import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
  ja: {
    // HomePage
    bannerTitle: '安全で信頼性の高いデジタル社会の実現に向けて、未来を築く',
    bannerSubtitle: 'Building the future toward the realization of a safe and reliable digital society',
    ourServices: '事業',
    pickUp: 'ピックアップ',

    // Navigation Buttons
    greeting: 'GREETING<br>代表挨拶',
    vision: 'VISION<br>経営理念・ビジョン',
    companyProfile: 'COMPANY PROFILE<br>会社概要',
    welfare: 'WELFARE<br>福利厚生',
    target: 'TARGET<br>経営目標',
    history: 'HISTORY<br>沿革',
    // NavBar
    achievementsNavBar: '開発実績',
    companyNavBar: 'すべての企業情報',
    visionNavBar: '経営理念・ビジョン',
    companyProfileNavBar: '会社概要',
    welfareNavBar: '福利厚生',
    targetNavBar: '経営目標',
    historyNavBar: '沿革',
    solution: 'すべての事業内容',
    itsolution: 'IT事業',
    t1solution: '登録支援機関',
    t2solution: '有料職業紹介',
    right: '   ',
    ses: 'SES事業',
    appDev: 'アプリ開発',
    develop: '開発実績',
    skill: '保有スキル',
    dispatch: 'その他業種への人材支援',

    // Footer
    companyNameFooter: '株式会社<br />GrowthSoft',
    address: '〒102-0072<br />東京都千代田区飯田橋1-7-10<br />山京ビル本館7F',
    phone: '電話: 03-6265-4936',
    email: 'メール: info@growthsoft.co.jp',
    links: 'リンク',
    home: 'ホーム',
    companyInfo: '企業情報',
    solutions: '事業内容',
    recruitmentInfo: '採用情報',
    contact: 'お問い合わせ',
    copyright: 'Copyright © 2024. 株式会社GrowthSoft. All rights reserved.',

    // Greeting Section
    greetingTitle: 'ごあいさつ',
    greetingMission: '<strong>使命と目標</strong><br><br>私たちグロースソフトは、お客様のビジネス成功を最優先に考え、革新的なITソリューションを提供することを使命としています。幅広い業界で培った経験と専門知識を活かし、最適なソリューションを提供するために全力を尽くしています。',
    greetingService: '<strong>サービスの柔軟性と信頼関係</strong><br><br>お客様のニーズに応じた柔軟で効果的なサービスを提供し、常にお客様の期待を超える成果を実現することを目指しています。先進技術の導入と持続的な改善を通じて、信頼関係を築くことを大切にしています。',
    greetingEmployee: '<strong>社員の成長と貢献</strong><br><br>私たちの成功は、社員一人ひとりの成長と貢献によって支えられています。社員が自身の能力を最大限に発揮できる環境を整え、共に成長し続けることで、組織全体の発展を目指しています。尊重と協力の精神を持ち、チーム一丸となってお客様の成功に寄与します。',
    greetingFuture: '<strong>未来への挑戦と価値創造</strong><br><br>技術の進歩が日々進む中で、私たちは絶えず挑戦し、新たな価値を創造することに努めています。お客様と共に歩み、新しい未来を切り拓いていくことをお約束します。皆様からのご支援とご愛顧を賜りますよう、心よりお願い申し上げます。',
    map: 'アクセス',
    mapcontext: '株式会社GrowthSoft<br />〒102-0072<br />東京都千代田区飯田橋1-7-10 山京ビル本館7F<br />電話: 03-6265-4936<br />メール: info@growthsoft.co.jp<br /><br />最寄交通機関からのアクセス<br />[東西線]<br />九段下駅7番出口から徒歩5分<br />[新宿線・半蔵門線]<br />九段下駅3a出口から徒歩6分<br />[東西線・南北線・大江戸線・有楽町線]<br />飯田橋駅Ａ４出口から徒歩5分<br />[JR総武線]<br />JR飯田橋駅東口 から徒歩6分',
    maplinks: 'Google Mapでみる',
    mapcompanyName: '株式会社GrowthSoft',
    mapaddress: '〒102-0072 <br />東京都千代田区飯田橋1-7-10 山京ビル本館7F',
    mapphone: '電話: 03-6265-4936',
    mapemail: 'メール: info@growthsoft.co.jp',
    mapcontextTitle: '<br />最寄交通機関からのアクセス',
    mapcontext1: '<br />[東西線] <br />九段下駅7番出口から徒歩5分',
    mapcontext2: '<br />[新宿線・半蔵門線] <br />九段下駅3a出口から徒歩6分',
    mapcontext3: '<br />[東西線・南北線・大江戸線・有楽町線] <br />飯田橋駅Ａ４出口から徒歩5分',
    mapcontext4: '<br />[JR総武線] <br />JR飯田橋駅東口 から徒歩6分',
    ceoName: '王 強',
    // Vision Section
    visionTitle: '経営理念・ビジョン',
    visionMission: '<strong>使命と目標</strong><br><br>私たちの経営理念は、お客様、社員、そして社会全体に対して、お互いに尊重し合いながら成長し、幸福な生活を実現することです。私たちは常に高い倫理基準を持ち、信頼を築き上げることで、持続可能な社会の発展に貢献します。',
    visionService: '<strong>サービスの柔軟性と信頼関係</strong><br><br>お客様に対しては、優れた技術とサービスを提供し、その期待を超えるソリューションを提案します。社員に対しては、成長の機会と働きやすい環境を提供し、それぞれのキャリアパスを尊重します。社会に対しては、環境保護と地域社会への貢献を重視し、持続可能なビジネスを展開します。',
    visionEmployee: '<strong>社員の成長と貢献</strong><br><br>私たちは、お互いに尊重し合いながら共に成長し、幸福な生活に向けて努力を惜しみません。このビジョンを実現するために、私たちは日々の業務において誠実さと情熱を持って取り組んでまいります。',
    // Company Profile Section
    companyProfileTitle: '会社概要',
    companyNameLabel: '会社名',
    companyName: '株式会社GrowthSoft（グロースソフト）',
    capitalLabel: '資本金',
    capital: '15,000,000円',
    ceoLabel: '代表者',
    foundedLabel: '設立',
    founded: '2023年9月4日',
    employeesLabel: '従業員数',
    employees: '22名',
    headquartersLabel: '本社',
    headquarters: '〒102-0072 東京都千代田区飯田橋1丁目7番10号 山京ビル本館7階',
    phoneLabel: '電話',
    phone: '03-6265-4936',
    banks: '取引銀行',
    bank1: '三井住友銀行',
    bank2: 'GMOあおぞらネット銀行',
    qualifications: '資格',
    qualification1: '適格請求書　T8013301051315',
    qualification2: '登録支援機関　24登-010800',
    qualification3: '有料職業紹介　13-ユ-317559',
    qualification4: '労働者派遣　（派）13-318368',
    // Welfare Section
    welfareTitle: '福利厚生',
    insurance: '保険',
    insuranceDetails: '健康保険、厚生年金、雇用保険、労災保険',
    vacation: '休暇',
    vacationDetails: '産休、育児休業、介護休業制度、フレックスタイム制度、短時間勤務制度（妊娠・育児・介護）',
    allowances: '手当',
    allowancesDetails: '通勤手当、家族手当、児童手当、資格取得補助',
    // History Section
    HistoryTitle: '沿革',
    Historyyear1:'2023年9月4日',
    Historyevent1:'・株式会社GrowthSoftを設立',
    Historyyear2:'2024年4月15日',
    Historyevent2:'・業務拡大により、千代田区飯田橋に本社を移転<br>・資本金を500万円に増資',
    Historyyear3:'2024年6月1日',
    Historyevent3:'・適格請求書発行事業者登録',
    Historyyear4:'2024年8月31日',
    Historyevent4:'・売上高が3,500万円達成',
    Historyyear5:'2024年10月10日',
    Historyevent5:'・登録支援機関登録',
    Historyyear6:'2025年1月1日',
    Historyevent6:'・有料職業紹介事業許可証を取得',
    Historyyear7:'2025年7月3日',
    Historyevent7:'・資本金を1,500万円に増資',
    Historyyear8:'2025年8月31日',
    Historyevent8:'・売上高が8,750万円達成',
    Historyyear9:'2026年1月1日',
    Historyevent9:'・労働者派遣事業許可証を取得',
    // Target Section
    TargetMainTitle: '経営目標',
    TargetTitle: '売上高中長期計画',
    Targetyear:'1年目　3,000万円<br>2年目　7,000万円<br>3年目　11,000万円',
    Targetyear1:'1年目　3,000万円',
    Targetyear2:'2年目　7,000万円',
    Targetyear3:'3年目　11,000万円',

    // Other
    blank: '',
    line: '-',
    joinus: 'join us',
    mapTitle: 'MAP',
    home1: 'HOME',
    companyInfo1: 'Company',
    solutions1: 'Business',
    recruitmentInfo1: 'Recruit',
    contact1: 'Contact',
    language1: 'Language',
    language: '言語選択',
    languages: {
      ja: '日本語',
      zh: '中文',
      en: 'English',
      ko: '한국어',
      vi: 'Tiếng Việt',
    },

    recruitment: {
      bannerTitle: 'お互いに尊重しながら、幸福な生活に向けて成長して行こう',
      bannerSubtitle: 'Let\'s respect each other and strive towards a happy life',
      bannerButton: '詳細を見る',
      title: '採用情報',
      description: 'グロースソフトでは、下記の職種でエントリーを受け付けています。<br>募集内容の詳細については職種名をクリックしてご覧ください。',
      applyButton: '応募する',
      newGraduate: '新卒採用',
      careerRecruitment: '中途採用',
      seconedGraduate: '第二新卒',
      job1: {
        title: '新卒採用',
        details: [
          {
            title: '応募条件',
            content: [
              {
                label: '必須条件',
                value: `
                  <li>大学以上の学歴（専門学校の場合はIT関連専攻）</li>
                  <li>良好な性格とコミュニケーション能力</li>
                  <li>チームで協力して仕事ができる能力</li>
                `
              }
            ]
          },
          {
            title: '待遇',
            content: [
              {
                label: '想定年収',
                value: '300万円～400万円<br>※能力により優遇'
              },
              {
                label: '',
                value: `
                  <li>諸条件を考慮の上、当社規定によって決定</li>
                  <li>試用期間: あり (3ヶ月、労働条件の変更なし)</li>
                  <li>昇給: 年1回</li>
                  <li>賞与: 年2回 (決算賞与を支給する場合あり)</li>
                `
              },
              {
                label: '休日休暇',
                value: `
                  <li>完全週休2日制（土日祝）</li>
                  <li>有給休暇（入社時より付与・初年度10日間）</li>
                  <li>年末年始休暇</li>
                  <li>慶弔休暇</li>
                  <li>産前・産後休暇</li>
                  <li>育児休暇</li>
                  <li>結婚休暇</li>
                  <li>介護休暇</li>
                `
              },
              {
                label: '資格取得奨励制度',
                value: `
                  受験料支給、合格報奨金は難易度によって、5千円～10万円支給<br><br>
                  【例】
                  <li>プロジェクトマネージャ試験　8万円</li>
                  <li>応用情報技術者試験　3万円</li>
                  <li>基本情報技術者試験　1万円</li>
                  <li>AWS Certified FOUNDATIONAL　1.5万円</li>
                  <li>AWS Certified ASSOCIATE　3万円</li>
                  <li>AWS Certified PROFESSIONAL　5万円</li>
                  <li>AWS Certified SPECIALTY　5万円</li>
                  <li>ITパスポート　5千円</li>
                  <li>TOEIC　2～8万円</li>
                  <li>他ベンダー資格も広く対象(Cisco、Azure、GCP、Oracle、SAP等)</li>
                `
              }
            ]
          },
          {
            title: '勤務時間',
            content: '※プロジェクトにより、勤務時間が変わることがあります'
          },
          {
            title: '勤務地',
            content: '東京/神奈川/千葉/埼玉'
          }
        ]
      },
      job2: {
        title: '中途採用',
        details: [
          {
            title: '職務内容',
            content: '当社のお客さま（事業会社、メーカー系SIer、ユーザー系SIer等）の開発現場で、システムエンジニア（要件定義、基本設計、詳細設計、開発、テスト、保守）としてシステム開発業務に従事していただきます。'
          },
          {
            title: '応募条件',
            content: [
              {
                label: '必須条件',
                value: `
                  <li>システム開発の経験を1年以上お持ちの方</li>
                  <li>プログラミング経験があり、Java、Python、C++などの言語に精通している方</li>
                `
              },
              {
                label: '望ましい経験・スキル',
                value: `
                  <li>過去にシステムの運用保守の経験があり、直近開発の経験をお持ちの方</li>
                  <li>上流工程でのPM、PLの経験や新人教育の経験者</li>
                  <li>Webアプリケーションやモバイルアプリケーションの開発経験者</li>
                  <li>データベース設計・管理の経験者</li>
                `
              }
            ]
          },
          {
            title: '待遇',
            content: [
              {
                label: '想定年収',
                value: '500万円～1000万円<br>※経験により優遇'
              },
              {
                label: '',
                value: `
                  <li>能力・経験・年齢等を考慮の上、当社規定によって決定</li>
                  <li>試用期間: あり (3ヶ月、労働条件の変更なし)</li>
                  <li>昇給: 年1回</li>
                  <li>賞与: 年2回 (決算賞与を支給する場合あり)</li>
                `
              },
              {
                label: '休日休暇',
                value: `
                  <li>完全週休2日制（土日祝）</li>
                  <li>有給休暇（入社時より付与・初年度10日間）</li>
                  <li>年末年始休暇</li>
                  <li>慶弔休暇</li>
                  <li>産前・産後休暇</li>
                  <li>育児休暇</li>
                  <li>結婚休暇</li>
                  <li>介護休暇</li>
                `
              },
              {
                label: '資格取得奨励制度',
                value: `
                  受験料支給、合格報奨金は難易度によって、5千円～10万円支給<br><br>
                  【例】
                  <li>プロジェクトマネージャ試験　8万円</li>
                  <li>応用情報技術者試験　3万円</li>
                  <li>基本情報技術者試験　1万円</li>
                  <li>AWS Certified FOUNDATIONAL　1.5万円</li>
                  <li>AWS Certified ASSOCIATE　3万円</li>
                  <li>AWS Certified PROFESSIONAL　5万円</li>
                  <li>AWS Certified SPECIALTY　5万円</li>
                  <li>ITパスポート　5千円</li>
                  <li>TOEIC　2～8万円</li>
                  <li>他ベンダー資格も広く対象(Cisco、Azure、GCP、Oracle、SAP等)</li>
                `
              }
            ]
          },
          {
            title: '勤務時間',
            content: '※プロジェクトにより、勤務時間が変わることがあります'
          },
          {
            title: '勤務地',
            content: '東京/神奈川/千葉/埼玉'
          }
        ]
      },
      job3: {
        title: '第二新卒',
        details: [
          {
            title: '応募条件',
            content: [
              {
                label: '必須条件',
                value: `
                  <li>大学以上の学歴（専門学校の場合はIT関連専攻）</li>
                  <li>良好な性格とコミュニケーション能力</li>
                  <li>チームで協力して仕事ができる能力</li>
                `
              }
            ]
          },
          {
            title: '待遇',
            content: [
              {
                label: '想定年収',
                value: '300万円～400万円<br>※能力により優遇'
              },
              {
                label: '',
                value: `
                  <li>諸条件を考慮の上、当社規定によって決定</li>
                  <li>試用期間: あり (3ヶ月、労働条件の変更なし)</li>
                  <li>昇給: 年1回</li>
                  <li>賞与: 年2回 (決算賞与を支給する場合あり)</li>
                `
              },
              {
                label: '休日休暇',
                value: `
                  <li>完全週休2日制（土日祝）</li>
                  <li>有給休暇（入社時より付与・初年度10日間）</li>
                  <li>年末年始休暇</li>
                  <li>慶弔休暇</li>
                  <li>産前・産後休暇</li>
                  <li>育児休暇</li>
                  <li>結婚休暇</li>
                  <li>介護休暇</li>
                `
              },
              {
                label: '資格取得奨励制度',
                value: `
                  受験料支給、合格報奨金は難易度によって、5千円～10万円支給<br><br>
                  【例】
                  <li>プロジェクトマネージャ試験　8万円</li>
                  <li>応用情報技術者試験　3万円</li>
                  <li>基本情報技術者試験　1万円</li>
                  <li>AWS Certified FOUNDATIONAL　1.5万円</li>
                  <li>AWS Certified ASSOCIATE　3万円</li>
                  <li>AWS Certified PROFESSIONAL　5万円</li>
                  <li>AWS Certified SPECIALTY　5万円</li>
                  <li>ITパスポート　5千円</li>
                  <li>TOEIC　2～8万円</li>
                  <li>他ベンダー資格も広く対象(Cisco、Azure、GCP、Oracle、SAP等)</li>
                `
              }
            ]
          },
          {
            title: '勤務時間',
            content: '※プロジェクトにより、勤務時間が変わることがあります'
          },
          {
            title: '勤務地',
            content: '東京/神奈川/千葉/埼玉'
          }
        ]
      },
      job4: {
        title: 'その他業種への人材支援',
        details: [
          {
            title: '応募条件',
            content: [
              {
                label: '必須条件',
                value: `
                  <li>良好な性格と強いコミュニケーション能力</li>
                  <li>チームで協力して仕事ができる能力</li>
                  <li>迅速かつ正確に業務を遂行できる能力</li>
                  <li>新しい環境に適応できる柔軟性</li>
                `
              }
            ]
          },
          {
            title: '待遇',
            content: [
              {
                label: '想定年収',
                value: '280万円～450万円<br>※経験により優遇'
              },
              {
                label: '',
                value: `
                  <li>能力・経験・年齢等を考慮の上、当社規定によって決定</li>
                  <li>試用期間: あり (3ヶ月、労働条件の変更なし)</li>
                  <li>昇給: 年1回</li>
                  <li>賞与: 年2回 (決算賞与を支給する場合あり)</li>
                `
              }
            ]
          },
          {
            title: '勤務地',
            content: '東京/神奈川/千葉/埼玉'
          }
        ]
      }
    },
    contactUs: {
      title: 'お問い合わせ',
      inquiryType: 'お問い合わせ種別',
      name: 'お名前',
      lastName: '姓',
      firstName: '名',
      companyName: '会社名・団体名',
      departmentName: '部署名',
      email: 'メールアドレス',
      phone: '電話番号',
      message: 'お問い合わせ内容',
      submitButton: '送信',
      required: '必須',
      optional: '任意',
      select: '選択してください',
      newGraduate: '新卒採用',
      careerRecruitment: '中途採用',
      seconedGraduate: '第二新卒',
      serviceInquiry: 'サービス・企業に関するお問い合わせ',
      other: 'その他',
      validationMessage: 'このフィールドを入力してください。',
      successMessage: 'メッセージが送信されました！',
      errorMessage: 'メッセージの送信に失敗しました。もう一度お試しください。'
    },
    solutionInfo: {
      title: 'IT事業',
      overview: '概要',
      technicalFields: '技術分野',
      services: 'サービス内容',
      ses: {
        title: 'SES事業',
        description: '当社では、SES（システムエンジニアリングサービス）事業を軸に、システム開発から運用・保守まで、一貫したサービスを提供しています。当社にはプロジェクトの開発段階から移行、そして保守・運用に至るまで、幅広いニーズに対応可能です。',
        description1: 'また、当社には優秀な外国籍エンジニアが多数在籍しており、質が高くコストパフォーマンスの良いサービスを提供しています。お見積もお気軽にご相談ください。',
        frontend: 'フロントエンド',
        languages: '開発言語',
        database: 'データベース',
        frontendContent: 'Vue.js、React.js、Angular.js等',
        languagesContent: 'Java、C、C++、C#、JavaScript、TypeScript、VB.NET、ASP.NET、COBOL、PHP等',
        databaseContent: 'Oracle、MySQL、PostgreSQL、SQLserver、MongoDB等'
      },
      appDev: {
        title: 'アプリ開発',
        description: 'アプリ開発事業では、スマートフォンアプリやウェブアプリの企画・開発・運用を行っています。最新技術を駆使し、ユーザーにとって使いやすいアプリを提供します。',
        services: '要件定義、デザイン、開発、テスト、リリースまで、一貫したサポートを提供します。お客様のビジネスモデルに最適なアプリケーションを開発し、競争力を高めます。'
      },
      skill: {
        title: '保有スキル',
        description: '当社チームは多様な技術領域に対応できる高い適応性と柔軟性を兼ね備えており、幅広い業界様のご要望に沿った最適なソリューションを提案させていただきます。',
        description1: '複雑なビジネス課題に対しましては、イノベーティブかつ実践的なアプローチで問題解決を図ります。証券・銀行・保険業界などいろいろな分野で、豊富なプロジェクト実績がございます。',
        description2: 'これまでの知見を活かし、お客様の具体的なご要望に迅速かつ最適な形でご対応いたします。今後とも継続的に技術力の向上に努めています。',
        environment: '開発環境',
        languages: '開発言語',
        database: 'データベース',
        environmentContent: 'Windows、Linux等',
        languagesContent: 'Java、C、C++、C#、JavaScript、TypeScript、VB.NET、ASP.NET、COBOL、PHP等',
        databaseContent: 'Oracle、MySQL、PostgreSQL、SQLserver、MongoDB等'
      },
      develop: {
        title: '開発実績',
        Webtitle: 'Web系',
        WebNameLabel1: '在庫管理システム',
        WebNameLabel2: '商品管理システム',
        WebNameLabel3: '顧客管理システム',
        WebNameLabel4: '生産管理システム',
        WebNameLabel5: 'ATM連携システム',
        WebNameLabel6: '物流システム',
        WebNameLabel7: '基盤システム',
        apptitle: 'アプリ',
        appNameLabel1: 'iOS',
        appNameLabel2: 'Android',
        packagetitle: 'パッケージ導入対応',
        packageNameLabel1: 'SAP',
        packageNameLabel2: 'Salesforce',
      },
      dispatch: {
        title: 'その他業種への人材支援サービス',
        description: 'その他業種への人材支援サービスは、多様な業種の企業に対して、必要なスキルと経験を持つ優秀な人材を提供します。私たちはお客様のビジネスニーズに合わせて、迅速かつ確実に最適な人材をマッチングします。業種例として、ホテル、工場、飲食店などがあります。',
        services: '人材の募集・選考から勤務開始後のフォローアップまで、一貫したサービスを提供します。お客様のビジネスニーズに基づき、適切な人材を提供することで、お客様のビジネス成功をサポートします。'
      },
      t2solution: {
        title: '有料職業紹介',
        work01: 'IT求人（自社 / 他社）',
        description01: 'Web開発 / AWS / ITインフラ / 中日企業のIT職種紹介',
        work02: '日本のさまざまな職種紹介',
        description02: '事務 / 翻訳 / 貿易 / 営業 / 販売',
        work03: '留学申請 / 進学サポート',
        description03: '日本語学校申請 / 大学・大学院進学相談',
        work04: '特定技能ビザ',
        description04: '外食（飲食業） / 食品加工',
        
      },
      t1solution: {
        title: '​登録支援機関',
        work0: '資料作成支援',
        work001: '支援計画書作成',
        description001: '当社のサービスでは、お得意先会社様が特定技能の外国人を採用する際、仕事と生活に必要な支援計画をご提案・作成します。さらなる詳細につきましては、お気軽にお問い合わせ下さいませ。',
        work002: '在留資格変更手続き作成',
        description002: '在留資格変更手続き資料を提供し、行政書士のの指導の下で、在留資格変更手続きを作成し、各地域の在留入国管理局へ提出・取次するサービスを御提供致します。',
        work1: '介護',
        description1a: '<strong>〈 分野、区分の概要 〉</strong><br> 高齢や障害で、生活をする時に介護が必要になった人たちへの身体介護等（介護を受ける人の状況にあわせて入浴、食事、排せつを助けること等）のほか、身体介護等に関係して助けが必要なしごと（レクリエーションの実施、リハビリテーションの補助等）<br>  ※介護を受ける人たちの家でするものは対象ではありません。',
        description1b: '<strong>〈 従事する主な業務 〉</strong><br> ・身体介護等（介護を受ける人の状況にあわせて入浴、食事、排せつを助けること等）<br> ・身体介護等に関係して助けが必要なしごと（レクリエーションの実施、リハビリテーションの補助等） ',
        description1c: '<strong>〈 想定される関連業務 〉</strong><br> 例：お知らせ等の掲示物の管理、物品の補充や管理',
        work2: 'ビルクリーニング',
        description2a: '<strong>〈 分野、区分の概要 〉</strong><br> 建築物内部の清掃',
        description2b: '<strong>〈 従事する主な業務 〉</strong><br> 多数の利用者が利用する建築物（住宅を除く。）の内部を対象に、衛生的環境の保護、美観の維持、安全の確保及び保全の向上を目的として、場所、部位、建材、汚れ等の違いに対し、方法、洗剤及び用具を適切に選択して清掃作業を行い、建築物に存在する環境上の物質を排除し、清潔さを維持する業務<br> ※床、浴室、トイレ、洗面台等の清掃からアメニティ補充やベッドメイク作業など、衛生かつ美観が整えられた客室を商品として納品するために必要な一連の業務である客室清掃業務は主な業務に含まれる。',
        description2c: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・複数の作業員の指導、現場の管理、計画作成や進行管理等<br>・清掃用機械器具の維持管理等に関する業務、技能実習責任者の業務、技能実習指導員の業務や、生活指導員の業務（それぞれ主たる業務に該当するものを除く。）<br>・建築物と構造上一体と見なせる部分（犬走・アプローチ等の外周部など）の清掃作業<br>・資機材倉庫の整備作業<br>・建物外部洗浄作業(外壁、屋上等。ただし高所作業を伴う窓ガラス・外壁清掃作業は除く。）<br>・ベッドメイク作業<br>・建築物内外の植裁管理作業（灌水作業等）<br>・資機材の運搬作業（他の現場に移動する場合等）',
        description2d: '<strong>〈 その他特記事項 〉</strong><br> ・詳細は以下の「ビルクリーニング分野特定技能外国人が従事できる業務について（令和５年 10 月 17 日ビルクリーニング分野特定技能協議会決定第１号）」を参照すること。',
        work3: '工業製品製造業',
        description3a: '（機械金属加工区分）',
        description3aa: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、素形材製品や産業機械等の製造工程の作業に従事',
        description3ab: '<strong>〈 従事する主な業務 〉</strong><br> 鋳造 ／ 鍛造 ／ ダイカスト ／ 機械加工 ／ 金属プレス加工 ／ 鉄工 ／ 工場板金 ／ 仕上げ ／ プラスチック成形 ／ 機械検査 ／ 機械保全 ／ 電気機器組立て ／ 塗装 ／ 溶接 ／ 工業包装 ／強化プラスチック成形 ／ 金属熱処理業',
        description3ac: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3b: '（電気電子機器組立て区分）',
        description3ba: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、電気電子機器等の製造工程、組立工程の作業に従事',
        description3bb: '<strong>〈 従事する主な業務 〉</strong><br> 機械加工 ／ 仕上げ ／ プラスチック成形 ／ プリント配線板製造 ／ 電子機器組立て ／ 電気機器組立て ／ 機械検査 ／ 機械保全 ／ 工業包装 ／強化プラスチック成形',
        description3bc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3c: '（金属表面処理区分）',
        description3ca: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、表面処理等の作業に従事',
        description3cb: '<strong>〈 従事する主な業務 〉</strong><br> めっき ／ アルミニウム陽極酸化処理',
        description3cc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3d: '（紙器・段ボール箱製造区分）',
        description3da: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、紙器・段ボール箱の製造工程の作業に従事',
        description3db: '<strong>〈 従事する主な業務 〉</strong><br> 紙器・段ボール箱製造',
        description3dc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3e: '（コンクリート製品製造区分）',
        description3ea: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、コンクリート製品の製造工程の作業に従事',
        description3eb: '<strong>〈 従事する主な業務 〉</strong><br> コンクリート製品製造 ',
        description3ec: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3f: '（RPF製造区分）',
        description3fa: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、破砕・成形等の作業に従事　',
        description3fb: '<strong>〈 従事する主な業務 〉</strong><br> ＲＰＦ製造',
        description3fc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3g: '（陶磁器製品製造区分）',
        description3ga: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、陶磁器製品の製造工程の作業に従事',
        description3gb: '<strong>〈 従事する主な業務 〉</strong><br> 陶磁器工業製品製造',
        description3gc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3h: '（印刷・製本区分）',
        description3ha: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、オフセット印刷、グラビア印刷、製本の製造工程の作業に従事 ',
        description3hb: '<strong>〈 従事する主な業務 〉</strong><br> 印刷 ／ 製本',
        description3hc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3i: '（紡織製品製造区分）',
        description3ia: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、紡織製品の製造工程の作業に従事',
        description3ib: '<strong>〈 従事する主な業務 〉</strong><br> 紡績運転 ／ 織布運転 ／ 染色 ／ ニット製品製造 ／ たて編ニット生地製造 ／カーペット製造 ',
        description3ic: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3j: '（縫製区分）',
        description3ja: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、縫製工程の作業に従事',
        description3jb: '<strong>〈 従事する主な業務 〉</strong><br> 婦人子供服製造 ／ 紳士服製造 ／ 下着類製造 ／ 寝具製作 ／ 帆布製品製造 ／布はく縫製 ／ 座席シート縫製',
        description3jc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        work4: '建設',
        description4a: '（土木区分）',
        description4aa: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示・監督を受けながら、土木施設の新設、改築、維持、修繕に係る作業等に従事',
        description4ab: '<strong>〈 従事する主な業務 〉</strong><br> 型枠施工 ／ コンクリート圧送 ／ トンネル推進工 ／ 建設機械施工 ／ 土工 ／ 鉄筋施工 ／ とび ／ 海洋土木工<br> その他、土木施設の新設、改築、維持、修繕に係る作業',
        description4ac: '<strong>〈 想定される関連業務 〉</strong><br>・原材料・部品の調達・搬送<br>・機器・装置・工具等の保守管理<br>・足場の組立て、設備の掘り起こしその他の後工程の準備作業<br>・足場の解体、設備の埋め戻しその他の前工程の片付け作業<br>・清掃・保守管理作業<br>・その他、主たる業務に付随して行う作業',
        description4ad: '<strong>〈 その他特記事項 〉</strong><br> 業務の詳細については、以下の国土交通省のウェブサイト中「◆業務区分と試験及び技能実習等との対応関係」の「業務区分と建設業許可工事業との対応関係」をご覧ください。',
        description4b: '（建築区分）',
        description4ba: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示・監督を受けながら、建築物の新築、増築、改築若しくは移転又は修繕若しくは模様替に係る作業等に従事',
        description4bb: '<strong>〈 従事する主な業務 〉</strong><br> 型枠施工 ／ 左官 ／ コンクリート圧送 ／ 屋根ふき ／ 土工 ／ 鉄筋施工 ／ 鉄筋継手 ／ 内装仕上げ ／ 表装 ／ とび ／ 建築大工 ／ 建築板金 ／ 吹付ウレタン断熱<br>その他、建築物の新築、増築、改築若しくは移転、修繕又は模様替に係る作業',
        description4bc: '<strong>〈 想定される関連業務 〉</strong><br>・原材料・部品の調達・搬送<br>・機器・装置・工具等の保守管理<br>・足場の組立て、設備の掘り起こしその他の後工程の準備作業<br>・足場の解体、設備の埋め戻しその他の前工程の片付け作業<br>・清掃・保守管理作業<br>・その他、主たる業務に付随して行う作業',
        description4bd: '<strong>〈 その他特記事項 〉</strong><br> 業務の詳細については、以下の国土交通省のウェブサイト中「◆業務区分と試験及び技能実習等との対応関係」の「業務区分と建設業許可工事業との対応関係」をご覧ください。',
        description4c: '（ライフライン・設備区分）',
        description4ca: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示・監督を受けながら、電気通信、ガス、水道、電気その他のライフライン・設備の整備・設置、変更又は修理に係る作業等に従事',
        description4cb: '<strong>〈 従事する主な業務 〉</strong><br> 電気通信 ／ 配管 ／ 建築板金 ／ 保温保冷<br>その他、ライフライン・設備の整備・設置、変更又は修理に係る作業',
        description4cc: '<strong>〈 想定される関連業務 〉</strong>・原材料・部品の調達・搬送<br>・機器・装置・工具等の保守管理<br>・足場の組立て、設備の掘り起こしその他の後工程の準備作業<br>・足場の解体、設備の埋め戻しその他の前工程の片付け作業<br>・清掃・保守管理作業<br>・その他、主たる業務に付随して行う作業',
        description4cd: '<strong>〈 その他特記事項 〉</strong><br> 業務の詳細については、以下の国土交通省のウェブサイト中「◆業務区分と試験及び技能実習等との対応関係」の「業務区分と建設業許可工事業との対応関係」をご覧ください。',
        work5: '造船・舶用工業',
        description5a: '（造船区分）',
        description5aa: '<strong>〈 分野、区分の概要 〉</strong><br> 造船（監督者の指示を理解し又は自らの判断により船舶の製造工程の作業に従事）',
        description5ab: '<strong>〈 従事する主な業務 〉</strong><br> 溶接 ／ 塗装 ／ 鉄工 ／ とび ／ 配管 ／ 船舶加工',
        description5ac: '<strong>〈 想定される関連業務 〉</strong><br>・読図作業<br>・作業工程管理<br>・検査（外観、寸法、材質、強度、非破壊、耐圧気密等）<br>・機器・装置・工具の保守管理<br>・機器・装置・運搬機の運転<br>・資材の材料管理・配置<br>・部品・製品の養生<br>・足場の組立て・解体<br>・廃材処理<br>・梱包・出荷<br>・資材・部品・製品の運搬<br>・入出渠<br>・清掃',
        description5ad: '<strong>〈 その他特記事項 〉</strong><br> 業務の詳細については、以下の国土交通省のウェブサイトをご覧ください。',
        description5b: '（舶用機械区分）',
        description5ba: '<strong>〈 分野、区分の概要 〉</strong><br> 舶用機械（監督者の指示を理解し又は自らの判断により舶用機械の製造工程の作業に従事）',
        description5bb: '<strong>〈 従事する主な業務 〉</strong><br> 溶接 ／ 塗装 ／ 鉄工 ／ 仕上げ ／ 機械加工 ／ 配管 ／ 鋳造 ／ 金属プレス加工 ／強化プラスチック成形 ／ 機械保全 ／ 船用機械加工',
        description5bc: '<strong>〈 想定される関連業務 〉</strong><br>・読図作業<br>・作業工程管理<br>・検査（外観、寸法、材質、強度、非破壊、耐圧気密等）<br>・機器・装置・工具の保守管理<br>・機器・装置・運搬機の運転<br>・資材の材料管理・配置<br>・部品・製品の養生<br>・足場の組立て・解体<br>・廃材処理<br>・梱包・出荷<br>・資材・部品・製品の運搬<br>・入出渠<br>・清掃',
        description5bd: '<strong>〈 その他特記事項 〉</strong><br> 業務の詳細については、以下の国土交通省のウェブサイトをご覧ください。',
        description5c: '（舶用電気電子機器区分）',
        description5ca: '<strong>〈 分野、区分の概要 〉</strong><br> 舶用電気電子機器（監督者の指示を理解し又は自らの判断により舶用電気電子機器の製造工程の作業に従事）',
        description5cb: '<strong>〈 従事する主な業務 〉</strong><br> 機械加工 ／ 電気機器組立て ／ 金属プレス加工 ／ 電子機器組み立て ／プリント配線板製造 ／ 配管 ／ 機器保全 ／ 船用電気電子機器加工　',
        description5cc: '<strong>〈 想定される関連業務 〉</strong><br>・読図作業<br>・作業工程管理<br>・検査（外観、寸法、材質、強度、非破壊、耐圧気密等）<br>・機器・装置・工具の保守管理<br>・機器・装置・運搬機の運転<br>・資材の材料管理・配置<br>・部品・製品の養生<br>・足場の組立て・解体<br>・廃材処理<br>・梱包・出荷<br>・資材・部品・製品の運搬<br>・入出渠<br>・清掃',
        description5cd: '<strong>〈 その他特記事項 〉</strong><br> 業務の詳細については、以下の国土交通省のウェブサイトをご覧ください。',
        work6: '自動車整備',
        description6a: '<strong>〈 分野、区分の概要 〉</strong><br> 自動車の日常点検整備、定期点検整備、特定整備、特定整備に付随する業務',
        description6b: '<strong>〈 従事する主な業務 〉</strong><br> 自動車の日常点検整備、定期点検整備、特定整備、特定整備に付随する業務（電子制御装置の整備や鈑金塗装など）の基礎的な業務',
        description6c: '<strong>〈 想定される関連業務 〉</strong><br>・整備内容の説明及び関連部品の販売<br>・部品番号検索・部内発注作業<br>・ナビ・ＥＴＣ等の電装品の取付作業<br>・洗車作業<br>・下廻り塗装作業<br>・車内清掃作業<br>・構内清掃作業<br>・部品等運搬作業<br>・設備機器等清掃作業',
        work7: '航空',
        description7a: '（空港グランドハンドリング区分）',
        description7aa: '<strong>〈 分野、区分の概要 〉</strong><br> 航空機の地上走行支援業務、手荷物・貨物取扱業務等',
        description7ab: '<strong>〈 従事する主な業務 〉</strong><br> 指導者やチームリーダーの下に行う<br>・航空機地上走行支援業務<br>・手荷物・貨物取扱業務<br>・手荷物・貨物の航空機搭降載業務<br>・航空機内外の清掃整備業務',
        description7ac: '<strong>〈 想定される関連業務 〉</strong><br>・事務作業<br>・作業場所の整理整頓や清掃<br>・積雪時における作業場所の除雪',
        description7b: '（航空機整備区分）',
        description7ba: '<strong>〈 分野、区分の概要 〉</strong><br> 航空機の機体、装備品等の整備業務等',
        description7bb: '<strong>〈 従事する主な業務 〉</strong><br> 国家資格整備士等の指導・監督の下、機体や装備品等の整備業務のうち基礎的な作業（簡単な点検や交換作業等）<br>・運航整備（空港に到着した航空機に対して、次のフライトまでの間に行う整備）<br>・機体整備（通常1～1年半毎に実施する、約1～2週間にわたり機体の隅々まで行う整備）<br>・装備品・原動機整備（航空機から取り下ろされた脚部や動翼、 飛行・操縦に用いられる計器類等及びエンジンの整備）',
        description7bc: '<strong>〈 想定される関連業務 〉</strong><br>・事務作業<br>・作業場所の整理整頓や清掃<br>・積雪時における作業場所の除雪',
        work8: '宿泊',
        description8a: '<strong>〈 分野、区分の概要 〉</strong><br> 旅館やホテルにおけるフロント、企画・広報、接客及びレストランサービス等の宿泊サービスの提供業務',
        description8b: '<strong>〈 従事する主な業務 〉</strong><br> ・フロント業務（チェックイン/アウト、周辺の観光地情報の案内、ホテル発着ツアーの手配　等）<br>・企画・広報業務（キャンペーン・特別プランの立案、館内案内チラシの作成、HP、SNS等による情報発信　等）<br>・接客業務（旅館やホテル内での案内、宿泊客からの問い合わせ対応 等）<br>・レストランサービス業務（注文への応対やサービス（配膳・片付け）、料理の下ごしらえ・盛りつけ等の業務　等）',
        description8c: '<strong>〈 想定される関連業務 〉</strong><br> 旅館やホテル内における販売、備品の点検・交換等',
        work9: '自動車運送業',
        description9a: '（バス運転者区分）',
        description9aa: '<strong>〈 分野、区分の概要 〉</strong><br> 運行管理者等の指導・監督の下、一般乗合旅客自動車運送事業、一般貸切旅客自動車運送事業又は特定旅客自動車運送事業における運行前後の車両点検、安全な旅客の輸送、乗務記録の作成や乗客対応等に従事',
        description9ab: '<strong>〈 従事する主な業務 〉</strong><br> ・運行業務（運行前後の車両点検、安全な旅客の輸送、乗務記録の作成等）<br>・接遇業務（乗客対応等）',
        description9ac: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br>関連業務に当たり得るものとして、次が想定される。<br>・車内清掃作業<br>・営業所内清掃作業<br>・運賃精算、管理<br>・その他、主たる業務に付随して行う作業<br>※専ら関連業務に従事することは認められない。',
        description9b: '（タクシー運転者区分）',
        description9ba: '<strong>〈 分野、区分の概要 〉</strong><br> 運行管理者等の指導・監督の下、一般乗用旅客自動車運送事業における運行前後の車両点検、安全な旅客の輸送、乗務記録の作成や乗客対応等に従事',
        description9bb: '<strong>〈 従事する主な業務 〉</strong><br> ・運行業務（運行前後の車両点検、安全な旅客の輸送、乗務記録の作成等）<br>・接遇業務（乗客対応等）',
        description9bc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br>関連業務に当たり得るものとして、次が想定される。<br>・車内清掃作業<br>・営業所内清掃作業<br>・運賃精算、管理<br>・その他、主たる業務に付随して行う作業<br>※専ら関連業務に従事することは認められない。',
        description9c: '（トラック運転者区分）',
        description9ca: '<strong>〈 分野、区分の概要 〉</strong><br> 運行管理者等の指導・監督の下、貨物自動車運送事業における運行前後の車両点検、安全な貨物の輸送、乗務記録の作成や荷崩れを起こさない貨物の積付け等に従事',
        description9cb: '<strong>〈 従事する主な業務 〉</strong><br> ・運行業務（運行前後の車両点検、安全な旅客の輸送、乗務記録の作成等）<br>・接遇業務（乗客対応等）',
        description9cc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br>関連業務に当たり得るものとして、次が想定される。<br>・車内清掃作業<br>・営業所内清掃作業<br>・運賃精算、管理<br>・その他、主たる業務に付随して行う作業<br>※専ら関連業務に従事することは認められない。',
        work10: '鉄道',
        description10a: '（軌道整備区分）',
        description10aa: '<strong>〈 分野、区分の概要 〉</strong><br> 軌道整備（軌道等の新設、改良、修繕に係る作業・検査業務等）',
        description10ab: '<strong>〈 従事する主な業務 〉</strong><br> 以下を例とする軌道等の新設、改良、修繕に係る作業・検査業務が対象となる。<br>・軌道検測作業（高低、通り等軌道の変位を測定する作業）<br>・レール交換作業（新旧レール交換 ／ 付帯作業（吊り上げ作業等））<br>・まくらぎ交換作業（新旧まくらぎ交換 ／ 付帯作業（道床掘削作業等））<br>・バラストを取り扱う作業（バラスト掘削及び埋戻し ／ 道床形状の形成 ／ つき固めや通り整正に伴う作業等）<br>・保安設備を取り扱う作業等（脱線防止ガード等保安設備の取り付け（交換・撤去・復旧等） ／ 付帯作業（締結装置の緊張・緩解作業等））',
        description10ac: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・事務作業<br>・作業場所の整理整頓や清掃',
        description10b: '（電気設備整備区分）',
        description10ba: '<strong>〈 分野、区分の概要 〉</strong><br> 電気設備整備（電路設備、変電所等設備、電気機器等設備、信号保安設備、保安通信設備、踏切保安設備等の新設、改良、修繕に係る作業・検査業務等）',
        description10bb: '<strong>〈 従事する主な業務 〉</strong><br> 以下の設備の新設、改良、修繕に係る作業、検査業務等が対象となる。<br>・電路設備（電車線、送電線、配電線等）<br>・変電所等設備（遮断装置、変圧器、整流器、避雷器、保護装置、接地装置、消火設備等）<br>・電気機器等設備（配電盤、開閉器、電源装置、照明設備、電気掲示器、電気融雪器等）<br>・信号保安設備（信号装置、転てつ装置、連動装置、列車検知装置、自動列車停止装置等）<br>・保安通信設備（交換装置、搬送装置、無線装置、端末装置、通信線等）<br>・踏切保安設備（踏切遮断機、踏切警報機、踏切警報時間制御装置、踏切支障報知装置、障害物検知装置等）<br>※上記設備の支持物、ケーブル、管路、配線等を含む',
        description10bc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・事務作業<br>・作業場所の整理整頓や清掃',
        description10c: '（車両整備区分）',
        description10ca: '<strong>〈 分野、区分の概要 〉</strong><br> 車両整備（鉄道車両の整備業務等）',
        description10cb: '<strong>〈 従事する主な業務 〉</strong><br> 以下を例とする業務等が対象となる。<br>・列車検査、定期検査、臨時検査（空調装置、集電装置、走行装置、ブレーキ装置、空気装置、電気装置、動力発生装置、保安装置、車体、乗務員室・客室に関わる装置、連結装置等や車両部品の検査、修繕等（解ぎ装等作業や消耗品の補充を含む））<br>・構内入換（車両基地等での車両の入換や誘導等）<br>・駅派出対応（駅等における車両の検査・修繕等）<br>・改造工事（車両の改造や改良工事等）<br>・定期・臨時清掃業務（車両基地における車両の清掃等）<br>・在庫・予備品管理、工場設備取扱い<br>・上記に関する材料や部品、装置等の管理及び設備の操作・管理',
        description10cc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・事務作業<br>・作業場所の整理整頓や清掃',
        description10d: '（車両製造区分）',
        description10da: '<strong>〈 分野、区分の概要 〉</strong><br> 車両製造（鉄道車両、鉄道車両部品等の製造業務等）',
        description10db: '<strong>〈 従事する主な業務 〉</strong><br> 以下を例とする業務等が対象となる。<br>・素材加工（シートモケット加工 ／ 台車枠、構体部品加工等）<br>・部品組立て作業（輪軸（駆動装置）、配電盤等電気機器組立て ／ ドア、窓、ほろ、シート等内装設備品組立て等）<br>・構体組立て（台枠、屋根構体、側構体及び妻構体組立て ／ 構体（六面体）組立て等）<br>・塗装<br>・溶接<br>・ぎ装（機器取付け、配線、配管 ／ ドア、窓、天井、トイレ設備等内装部品取付け）<br>・台車枠製造<br>・台車組立て<br>・電子機器組立て（運転保安装置(ＡＴＣ装置やＡＴＳ装置)、制御装置、モニタ装置等の組立て）<br>・電気機器組立て（継電器等を使用した配電盤等の組立て）<br>・試験・検査（機能検査等）<br>・部品検収・配膳業務（倉庫管理及び部品等運搬等）',
        description10dc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・事務作業<br>・作業場所の整理整頓や清掃',
        description10e: '（運輸係員区分）',
        description10ea: '<strong>〈 分野、区分の概要 〉</strong><br> 運輸係員（駅係員、車掌、運転士等）',
        description10eb: '<strong>〈 従事する主な業務 〉</strong><br> 以下を例とする業務等が対象となる。<br>・ポイント操作（列車等の進路を決めるポイント操作、列車の進路に合わせた適正な鉄道信号の現示又は表示）<br>・入換え合図（列車等の転線、連結・分割等を行うための係員への合図）<br>・駅設備管理・取扱業務（駅の券売機・改札機等の管理、操作 ／ 設備故障時の一次修理対応）<br>・旅客案内・貨物取扱業務（通常時・異常時のホーム上安全確認や旅客案内 ／ 振替輸送時等の旅客案内 ／ 貨物の受付、一時留置場所・積載列車等の指定等）<br>・運行管理業務（列車ダイヤと列車運行の確認・管理 ／ 異常時における運休や増発の列車指定）<br>・車掌業務（列車内の旅客案内、運転士への合図 ／ 事故防止等に必要な安全確認 ／ 事故発生時の列車防護等による事故拡大防止等の対処を行う ／ 異常発生時等の避難誘導等）<br>・運転士業務（列車の運転には動力車操縦者運転免許要す）（列車等の運転（ワンマン列車運転の場合は車掌業務も兼任））',
        description10ec: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・事務作業<br>・作業場所の整理整頓や清掃',
        work11: '農業',
        description11a: '（耕種農業区分）',
        description11aa: '<strong>〈 分野、区分の概要 〉</strong><br> 栽培管理、農産物の集出荷・選別等の農作業',
        description11ab: '<strong>〈 従事する主な業務 〉</strong><br>・各作物に応じた土壌づくり<br>・施肥作業<br>・種子、苗木の取扱い<br>・資材、装置の取扱い<br>・栽培に関する作業<br>・安全衛生業務　等',
        description11ac: '<strong>〈 想定される関連業務 〉</strong><br>・特定技能所属機関（労働者派遣形態の場合は派遣先事業者）が生産した農畜産物を原料又は材料の一部として使用する製造又は加工の作業<br>・特定技能所属機関（労働者派遣形態の場合は派遣先事業者）による農畜産物の生産に伴う副産物（稲わら、家畜排泄物等）を原料又は材料の一部として使用する製造又は加工の作業<br>・農畜産物（特定技能所属機関（労働者派遣形態の場合は派遣先事業者）が生産した農畜産物が含まれる場合に限る。）の運搬、陳列又は販売の作業<br>・農畜産物を原料又は材料として製造され、又は加工された物（特定技能所属機関（労働者派遣形態の場合は派遣先事業者）が生産した農畜産物を原料又は材料の一部として使用し、製造され、又は加工された物が含まれる場合に限る。）の運搬、陳列又は販売の作業<br>・農畜産物の生産に伴う副産物を原料又は材料として製造され、又は加工された物（特定技能所属機関（労働者派遣形態の場合は派遣先事業者）による農畜産物の生産に伴う副産物を原料又は材料の一部として使用し、製造され、又は加工された物（たい肥等の肥料、飼料等）が含まれる場合に限る。）の運搬、陳列又は販売の作業<br>・その他特定技能所属機関（労働者派遣形態の場合は派遣先事業者）で耕種農業又は畜産農業の業務に従事する日本人が通常従事している作業（畜産農業と耕種農業を複合経営している特定技能所属機関（労働者派遣形態の場合は派遣先事業者）において畜産農業の技能を有する特定技能外国人が耕種農業の作業に従事する場合、冬場の除雪作業に従事する場合等）',
        description11b: '（畜産農業区分）',
        description11ba: '<strong>〈 分野、区分の概要 〉</strong><br> 飼養管理、畜産物の集出荷・選別等の農作業',
        description11bb: '<strong>〈 従事する主な業務 〉</strong><br>・各畜種に応じた器具の取扱い<br>・個体の取扱い、観察<br>・飼養管理<br>・生産物の取扱い<br>・安全衛生業務　等',
        description11bc: '<strong>〈 想定される関連業務 〉</strong><br>・特定技能所属機関（労働者派遣形態の場合は派遣先事業者）が生産した農畜産物を原料又は材料の一部として使用する製造又は加工の作業<br>・特定技能所属機関（労働者派遣形態の場合は派遣先事業者）による農畜産物の生産に伴う副産物（稲わら、家畜排泄物等）を原料又は材料の一部として使用する製造又は加工の作業<br>・農畜産物（特定技能所属機関（労働者派遣形態の場合は派遣先事業者）が生産した農畜産物が含まれる場合に限る。）の運搬、陳列又は販売の作業<br>・農畜産物を原料又は材料として製造され、又は加工された物（特定技能所属機関（労働者派遣形態の場合は派遣先事業者）が生産した農畜産物を原料又は材料の一部として使用し、製造され、又は加工された物が含まれる場合に限る。）の運搬、陳列又は販売の作業<br>・農畜産物の生産に伴う副産物を原料又は材料として製造され、又は加工された物（特定技能所属機関（労働者派遣形態の場合は派遣先事業者）による農畜産物の生産に伴う副産物を原料又は材料の一部として使用し、製造され、又は加工された物（たい肥等の肥料、飼料等）が含まれる場合に限る。）の運搬、陳列又は販売の作業<br>・その他特定技能所属機関（労働者派遣形態の場合は派遣先事業者）で耕種農業又は畜産農業の業務に従事する日本人が通常従事している作業（畜産農業と耕種農業を複合経営している特定技能所属機関（労働者派遣形態の場合は派遣先事業者）において畜産農業の技能を有する特定技能外国人が耕種農業の作業に従事する場合、冬場の除雪作業に従事する場合等）',
        work12: '漁業',
        description12a: '（漁業区分）',
        description12aa: '<strong>〈 分野、区分の概要 〉</strong><br> 漁具の製作・補修、水産動植物の探索、漁具・漁労機械の操作、水産動植物の採捕、漁獲物の処理・保蔵、安全衛生の確保等',
        description12ab: '<strong>〈 従事する主な業務 〉</strong><br>・釣りによる方法を主とした魚介類の捕獲(延縄漁、カツオ一本釣り漁、イカ釣り漁　等)<br>・網やカゴによる方法を主とした魚介類の捕獲(定置網漁、まき網漁、曳網漁　等)<br>・漁具（網、カゴ等）の修理作業<br>・ソナーや魚群探知機による魚群の探索<br>・漁に使用する網・縄を巻き上げる機械(ネット・ラインホーラー)、自動イカ釣り機等の機械操作<br>・漁獲物の選別、函詰め、冷凍作業、下処理<br>・漁港での漁獲物や漁具等の荷揚げ作業　等',
        description12ac: '<strong>〈 想定される関連業務 〉</strong><br>・漁具・漁労機械の点検・換装<br>・船体の補修・清掃<br>・魚倉、漁具保管庫、番屋の清掃<br>・漁船への餌、氷、燃油、食材、日用品その他の操業・生活資材の仕込み・積込み<br>・出漁に係る炊事・賄い<br>・採捕した水産動植物の生簀における畜養その他付随的な養殖<br>・自家生産物の運搬・陳列・販売<br>・自家生産物又は当該生産に伴う副産物を原料又は材料の一部として使用する製造・加工及び当該製造物・加工物の運搬・陳列・販売<br>・魚市場・陸揚港での漁獲物の選別・仕分け<br>・体験型漁業の際に乗客が行う水産動植物の採捕の補助<br>・社内外における研修',
        description12b: '（養殖業区分）',
        description12ba: '<strong>〈 分野、区分の概要 〉</strong><br> 養殖資材の製作・補修・管理、養殖水産動植物の育成管理、養殖水産動植物の収獲（穫）・処理、安全衛生の確保等',
        description12bb: '<strong>〈 従事する主な業務 〉</strong><br>・魚類や貝類、藻類などの育成<br>・養殖魚の給餌、死んだ魚や残餌等の除去<br>・養殖貝類の付着物の清掃<br>・養殖水産動植物の収獲（穫）、魚市場や陸揚港への運搬作業<br>・養殖貝類の殻剥き<br>・養殖池や網の清掃、水質等の管理<br>・養殖筏の製作、補修<br>・養殖水産動植物の種苗の生産、採捕　等',
        description12bc: '<strong>〈 想定される関連業務 〉</strong><br>・漁具・漁労機械の点検・換装<br>・船体の補修・清掃<br>・魚倉、漁具保管庫・番屋の清掃<br>・漁船への餌、氷、燃油、食材、日用品その他の操業・生活資材の仕込み・積込み<br>・養殖用の機械・設備・器工具等の清掃・消毒・管理・保守<br>・鳥獣に対する駆除、追払、防護ネット・テグス張り等の養殖場における食害防止<br>・養殖水産動植物の餌となる水産動植物や養殖用稚魚の採捕その他付随的な漁業<br>・自家生産物の運搬・陳列・販売<br>・自家生産物又は当該生産に伴う副産物を原料又は材料の一部として使用する製造・加工及び当該製造物・加工物の運搬・陳列・販売<br>・魚市場・陸揚港での漁獲物の選別・仕分け<br>・体験型漁業の際に乗客が行う水産動植物の採捕の補助<br>・社内外における研修',
        work13: '飲食料品製造業',
        description13a: '<strong>〈 分野、区分の概要 〉</strong><br> 飲食料品（酒類を除く。）の製造・加工、安全衛生の確保',
        description13b: '<strong>〈 従事する主な業務 〉</strong><br>・原料の処理、加熱、殺菌、成形、乾燥などの、生産に関わる一連の作業など<br>・業務で使う機械の安全確認や、作業者の衛生管理などの、業務上の安全衛生と食品衛生を守るための業務',
        description13c: '<strong>〈 想定される関連業務 〉</strong><br>・原料の調達・受入れ<br>・製品の納品<br>・清掃<br>・事業所の管理の作業',
        work14: '外食業',
        description14a: '<strong>〈 分野、区分の概要 〉</strong><br> 飲食物調理、接客、店舗管理',
        description14b: '<strong>〈 従事する主な業務 〉</strong><br>・飲食物調理（客に提供する飲食料品の調理、調製、製造を行うもの）<br> 例：食材仕込み、加熱調理、非加熱調理、調味、盛付け、飲食料品の調製等<br>・接客（客に飲食料品を提供するために必要な飲食物調理以外の業務を行うもの）<br> 例：席への案内、メニュー提案、注文伺い、配膳、下膳、カトラリーセッティング、代金受取り、商品セッティング、商品の受渡し、食器・容器等の回収、予約受付、客席のセッティング、苦情等への対応、給食事業所における提供先との連絡・調整 等<br>・店舗管理（店舗の運営に必要となる上記２業務以外のもの）<br> 例：店舗内の衛生管理全般、従業員のシフト管理、求人・雇用に関する事務、従業員の指導・研修に関する事務、予約客情報・顧客情報の管理、レジ・券売機管理、会計事務管理、社内本部・取引事業者・行政等との連絡調整、各種機器・設備のメンテナンス、食材・消耗品・備品の補充、発注、検品又は数量管理、メニューの企画・開発、メニューブック・POP 広告等の作成、宣伝・広告の企画、店舗内外・全体の環境整備、店内オペレーションの改善、作業マニュアルの作成・改訂等',
        description14c: '<strong>〈 想定される関連業務 〉</strong><br>・店舗において原材料として使用する農林水産物の生産<br>・客に提供する調理品等以外の物品の販売',
        work15: '林業',
        description15a: '<strong>〈 分野、区分の概要 〉</strong><br> 森林において樹木を育てて丸太を生産し、苗木を植える等の作業に従事',
        description15b: '<strong>〈 従事する主な業務 〉</strong><br>・苗木を植え、樹木を育てる作業<br>・丸太を生産する作業 等',
        description15c: '<strong>〈 想定される関連業務 〉</strong><br>当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次のものなどが想定される。<br>・生産した丸太を使用して行う加工等の作業<br>・丸太の生産に伴う副産物（樹皮、つる等）を使用して行う製造等の作業<br>・機器・装置・工具等の保守管理<br>・資材の管理・運搬<br>・事業所等の清掃作業',
        work16: '木材産業',
        description16a: '<strong>〈 分野、区分の概要 〉</strong><br> 木材・木製品の製造・加工<br>（家具や建具などの装備品を除く。）',
        description16b: '<strong>〈 従事する主な業務 〉</strong><br> 製材／単板（ベニヤ）製造／木材チップ製造／合板製造／集成材製造／プレカット加工／銘木製造／床板製造',
        description16c: '<strong>〈 想定される関連業務 〉</strong><br>・原材料（原木・資材）の調達・受入れ作業<br>・製品の検査<br>・製品の出荷作業（運搬・梱包・積込み）<br>・作業場所の整理整頓や清掃',
      }
    },
  },
  zh: {
    // 首页
    bannerTitle: '我们正在努力建设一个安全可靠的数字社会，一起迈向更美好的未来。',
    bannerSubtitle: 'Building the future toward the realization of a safe and reliable digital society',
    ourServices: '业务',
    pickUp: '推荐',
    // 导航按钮
    greeting: '致辞<br>代表致辞',
    vision: '愿景<br>经营理念与愿景',
    companyProfile: '公司简介<br>公司概况',
    welfare: '福利<br>福利待遇',
    target: '目标<br>经营目标',
    history: '历史<br>沿革',
    // 导航栏
    achievementsNavBar: '开发实绩',
    companyNavBar: '所有公司信息',
    visionNavBar: '经营理念与愿景',
    companyProfileNavBar: '公司概况',
    welfareNavBar: '福利待遇',
    targetNavBar: '经营目标',
    historyNavBar: '沿革',
    solution: '所有业务内容',
    itsolution: 'IT事业内容',
    t1solution: '登录支援机关',
    t2solution: '有料职业介绍',
    right: '   ',
    ses: 'SES业务',
    appDev: '应用开发',
    develop: '开发实际',
    skill: '保有技术',
    dispatch: '其他行业的人才支援',
    // 页脚
    companyNameFooter: '株式会社<br />GrowthSoft',
    address: '〒102-0072<br />东京都千代田区饭田桥1-7-10<br />山京大厦本馆7F',
    phone: '电话: 03-6265-4936',
    email: '邮箱: info@growthsoft.co.jp',
    links: '链接',
    home: '首页',
    companyInfo: '公司信息',
    solutions: '事业内容',
    recruitmentInfo: '招聘信息',
    contact: '联系我们',
    copyright: '版权 © 2024. 株式会社GrowthSoft. 保留所有权利。',
    // 致辞部分
    greetingTitle: '致辞',
    greetingMission: '<strong>使命与目标</strong><br>我们GrowthSoft以客户的商业成功为首要目标，致力于提供创新的IT解决方案。我们利用在各个行业积累的经验和专业知识，全力提供最佳解决方案。',
    greetingService: '<strong>服务的灵活性与信任关系</strong><br>我们提供灵活且高效的服务，满足客户需求，力求始终超越客户期望。通过引入先进技术和持续改进，我们重视建立信任关系。',
    greetingEmployee: '<strong>员工的成长与贡献</strong><br>我们的成功依靠每位员工的成长和贡献。我们提供一个让员工充分发挥能力的环境，通过共同成长，推动整个组织的发展。我们尊重和合作，为客户的成功贡献力量。',
    greetingFuture: '<strong>对未来的挑战与价值创造</strong><br>在技术日新月异的进步中，我们不断挑战自我，致力于创造新价值。我们承诺与客户共同前行，开拓新的未来。真诚希望得到大家的支持和厚爱。',
    map: 'アクセス',
    mapcontext: 'GrowthSoft株式会社<br />地址:〒102-0072 东京都千代田区饭田桥1-7-10 山京大厦本馆7F<br />电话：03-6265-4936<br />邮箱：info@growthsoft.co.jp<br /><br />从最近的交通工具前往<br />[东西线]<br />从九段下站7号出口步行5分钟<br />[新宿线、半藏门线]<br />从九段下站3a出口步行6分钟<br />[东西线、南北线、大江户线、有乐町线]<br />从饭田桥站A4出口步行5分钟<br />[JR总武线]<br />从JR饭田桥站东口步行6分钟',
    maplinks: '使用Google地图检索',
    mapcompanyName: '株式会社GrowthSoft',
    mapaddress: '〒102-0072 <br />东京都千代田区饭田桥1-7-10 山京大厦本馆7F',
    mapphone: '电话: 03-6265-4936',
    mapemail: '邮件: info@growthsoft.co.jp',
    mapcontextTitle: '<br />最近直达的交通渠道',
    mapcontext1: '<br />[东西线] <br />九段下站No7出口走5分',
    mapcontext2: '<br />[新宿线・半藏门线] <br />九段下站3a出口走6分',
    mapcontext3: '<br />[东西线・南北线・大江户线・有乐町线] <br />饭田桥站Ａ４出口走5分',
    mapcontext4: '<br />[JR总武线] <br />JR饭田桥站东口走6分',
    ceoName: '王 强',
    // 愿景部分
    visionTitle: '经营理念与愿景',
    visionMission: '<strong>使命与目标</strong><br>我们的经营理念是，在相互尊重的基础上，与客户、员工和整个社会共同成长，实现幸福生活。我们始终保持高标准的道德规范，通过建立信任，为可持续发展的社会做出贡献。',
    visionService: '<strong>服务的灵活性与信任关系</strong><br>我们为客户提供卓越的技术和服务，提出超越其期望的解决方案。为员工提供成长机会和舒适的工作环境，尊重每个人的职业发展。重视环境保护和对社区的贡献，开展可持续的业务。',
    visionEmployee: '<strong>员工的成长与贡献</strong><br>我们在相互尊重中共同成长，努力追求幸福生活。为实现这一愿景，我们在日常工作中始终以诚实和热情为动力。',
    // 公司概况部分
    companyProfileTitle: '公司概况',
    companyNameLabel: '公司名称',
    companyName: '株式会社GrowthSoft',
    capitalLabel: '注册资本',
    capital: '15,000,000日元',
    ceoLabel: '代表人',
    foundedLabel: '成立时间',
    founded: '2023年9月4日',
    employeesLabel: '员工人数',
    employees: '22人',
    headquartersLabel: '总部',
    headquarters: '〒102-0072 东京都千代田区饭田桥1-7-10 山京大厦本馆7层',
    phoneLabel: '电话',
    phone: '03-6265-4936',
    banks: '合作银行',
    bank1: '三井住友银行',
    bank2: 'GMO青空网络银行',
    qualifications: '資格',
    qualification1: '合格发票　T8013301051315',
    qualification2: '注册支援机构　24登-010800',
    qualification3: '收费职业介绍　13-ユ-317559',
    qualification4: '劳动者派遣　（派）13-318368',
    // 福利待遇部分
    welfareTitle: '福利待遇',
    insurance: '保险',
    insuranceDetails: '健康保险、厚生年金、雇佣保险、工伤保险、儿童育儿补助金',
    vacation: '休假',
    vacationDetails: '产假、育儿假、护理假、弹性工作制、短时间工作制（怀孕、育儿、护理）',
    allowances: '补贴',
    allowancesDetails: '通勤补贴、勤勉补贴、加班补贴、住房补贴、年终特别出勤补贴、资格考试补助、研讨会费用补助',
    // 历史部分
    HistoryTitle: '公司沿革',
    Historyyear1: '2023年9月4日',
    Historyevent1: '・成立GrowthSoft株式会社',
    Historyyear2: '2024年4月15日',
    Historyevent2: '・因业务扩展，迁移总部至千代田区饭田桥<br>・将公司资本增资至500万元',
    Historyyear3: '2024年6月1日',
    Historyevent3: '・注册成为合格发票开具商',
    Historyyear4: '2024年8月31日',
    Historyevent4: '・实现销售额达3500万元',
    Historyyear5: '2024年10月10日',
    Historyevent5: '・注册成为支援机构',
    Historyyear6: '2025年1月1日',
    Historyevent6: '・获得职业介绍许可',
    Historyyear7: '2025年7月3日',
    Historyevent7: '・公司资本增资至1500万元',
    Historyyear8:'2025年8月31日',
    Historyevent8:'・实现销售额达8750万元',
    Historyyear9:'2026年1月1日',
    Historyevent9:'・获得劳动者派遣资格许可',
    // 目标部分
    TargetMainTitle: '经营目标',
    TargetTitle: '销售收入中长期计划',
    Targetyear: '第一年 3000万元<br>第二年 7000万元<br>第三年 11000万元',
    Targetyear1: '第一年 3000万元',
    Targetyear2: '第二年 7000万元',
    Targetyear3: '第三年 11000万元',
    // 其他
    blank: '',
    line: '-',
    joinus: '加入我们',
    mapTitle: '地图',
    home1: 'HOME',
    companyInfo1: 'Company',
    solutions1: 'Business',
    recruitmentInfo1: 'Recruit',
    contact1: 'Contact',
    language1: 'Language',
    language: '语言选择',
    languages: {
      ja: '日本語',
      zh: '中文',
      en: 'English',
      ko: '한국어',
      vi: 'Tiếng Việt',
    },
    recruitment: {
      bannerTitle: '在相互尊重中，一起向幸福生活成长',
      bannerButton: '查看详情',
      title: '招聘信息',
      description: 'GrowthSoft正在接受以下职位的申请。<br>点击职位名称查看详细信息。',
      applyButton: '申请',
      newGraduate: '新卒招聘',
      careerRecruitment: '中途招聘',
      seconedGraduate: '第二新卒',
      job1: {
        title: '应届生招聘',
        details: [
          {
            title: '应聘条件',
            content: [
              {
                label: '必备条件',
                value: `
                  <li>大学及以上学历（专科学校需为IT相关专业）</li>
                  <li>良好的性格和沟通能力</li>
                  <li>具备团队合作能力</li>
                `
              }
            ]
          },
          {
            title: '待遇',
            content: [
              {
                label: '预计年收入',
                value: '300万元～400万元<br>※根据能力给予优待'
              },
              {
                label: '',
                value: `
                  <li>根据公司规定，考虑各种条件后决定</li>
                  <li>试用期：有（3个月，工作条件不变）</li>
                  <li>升职：每年一次</li>
                  <li>奖金：每年两次（可能会发放决算奖金）</li>
                `
              },
              {
                label: '休假制度',
                value: `
                  <li>完全双休制（周六、周日及节假日休息）</li>
                  <li>带薪休假（入职时开始享有，第一年10天）</li>
                  <li>年末年初休假</li>
                  <li>丧假</li>
                  <li>产前产后假</li>
                  <li>育儿假</li>
                  <li>结婚假</li>
                  <li>护理假</li>
                `
              },
              {
                label: '资格取得奖励制度',
                value: `
                  考试费用将被承担，并且根据考试难度，通过奖金将从 5,000 日元到 100,000 日元不等。<br><br>
                  【例】
                  <li>项目经理考试 8万元</li>
                  <li>应用信息技术员考试 3万元</li>
                  <li>基础信息技术员考试 1万元</li>
                  <li>AWS认证基础级 1.5万元</li>
                  <li>AWS认证助理级 3万元</li>
                  <li>AWS认证专业级 5万元</li>
                  <li>AWS认证高级专业级 5万元</li>
                  <li>IT护照 5000元</li>
                  <li>TOEIC考试 2万～8万元</li>
                  <li>其他厂商认证也广泛适用（如Cisco、Azure、GCP、Oracle、SAP等）</li>
                `
              }
            ]
          },
          {
            title: '工作时间',
            content: '※根据项目不同，工作时间可能会有所调整'
          },
          {
            title: '工作地点',
            content: '东京/神奈川/千叶/埼玉'
          }
        ]
      },
      job2: {
        title: '中途招聘',
        details: [
          {
            title: '职位内容',
            content: '在我们客户公司（事业公司、制造商SIer、用户SIer等）的开发现场，作为系统工程师（需求定义、基本设计、详细设计、开发、测试、维护等）参与系统开发工作。'
          },
          {
            title: '应聘条件',
            content: [
              {
                label: '必备条件',
                value: `
                  <li>拥有1年以上系统开发经验</li>
                  <li>具有编程经验，并精通Java、Python、C++等编程语言</li>
                `
              },
              {
                label: '优先考虑经验和技能',
                value: `
                  <li>有过系统运维经验，并且最近有开发经验的候选人</li>
                  <li>有上游流程中的PM、PL经验或新员工培训经验者</li>
                  <li>有Web应用或移动应用开发经验者</li>
                  <li>有数据库设计和管理经验者</li>
                `
              }
            ]
          },
          {
            title: '待遇',
            content: [
              {
                label: '预计年收入',
                value: '500万元～1000万元<br>※根据经验给予优待'
              },
              {
                label: '',
                value: `
                  <li>根据能力、经验、年龄等考虑后，根据公司规定决定</li>
                  <li>试用期：有（3个月，工作条件不变）</li>
                  <li>升职：每年一次</li>
                  <li>奖金：每年两次（可能会发放决算奖金）</li>
                `
              },
              {
                label: '休假制度',
                value: `
                  <li>完全双休制（周六、周日及节假日休息）</li>
                  <li>带薪休假（入职时开始享有，第一年10天）</li>
                  <li>年末年初休假</li>
                  <li>丧假</li>
                  <li>产前产后假</li>
                  <li>育儿假</li>
                  <li>结婚假</li>
                  <li>护理假</li>
                `
              },
              {
                label: '资格取得奖励制度',
                value: `
                  考试费用将被承担，并且根据考试难度，通过奖金将从 5,000 日元到 100,000 日元不等。<br><br>
                  【例】
                  <li>项目经理考试 8万元</li>
                  <li>应用信息技术员考试 3万元</li>
                  <li>基础信息技术员考试 1万元</li>
                  <li>AWS认证基础级 1.5万元</li>
                  <li>AWS认证助理级 3万元</li>
                  <li>AWS认证专业级 5万元</li>
                  <li>AWS认证高级专业级 5万元</li>
                  <li>IT护照 5000元</li>
                  <li>TOEIC考试 2万～8万元</li>
                  <li>其他厂商认证也广泛适用（如Cisco、Azure、GCP、Oracle、SAP等）</li>
                `
              }
            ]
          },
          {
            title: '工作时间',
            content: '※根据项目不同，工作时间可能会有所调整'
          },
          {
            title: '工作地点',
            content: '东京/神奈川/千叶/埼玉'
          }
        ]
      },
      job3: {
        title: '第二新卒',
        details: [
          {
            title: '应聘条件',
            content: [
              {
                label: '必备条件',
                value: `
                  <li>大学及以上学历（专科学校需为IT相关专业）</li>
                  <li>良好的性格和沟通能力</li>
                  <li>具备团队合作能力</li>
                `
              }
            ]
          },
          {
            title: '待遇',
            content: [
              {
                label: '预计年收入',
                value: '300万元～400万元<br>※根据能力给予优待'
              },
              {
                label: '',
                value: `
                  <li>根据公司规定，考虑各种条件后决定</li>
                  <li>试用期：有（3个月，工作条件不变）</li>
                  <li>升职：每年一次</li>
                  <li>奖金：每年两次（可能会发放决算奖金）</li>
                `
              },
              {
                label: '休假制度',
                value: `
                  <li>完全双休制（周六、周日及节假日休息）</li>
                  <li>带薪休假（入职时开始享有，第一年10天）</li>
                  <li>年末年初休假</li>
                  <li>丧假</li>
                  <li>产前产后假</li>
                  <li>育儿假</li>
                  <li>结婚假</li>
                  <li>护理假</li>
                `
              },
              {
                label: '资格取得奖励制度',
                value: `
                  考试费用将被承担，并且根据考试难度，通过奖金将从 5,000 日元到 100,000 日元不等。<br><br>
                  【例】
                  <li>项目经理考试 8万元</li>
                  <li>应用信息技术员考试 3万元</li>
                  <li>基础信息技术员考试 1万元</li>
                  <li>AWS认证基础级 1.5万元</li>
                  <li>AWS认证助理级 3万元</li>
                  <li>AWS认证专业级 5万元</li>
                  <li>AWS认证高级专业级 5万元</li>
                  <li>IT护照 5000元</li>
                  <li>TOEIC考试 2万～8万元</li>
                  <li>其他厂商认证也广泛适用（如Cisco、Azure、GCP、Oracle、SAP等）</li>
                `
              }
            ]
          },
          {
            title: '工作时间',
            content: '※根据项目不同，工作时间可能会有所调整'
          },
          {
            title: '工作地点',
            content: '东京/神奈川/千叶/埼玉'
          }
        ]
      },
      job4: {
        title: '其他行业的人才支援',
        details: [
          {
            title: '申请条件',
            content: [
              {
                label: '必要条件',
                value: `
                  <li>良好的性格和强大的沟通能力</li>
                  <li>能够团队合作工作</li>
                  <li>能够迅速且准确地完成工作</li>
                  <li>能够适应新环境的灵活性</li>
                `
              }
            ]
          },
          {
            title: '待遇',
            content: [
              {
                label: '预期年收入',
                value: '280万日元～450万日元<br>※根据经验优待'
              },
              {
                label: '',
                value: `
                  <li>根据公司规定，考虑能力、经验、年龄等决定</li>
                  <li>试用期：有 (3个月，无劳动条件变化)</li>
                  <li>晋升：每年一次</li>
                  <li>奖金：每年两次（可能有决算奖金）</li>
                `
              }
            ]
          },
          {
            title: '工作地点',
            content: '东京/神奈川/千叶/埼玉'
          }
        ]
      }
    },
    contactUs: {
      title: '联系我们',
      inquiryType: '咨询类别',
      name: '姓名',
      lastName: '姓',
      firstName: '名',
      companyName: '公司名或团体名',
      departmentName: '部门名',
      email: '电子邮箱',
      phone: '电话号码',
      message: '咨询内容',
      submitButton: '发送',
      required: '必填',
      optional: '选填',
      select: '请选择',
      newGraduate: '新卒招聘',
      careerRecruitment: '中途招聘',
      seconedGraduate: '第二新卒',
      serviceInquiry: '服务或公司相关咨询',
      other: '其他',
      validationMessage: '请填写此字段。',
      successMessage: '消息已发送！',
      errorMessage: '消息发送失败，请重试。'
    },
    solutionInfo: {
      title: '业务内容',
      overview: '概述',
      technicalFields: '技术领域',
      services: '服务内容',
      ses: {
        title: 'SES业务',
        description: '我们公司以SES（系统工程服务）业务为核心，从系统开发到运维和维护，提供一条龙服务。我们能够满足从项目开发阶段到系统上线后的维护运作等各个环节的各种需求。',
        description1: '此外，我们公司有很多优秀的外国籍工程师，能够提供高质量、性价比高的服务。如需报价，欢迎随时联系我们咨询。',
        frontend: '前端',
        languages: '开发语言',
        database: '数据库',
        frontendContent: 'Vue.js、React.js、Angular.js等',
        languagesContent: 'Java、C、C++、C#、JavaScript、TypeScript、VB.NET、ASP.NET、COBOL、PHP等',
        databaseContent: 'Oracle、MySQL、PostgreSQL、SQLserver、MongoDB等'
      },
      appDev: {
        title: '应用开发',
        description: '在应用开发业务中，我们从事智能手机应用和网络应用的策划、开发和运维。我们利用最新技术，提供用户友好的应用程序。',
        services: '从需求定义、设计、开发、测试到发布，我们提供一站式支持。我们为客户开发最适合其商业模式的应用，提高竞争力。'
      },
      skill: {
        title: '拥有技能',
        description: '我们团队具备应对多种技术领域的高度适应能力和灵活性，能够为不同行业的客户提供最合适的解决方案。',
        description1: '对于复杂的业务课题，我们采取创新且实用的方法进行问题解决。我们在证券、银行、保险等多个行业领域都拥有丰富的项目经验。',
        description2: '凭借以往积累的经验，我们可以迅速并以最合适的方式应对客户的具体需求。同时我们也会持续提升技术实力。',
        environment: '开发环境',
        languages: '开发语言',
        database: '数据库',
        environmentContent: 'Windows、Linux 等操作系统',
        languagesContent: 'Java、C、C++、C#、JavaScript、TypeScript、VB.NET、ASP.NET、COBOL、PHP 等',
        databaseContent: 'Oracle、MySQL、PostgreSQL、SQL Server、MongoDB 等'
      },
      develop: {
        title: '开发实绩',
        Webtitle: 'Web系统',
        WebNameLabel1: '库存管理系统',
        WebNameLabel2: '商品管理系统',
        WebNameLabel3: '客户管理系统',
        WebNameLabel4: '生产管理系统',
        WebNameLabel5: 'ATM联动系统',
        WebNameLabel6: '物流系统',
        WebNameLabel7: '基础平台系统',
        apptitle: '应用程序',
        appNameLabel1: 'iOS应用',
        appNameLabel2: 'Android应用',
        packagetitle: '套件导入支持',
        packageNameLabel1: 'SAP 系统',
        packageNameLabel2: 'Salesforce 系统'
      },
      t2solution: {
        title: '有偿职业介绍',
        work01: 'IT类职位招聘（本公司/合作公司）',
        description01: '涉及Web开发、AWS云服务、IT基础设施等，面向中日企业的IT相关职位推荐',
        work02: '日本各类职位推荐',
        description02: '如办公室文员、翻译、国际贸易、销售、零售等工作',
        work03: '留学申请和升学指导',
        description03: '包括日本语学校申请、大学和研究生院的升学咨询',
        work04: '特定技能签证相关服务',
        description04: '包含餐饮、食品加工等行业的技能签证支持',
      },
      t1solution: {
        title: '注册支援机构服务',
        work0: '资料准备支持',
        work001: '支援计划书的制作',
        description001: '我们可以协助合作公司在招聘特定技能外国人时，制定工作和生活方面的支援计划。如果需要了解更详细的内容，欢迎随时联系我们。',
        work002: '签证类型变更材料准备',
        description002: '我们提供签证类型变更所需的资料，并在行政书士的指导下，协助准备材料并提交到各地的入国管理局办理手续',
        work1: '护理',
        description1a: '<strong>〈 领域、分类概要 〉</strong><br> 为因年老或残障等原因在生活上需要协助的人提供身体护理服务（如根据被照护者的具体情况，协助洗澡、吃饭、如厕等），以及与身体护理相关的其他辅助工作（如娱乐活动的组织、康复训练的辅助等）<br>  ※不包括在被照护者家中提供的护理服务。',
        description1b: '<strong>〈 主要从事的工作内容 〉</strong><br> ・身体护理等（如协助洗澡、吃饭、如厕等）<br> ・与身体护理相关的辅助工作（如娱乐活动的组织、康复训练的协助等）',
        description1c: '<strong>〈 可能涉及的相关工作 〉</strong><br> 例如：张贴通知、补充和管理物品等',
        work2: '大楼清洁',
        description2a: '<strong>〈 领域、分类概要 〉</strong><br> 建筑物内部的清扫工作',
        description2b: '<strong>〈 主要从事的工作内容 〉</strong><br> 在多人使用的建筑物内部（不包括住宅）进行清洁工作，目的为保持卫生环境、美观、安全以及设施维护。需根据不同区域、材质和污渍类型选择合适的清洁方法、清洁剂和工具，清除影响环境的物质，保持建筑物整洁。<br> ※包括地面、浴室、厕所、洗手台等区域的清洁，以及补充用品、整理床铺等一整套为提供卫生美观的客房所需的工作（即客房清洁）属于主要工作内容。',
        description2c: '<strong>〈 可能涉及的相关工作 〉</strong><br> 可以协助日本员工通常也会从事的相关工作，例如：<br>・多名作业员的指导、现场管理、计划制定与进度管理等<br>・清洁设备的维护、技能实习负责人、技能实习指导员、生活指导员的工作（不含主要工作内容）<br>・清洁建筑物附属的外围结构（如走道、入口区域等）<br>・清洁器材仓库的整理工作<br>・建筑物外部的清洗（外墙、屋顶等，但不包括高空作业）<br>・整理床铺工作<br>・建筑物内外的绿化管理（如浇水等）<br>・运送清洁工具和材料（如跨工地移动等）',
        description2d: '<strong>〈 其他的注意事项 〉</strong><br> ・详细内容请参考以下文件：“关于大楼清洁领域特定技能外国人可以从事的业务（2023年10月17日 大楼清洁领域特定技能协议会决议第1号）”。',
        work3: '工业产品制造业',
        description3a: '（机械金属加工分类）',
        description3aa: '<strong>〈 分野、区分的概要 〉</strong><br> 理解指导者的指示，或根据自己的判断，从事素形材产品、产业机械等的制造工序相关作业。',
        description3ab: '<strong>〈 从事的主要工作 〉</strong><br> 铸造 ／ 锻造 ／ 压铸 ／ 机械加工 ／ 金属冲压加工 ／ 钢铁作业 ／ 工厂钣金 ／ 精加工 ／ 塑料成型 ／ 机械检查 ／ 机械维护 ／ 电气设备组装 ／ 涂装 ／ 焊接 ／ 工业包装 ／ 强化塑料成型 ／ 金属热处理业',
        description3ac: '<strong>〈 预期的相关工作 〉</strong><br> 可以从事通常由日本人从事的相关工作作为附带作业。<br> 预期的相关工作如下：<br>・原材料、零部件的采购与搬运作业<br>・各工种的前后工序作业<br>・起重机、叉车等的操作作业<br>・清扫、维护管理作业<br>※不得专职从事上述相关作业。',
        description3b: '（电气电子设备组装分类）',
        description3ba: '<strong>〈 分野、区分的概要 〉</strong><br> 理解指导者的指示，或根据自己的判断，从事电气电子设备等的制造工序、组装工序相关作业。',
        description3bb: '<strong>〈 从事的主要工作 〉</strong><br> 机械加工 ／ 精加工 ／ 塑料成型 ／ 印刷线路板制造 ／ 电子设备组装 ／ 电气设备组装 ／ 机械检查 ／ 机械维护 ／ 工业包装 ／ 强化塑料成型',
        description3bc: '<strong>〈 预期的相关工作 〉</strong><br> 可以从事通常由日本人从事的相关工作作为附带作业。<br> 预期的相关工作如下：<br>・原材料、零部件的采购与搬运作业<br>・各工种的前后工序作业<br>・起重机、叉车等的操作作业<br>・清扫、维护管理作业<br>※不得专职从事上述相关作业。',
        description3c: '（金属表面处理分类）',
        description3ca: '<strong>〈 分野、区分的概要 〉</strong><br> 理解指导者的指示，或根据自己的判断，从事表面处理等相关作业。',
        description3cb: '<strong>〈 从事的主要工作 〉</strong><br> 电镀 ／ 铝阳极氧化处理',
        description3cc: '<strong>〈 预期的相关工作 〉</strong><br> 可以从事通常由日本人从事的相关工作作为附带作业。<br> 预期的相关工作如下：<br>・原材料、零部件的采购与搬运作业<br>・各工种的前后工序作业<br>・起重机、叉车等的操作作业<br>・清扫、维护管理作业<br>※不得专职从事上述相关作业。',
        description3d: '（纸制品・瓦楞纸箱制造分类）',
        description3da: '<strong>〈 分野、区分的概要 〉</strong><br> 理解指导者的指示，或根据自己的判断，从事纸盒、瓦楞纸箱的制造工序相关作业。',
        description3db: '<strong>〈 从事的主要工作 〉</strong><br> 纸盒・瓦楞纸箱制造',
        description3dc: '<strong>〈 预期的相关工作 〉</strong><br> 可以从事通常由日本人从事的相关工作作为附带作业。<br> 预期的相关工作如下：<br>・原材料、零部件的采购与搬运作业<br>・各工种的前后工序作业<br>・起重机、叉车等的操作作业<br>・清扫、维护管理作业<br>※不得专职从事上述相关作业。',
        description3e: '（混凝土制品制造分类）',
        description3ea: '<strong>〈 分野、区分的概要 〉</strong><br> 理解指导者的指示，或根据自己的判断，从事混凝土制品的制造工序相关作业。',
        description3eb: '<strong>〈 从事的主要工作 〉</strong><br> 混凝土制品制造',
        description3ec: '<strong>〈 预期的相关工作 〉</strong><br> 可以从事通常由日本人从事的相关工作作为附带作业。<br> 预期的相关工作如下：<br>・原材料、零部件的采购与搬运作业<br>・各工种的前后工序作业<br>・起重机、叉车等的操作作业<br>・清扫、维护管理作业<br>※不得专职从事上述相关作业。',
        description3f: '（RPF制造分类）',
        description3fa: '<strong>〈 分野、区分的概要 〉</strong><br> 理解指导者的指示，或根据自己的判断，从事破碎、成型等相关作业。',
        description3fb: '<strong>〈 从事的主要工作 〉</strong><br> RPF（再生塑料燃料）制造',
        description3fc: '<strong>〈 预期的相关工作 〉</strong><br> 可以从事通常由日本人从事的相关工作作为附带作业。<br> 预期的相关工作如下：<br>・原材料、零部件的采购与搬运作业<br>・各工种的前后工序作业<br>・起重机、叉车等的操作作业<br>・清扫、维护管理作业<br>※不得专职从事上述相关作业。',
        description3g: '（陶瓷制品制造分类）',
        description3ga: '<strong>〈 分野、区分的概要 〉</strong><br> 理解指导者的指示，或根据自己的判断，从事陶瓷制品的制造工序相关作业。',
        description3gb: '<strong>〈 从事的主要工作 〉</strong><br> 陶瓷工业制品制造',
        description3gc: '<strong>〈 预期的相关工作 〉</strong><br> 可以从事通常由日本人从事的相关工作作为附带作业。<br> 预期的相关工作如下：<br>・原材料、零部件的采购与搬运作业<br>・各工种的前后工序作业<br>・起重机、叉车等的操作作业<br>・清扫、维护管理作业<br>※不得专职从事上述相关作业。',
        description3h: '（印刷装订分类）',
        description3ha: '<strong>〈 分野、区分的概要 〉</strong><br> 了解主管的指示或运用自己的判断来从事胶印、凹印和装订制造流程。',
        description3hb: '<strong>〈 从事的主要工作 〉</strong><br> 印刷/装订',
        description3hc: '<strong>〈 预期的相关工作 〉</strong><br> 可以从事通常由日本人从事的相关工作作为附带作业。<br> 预期的相关工作如下：<br>・原材料、零部件的采购与搬运作业<br>・各工种的前后工序作业<br>・起重机、叉车等的操作作业<br>・清扫、维护管理作业<br>※不得专职从事上述相关作业。',
        description3i: '（纺织制造分类）',
        description3ia: '<strong>〈 分野、区分的概要 〉</strong><br> 在理解讲师指导或自行判断的情况下参与纺织产品的制造过程',
        description3ib: '<strong>〈 从事的主要工作 〉</strong><br> 纺纱作业 / 织造作业 / 染色 / 针织产品制造 / 经编针织物制造 / 地毯制造',
        description3ic: '<strong>〈 预期的相关工作 〉</strong><br> 可以从事通常由日本人从事的相关工作作为附带作业。<br> 预期的相关工作如下：<br>・原材料、零部件的采购与搬运作业<br>・各工种的前后工序作业<br>・起重机、叉车等的操作作业<br>・清扫、维护管理作业<br>※不得专职从事上述相关作业。',
        description3j: '（缝纫分类）',
        description3ja: '<strong>〈 分野、区分的概要 〉</strong><br> 理解指导员的指示或根据自己的判断从事缝纫工序工作',
        description3jb: '<strong>〈 从事的主要工作 〉</strong><br> 女装及童装制造 / 男装制造 / 内衣制造 / 床上用品制造 / 帆布制品制造 / 布料缝纫 / 座椅缝纫',
        description3jc: '<strong>〈 预期的相关工作 〉</strong><br> 可以从事通常由日本人从事的相关工作作为附带作业。<br> 预期的相关工作如下：<br>・原材料、零部件的采购与搬运作业<br>・各工种的前后工序作业<br>・起重机、叉车等的操作作业<br>・清扫、维护管理作业<br>※不得专职从事上述相关作业。',
        work4: '施工',
        description4a: '（土木分类）',
        description4aa: '<strong>〈 分野、区分的概要 〉</strong><br> 在主管的指导和监督下，您将从事与土木工程设施的建设、改造、维护和修理相关的工作。',
        description4ab: '<strong>〈 从事的主要工作 〉</strong><br> 模板施工 / 混凝土泵送 / 隧道掘进 / 建筑机械施工 / 土方工程 / 钢筋混凝土施工 / 脚手架 / 海洋土木工程<br>其他与土木工程设施的建设、重建、维护和修理有关的工作',
        description4ac: '<strong>〈 预期的相关工作 〉</strong><br>・原材料和零部件的采购和运输<br>・设备、装置、工具等的维护和管理<br>・组装脚手架、挖掘设备等后续工序的准备工作<br>・拆除脚手架、回填设备等上游工序的整理工作<br>・清洁和维护工作<br>・其他与主要工作相关的工作',
        description4ad: '<strong>〈 其他的注意事项 〉</strong><br> 有关工作的详情，请参阅“工作类别与考试、技能实习等的关系”下的“工作类别与建筑业执照工作的关系”。请参阅下面的国土交通省网站。',
        description4b: '（建筑分类）',
        description4ba: '<strong>〈 分野、区分的概要 〉</strong><br> 在主管的指导和监督下，您将从事与建筑物的建造、扩建、翻新、搬迁、修理或改造相关的工作',
        description4bb: '<strong>〈 从事的主要工作 〉</strong><br> 模板施工 / 抹灰 / 混凝土泵送 / 屋顶施工 / 土方工程 / 钢筋施工 / 钢筋接头 / 室内装修 / 室外工程 / 脚手架 / 木工 / 建筑金属板材工程 / 喷涂聚氨酯保温<br>与建筑物的新建、扩建、翻新、搬迁、维修或改建相关的其他工作',
        description4bc: '<strong>〈 预期的相关工作 〉</strong><br>・原材料和零部件的采购和运输<br>・设备、装置、工具等的维护和管理<br>・组装脚手架、挖掘设备等后续工序的准备工作<br>・拆除脚手架、回填设备等上游工序的整理工作<br>・清洁和维护工作<br>・其他与主要工作相关的工作',
        description4bd: '<strong>〈 其他的注意事项 〉</strong><br> 有关工作的详情，请参阅“工作类别与考试、技能实习等的关系”下的“工作类别与建筑业执照工作的关系”。请参阅下面的国土交通省网站。',
        description4c: '（生命线和设施分类）',
        description4ca: '<strong>〈 分野、区分的概要 〉</strong><br> 在主管的指导和监督下，您将从事与电信、燃气、水、电和其他生命线设施的维护、安装、改造或修理相关的工作。',
        description4cb: '<strong>〈 从事的主要工作 〉</strong><br> 电信/管道/建筑金属板/隔热和保冷<br>与生命线和设施的维护、安装、改造或修理有关的其他工作',
        description4cc: '<strong>〈 预期的相关工作 〉</strong>材料和零件的采购和运输<br>・设备、装置、工具等的维护和管理<br>・组装脚手架、挖掘设施等后期准备工作<br>・拆除脚手架、回填设施等前期整理工作<br>・清洁和维护工作<br>・其他与主要工作相关的工作',
        description4cd: '<strong>〈 其他的注意事项 〉</strong><br> 有关工作的详情，请参阅“工作类别与考试、技能实习等的关系”下的“工作类别与建筑业执照工作的关系”。请参阅下面的国土交通省网站。',
        work5: '造船和海洋工业',
        description5a: '（造船分类）',
        description5aa: '<strong>〈 分野、区分的概要 〉</strong><br> 造船（在主管的监督下或自行从事造船工作）',
        description5ab: '<strong>〈 从事的主要工作 〉</strong><br> 焊接 / 喷漆 / 铁制品 / 脚手架 / 管道 / 造船',
        description5ac: '<strong>〈 预期的相关工作 〉</strong><br>・读图作业<br>・工作流程管理<br>・检查（外观、尺寸、材质、强度、无损、耐压、气密性等）<br>・设备、装置、工具的维护管理<br>・设备、装置、运输机械的操作<br>・材料管理和材料放置<br>・零件和产品的保养<br>・脚手架的组装和拆卸<br>・废料处理<br>・包装和运输<br>・材料、零件和产品的运输<br>・码头的进出<br>・清洁',
        description5ad: '<strong>〈 其他的注意事项 〉</strong><br> 有关该服务的详情，请访问以下国土交通省网站。',
        description5b: '（船用机械分类）',
        description5ba: '<strong>〈 分野、区分的概要 〉</strong><br> 船舶机械（理解监督人员的指示或自行决定从事船舶机械的制造过程）',
        description5bb: '<strong>〈 从事的主要工作 〉</strong><br> 焊接 / 涂装 / 铁工 / 精加工 / 机械加工 / 管道 / 铸造 / 金属冲压加工 / 强化塑料成型 / 机械维护 / 船舶加工',
        description5bc: '<strong>〈 预期的相关工作 〉</strong><br>・读图作业<br>・工作流程管理<br>・检查（外观、尺寸、材质、强度、无损、耐压、气密性等）<br>・设备、装置、工具的维护管理<br>・设备、装置、运输机械的操作<br>・材料管理和材料放置<br>・零件和产品的保养<br>・脚手架的组装和拆卸<br>・废料处理<br>・包装和运输<br>・材料、零件和产品的运输<br>・码头的进出<br>・清洁',
        description5bd: '<strong>〈 其他的注意事项 〉</strong><br> 有关该服务的详情，请访问以下国土交通省网站。',
        description5c: '（船用电气电子设备分类）',
        description5ca: '<strong>〈 分野、区分的概要 〉</strong><br> 船舶电气电子设备（理解主管指示或自行决定从事船舶电气电子设备的制造过程）',
        description5cb: '<strong>〈 从事的主要工作 〉</strong><br> 机械加工 / 电气设备组装 / 金属冲压加工 / 电子设备组装 / 印刷线路板制造 / 管道 / 设备维修 / 船舶电气电子设备加工',
        description5cc: '<strong>〈 预期的相关工作 〉</strong><br>・读图作业<br>・工作流程管理<br>・检查（外观、尺寸、材质、强度、无损、耐压、气密性等）<br>・设备、装置、工具的维护管理<br>・设备、装置、运输机械的操作<br>・材料管理和材料放置<br>・零件和产品的保养<br>・脚手架的组装和拆卸<br>・废料处理<br>・包装和运输<br>・材料、零件和产品的运输<br>・码头的进出<br>・清洁',
        description5cd: '<strong>〈 其他的注意事项 〉</strong><br> 有关该服务的详情，请访问以下国土交通省网站。',
        work6: '汽车维修',
        description6a: '<strong>〈 分野、区分的概要 〉</strong><br> 汽车的日常检查及保养、定期检查及保养、专项保养、专项保养相关工作',
        description6b: '<strong>〈 从事的主要工作 〉</strong><br> 汽车日常检查维护、定期检查维护、专项维护、专项维护相关工作（电子控制装置维护、车身喷漆等）的基础工作',
        description6c: '<strong>〈 预期的相关工作 〉</strong><br>・维修内容说明及相关零件销售<br>・零件编号搜索及内部订购<br>・导航系统、ETC 等电气设备的安装<br>・洗车工作<br>・底盘喷漆工作<br>・车内清洁<br>・场所清洁工作<br>・零件运输等<br>・设施设备清扫等',
        work7: '航空',
        description7a: '（机场地面服务分类）',
        description7aa: '<strong>〈 分野、区分的概要 〉</strong><br> 飞机地面处理支持、行李和货物处理等',
        description7ab: '<strong>〈 从事的主要工作 〉</strong><br> 在主管或团队负责人的监督下工作<br>・飞机地面处理支持<br>・行李和货物处理<br>・装卸行李和货物<br>・飞机内外的清洁和维护',
        description7ac: '<strong>〈 预期的相关工作 〉</strong><br>- 文书工作<br>- 整理和清洁工作区域<br>- 清除工作区域积雪',
        description7b: '（飞机维修分类）',
        description7ba: '<strong>〈 分野、区分的概要 〉</strong><br> 飞机、设备等的维修',
        description7bb: '<strong>〈 从事的主要工作 〉</strong><br> 在国家合格维修工程师的指导和监督下，您将对飞机和设备进行基本的维护工作（简单的检查和更换工作等）<br>・运行维护（对下一班航班前到达机场的飞机进行的维护）<br>・飞机维护（覆盖飞机各个角落的维护，大约1-2周，通常每1-1.5年进行一次）<br>・设备和发动机维护（对从飞机上拆下的起落架和可移动表面、用于飞行和控制的仪器以及发动机进行维护）',
        description7bc: '<strong>〈 预期的相关工作 〉</strong><br>- 文书工作<br>- 整理和清洁工作区域<br>- 清除工作区域积雪',
        work8: '住宿',
        description8a: '<strong>〈 分野、区分的概要 〉</strong><br> 提供旅馆、酒店的前台、策划、公关、客服、餐饮等住宿服务',
        description8b: '<strong>〈 从事的主要工作 〉</strong><br> ・前台业务（办理入住和退房手续、提供附近旅游景点的信息、安排往返酒店的旅游行程等）<br>・策划和宣传业务（制作活动和特别计划、制作酒店介绍传单、通过网站和社交媒体发布信息等）<br>・客服业务（引导客人参观旅馆或酒店、处理客人的咨询等）<br>・餐厅服务业务（处理订单和服务（上菜和整理）、准备和摆盘食物等）',
        description8c: '<strong>〈 预期的相关工作 〉</strong><br> 旅馆、酒店等设备的销售、检测、更换等',
        work9: '汽车运输业',
        description9a: '（公交车司机分类）',
        description9aa: '<strong>〈 分野、区分的概要 〉</strong><br> 在运营经理的指导和监督下，从事一般客车运输业务、一般包车客车运输业务或特定客车运输业务的运营前后车辆检查、安全运送乘客、建立驾驶记录和与乘客打交道等工作。',
        description9ab: '<strong>〈 从事的主要工作 〉</strong><br> ・运营业务（运营前后的车辆检查、安全运送乘客、编制乘务记录等）<br>・接待业务（与乘客打交道等）',
        description9ac: '<strong>〈 预期的相关工作 〉</strong><br> 从事该业务的日本国民可以顺便从事通常会做的相关工作。 <br>预计相关工作如下：<br>- 车辆内部清洁工作<br>- 办公室内部清洁工作<br>- 票价结算和管理<br>- 与主要职责相关的其他工作<br> * 不允许专门从事相关任务。',
        description9b: '（出租车司机分类）',
        description9ba: '<strong>〈 分野、区分的概要 〉</strong><br> 在运营经理的指导和监督下，参与一般客运汽车运输业务的运营前和运营后的车辆检查、安全客运、建立工作记录和处理乘客咨询。',
        description9bb: '<strong>〈 从事的主要工作 〉</strong><br> ・运营业务（运营前后的车辆检查、安全运送乘客、编制乘务记录等）<br>・接待业务（与乘客打交道等）',
        description9bc: '<strong>〈 预期的相关工作 〉</strong><br> 从事该业务的日本国民可以顺便从事通常会做的相关工作。 <br>预计相关工作如下：<br>- 车辆内部清洁工作<br>- 办公室内部清洁工作<br>- 票价结算和管理<br>- 与主要职责相关的其他工作<br> * 不允许专门从事相关任务。',
        description9c: '（卡车司机分类）',
        description9ca: '<strong>〈 分野、区分的概要 〉</strong><br> 在运营经理的指导和监督下，您将参与卡车运输业务运营前后的车辆检查、货物的安全运输、创建机组人员记录以及装载货物以防止其移位。',
        description9cb: '<strong>〈 从事的主要工作 〉</strong><br> ・运营业务（运营前后的车辆检查、安全运送乘客、编制乘务记录等）<br>・接待业务（与乘客打交道等）',
        description9cc: '<strong>〈 预期的相关工作 〉</strong><br> 从事该业务的日本国民可以顺便从事通常会做的相关工作。 <br>预计相关工作如下：<br>- 车辆内部清洁工作<br>- 办公室内部清洁工作<br>- 票价结算和管理<br>- 与主要职责相关的其他工作<br> * 不允许专门从事相关任务。',
        work10: '铁路',
        description10a: '（轨道养护分类）',
        description10aa: '<strong>〈 分野、区分的概要 〉</strong><br> 轨道维护（轨道的建设、改进、维修和检查等）',
        description10ab: '<strong>〈 从事的主要工作 〉</strong><br> 以下列出与轨道建设、改进和维修等相关的工作和检查示例。<br>- 轨道检查工作（测量轨道位移，例如高度和线形）<br>- 轨道更换工作（更换新旧轨道/辅助工作（起重工作等））<br>- 枕木更换工作（更换新旧枕木/辅助工作（道碴挖掘工作等））<br>- 道碴处理工作（道碴挖掘和回填/形成道碴形状/与捣固和线形调整相关的工作等）<br>- 安全设备等处理工作（安装防脱轨保护装置等安全设备（更换、拆除、修复等）/辅助工作（张紧和松开紧固装置等））',
        description10ac: '<strong>〈 预期的相关工作 〉</strong><br> 从事该业务的日本国民可以顺便从事通常会做的相关工作。 <br> 预计相关业务活动如下：<br>・行政工作<br>・整理和清洁工作区域',
        description10b: '（电气设备维护分类）',
        description10ba: '<strong>〈 分野、区分的概要 〉</strong><br> 电气设备维护（与电路设备、变电设备、电气设备、信号安全设备、安全通信设备、铁路道口安全设备等有关的建设、改进和修理工作）',
        description10bb: '<strong>〈 从事的主要工作 〉</strong><br> 适用于下列设施的建设、改进、修理和检查工作：<br>・电路设施（电力线、输电线、配电线等）<br>・变电设施（断路器、变压器、整流器、避雷器、保护装置、接地装置、灭火设施等）<br>・电气设备设施（配电盘、开关、电源、照明设备、电动公告牌、电动融雪器等）<br>・信号安全设施（信号装置、转辙装置、联锁装置、列车检测装置、列车自动停止装置等）<br>・安全通信设施（配电盘、传送装置、无线电装置、终端装置、通信线路等）<br>・铁路道口安全设施（铁路道口闸门、铁路道口警报器、铁路道口警报时间控制装置、铁路道口障碍物警告装置、障碍物检测装置等）<br>※包括支架、电缆、导管、配线等。对于上述设施”',
        description10bc: '<strong>〈 预期的相关工作 〉</strong><br> 从事该业务的日本国民可以顺便从事通常会做的相关工作。 <br> 预计相关业务活动如下：<br>・行政工作<br>・整理和清洁工作区域',
        description10c: '（车辆维修分类）',
        description10ca: '<strong>〈 分野、区分的概要 〉</strong><br> 车辆维修（铁路车辆维修工作等）',
        description10cb: '<strong>〈 从事的主要工作 〉</strong><br> 以下列举了一些受本条例约束的业务活动：<br>・列车检查、定期检查、特殊检查（空调设备、受电设备、行走装置、制动设备、空气设备、电气设备、发电设备、安全设备、车体、乘务组及乘客车厢相关设备、联结装置等以及车辆部件（包括拆卸和补充消耗品）的检查和维修）<br>・场内调车（车辆段等的车辆调车和引导）<br>・车站调度支援（车辆段等的车辆检查和维修）<br>・改装工作（车辆的改装和改进工作等）<br>・定期和特殊清洁工作（车辆段等的车辆清洁）<br>・库存和备件管理、工厂设备的处理<br>・与上述相关的材料、部件、设备等的管理以及设备的运行和管理',
        description10cc: '<strong>〈 预期的相关工作 〉</strong><br> 从事该业务的日本国民可以顺便从事通常会做的相关工作。 <br> 预计相关业务活动如下：<br>・行政工作<br>・整理和清洁工作区域',
        description10d: '（车辆制造分类）',
        description10da: '<strong>〈 分野、区分的概要 〉</strong><br> 车辆制造（铁路车辆、铁路车辆零部件等制造）',
        description10db: '<strong>〈 从事的主要工作 〉</strong><br> 以下列举一些受此规定约束的业务活动：<br>・材料加工（板材加工/转向架构架、结构部件加工等）<br>・部件组装作业（轮对（驱动装置）、配电盘等电气设备组装/车门、车窗、发动机罩、座椅等内饰设备组装）<br>・结构组装（车架、车顶结构、侧面结构和山墙结构组装/结构（六面体）组装等）<br>・涂装<br>・焊接<br>・装配（设备安装、配线、管道/车门、车窗、天花板、卫生间设施等内饰部件安装）<br>・转向架构架制造<br>・转向架组装<br>・电子设备组装（运行安全装置（ATC 装置和 ATS 装置）、控制装置、监视器装置等的组装）<br>・电气设备组装（使用继电器的配电盘组装、等）<br>・测试和检查（功能检查等）<br>・零件检查和配送工作（仓库管理和零件运输等）',
        description10dc: '<strong>〈 预期的相关工作 〉</strong><br> 从事该业务的日本国民可以顺便从事通常会做的相关工作。 <br> 预计相关业务活动如下：<br>・行政工作<br>・整理和清洁工作区域',
        description10e: '（交通运输人员分类）',
        description10ea: '<strong>〈 分野、区分的概要 〉</strong><br> 交通运输工作人员（车站工作人员、售票员、司机等）',
        description10eb: '<strong>〈 从事的主要工作 〉</strong><br> 以下列出受此限制的业务活动示例：<br>・道岔运营（运营道岔以确定列车等的路径，根据列车路径显示或指示适当的铁路信号）<br>・调车信号（向工作人员发出切换轨道、列车联结/分离等的信号）<br>・车站设备管理及操作业务（车站售票机、检票口等的管理和操作/设备故障时的第一轮维修响应）<br>・乘客引导及货物处理业务（正常和异常情况下在站台上的安全检查和乘客引导/换乘运输期间的乘客引导等/货物接收、临时存放场所的指定、载客列车等）<br>・运行管理业务（确认和管理列车时刻表和列车运行/在发生异常时指定暂停或增加的列车）<br>・列车长业务（在列车上引导乘客、向司机发出信号/为防止事故而进行的安全检查等/采取措施防止发生事故时保护列车，防止事故蔓延/（紧急情况下的避难指导等）<br>・司机职责（驾驶列车需要机车驾驶执照）（列车驾驶（单人驾驶列车时，兼任乘务员））',
        description10ec: '<strong>〈 预期的相关工作 〉</strong><br> 从事该业务的日本国民可以顺便从事通常会做的相关工作。 <br> 预计相关业务活动如下：<br>・行政工作<br>・整理和清洁工作区域',
        work11: '农业',
        description11a: '（耕作农业分类）',
        description11aa: '<strong>〈 分野、区分的概要 〉</strong><br> 栽培管理、农产品的收集、运输、分拣等农业工作',
        description11ab: '<strong>〈 从事的主要工作 〉</strong><br>・营造适合各种作物的土壤<br>・施肥作业<br>・种子和幼苗的处理<br>・材料和设备的处理<br>・与栽培相关的工作<br>・安全和卫生职责等',
        description11ac: '<strong>〈 预期的相关工作 〉</strong><br>- 使用特定技能机构（劳务派遣时为派遣业务经营者）生产的农产品或畜牧产品作为原材料或配料的制造或加工工作<br>- 使用特定技能机构（劳务派遣时为派遣业务经营者）生产农产品和畜牧产品过程中产生的副产品（稻草、牲畜粪便等）作为原材料或配料的制造或加工工作<br>- 运输、展示或销售农产品和畜牧产品的工作（仅限包含特定技能机构（劳务派遣时为派遣业务经营者）生产的农产品和畜牧产品的情况）<br>- 运输使用农产品和畜牧产品作为原材料或配料制造或加工的产品（仅限包含特定技能机构（劳务派遣时为派遣业务经营者）生产的农产品和畜牧产品作为原材料或配料的情况）。特定技能机构（劳务派遣时为派遣业务）运输、展示或销售以农畜产品生产副产品为原料或配料而制造或加工的产品（仅限于以农畜产品生产副产品为原料或配料而制造或加工的产品（肥料、饲料等））。在特定技能机构（劳务派遣时为派遣业务）从事种植业或畜牧业的日本人通常进行的工作。（拥有畜牧业技能的特定技能外国人在经营畜牧业和种植业相结合业务的特定技能机构（劳务派遣时为派遣业务）从事种植业工作时，或从事冬季除雪工作时等）',
        description11b: '（畜牧养殖分类）',
        description11ba: '<strong>〈 分野、区分的概要 〉</strong><br> 农场工作，如牲畜管理、牲畜产品的收集、运输和分类',
        description11bb: '<strong>〈 从事的主要工作 〉</strong><br>・各种牲畜设备的操作<br>・个体牲畜的操作和观察<br>・畜牧业管理<br>・农产品处理<br>・安全和卫生工作等',
        description11bc: '<strong>〈 预期的相关工作 〉</strong><br>- 使用特定技能机构（劳务派遣时为派遣业务经营者）生产的农产品或畜牧产品作为原材料或配料的制造或加工工作<br>- 使用特定技能机构（劳务派遣时为派遣业务经营者）生产农产品和畜牧产品过程中产生的副产品（稻草、牲畜粪便等）作为原材料或配料的制造或加工工作<br>- 运输、展示或销售农产品和畜牧产品的工作（仅限包含特定技能机构（劳务派遣时为派遣业务经营者）生产的农产品和畜牧产品的情况）<br>- 运输使用农产品和畜牧产品作为原材料或配料制造或加工的产品（仅限包含特定技能机构（劳务派遣时为派遣业务经营者）生产的农产品和畜牧产品作为原材料或配料的情况）。特定技能机构（劳务派遣时为派遣业务）运输、展示或销售以农畜产品生产副产品为原料或配料而制造或加工的产品（仅限于以农畜产品生产副产品为原料或配料而制造或加工的产品（肥料、饲料等））。在特定技能机构（劳务派遣时为派遣业务）从事种植业或畜牧业的日本人通常进行的工作。（拥有畜牧业技能的特定技能外国人在经营畜牧业和种植业相结合业务的特定技能机构（劳务派遣时为派遣业务）从事种植业工作时，或从事冬季除雪工作时等）',
        work12: '渔业',
        description12a: '（渔业分类）',
        description12aa: '<strong>〈 分野、区分的概要 〉</strong><br> 制造和修理渔具，搜寻水生动植物，操作渔具和机械，捕捞水生动植物，加工和储存渔获物，确保安全和卫生等。',
        description12ab: '<strong>〈 从事的主要工作 〉</strong><br>・主要通过钓鱼捕捞水产（延绳钓、鲣鱼竿钓、鱿鱼捕捞等）<br>・主要使用网和笼捕捞水产（定置网捕捞、围网捕捞、拖网捕捞等）<br>・修理渔具（网、笼等）<br>・使用声纳和鱼群探测器搜寻鱼群<br>・操作收起捕鱼用网和线的起网机/起线机、自动鱿鱼捕捞机等机器<br>・渔获物的分类、装箱、冷冻和准备<br>・在渔港卸载渔获物和渔具等',
        description12ac: '<strong>〈 预期的相关工作 〉</strong><br>・渔具及机械的检查、更换<br>・船体的修理、清洗<br>・鱼舱、渔具库、岗亭的清洗<br>・饵料、冰块、燃料、食材、生活用品等作业、生活用品的准备、装载<br>・出海捕鱼时的烹饪、用餐服务<br>・围网养殖捕获的水生动植物等辅助性水产养殖<br>・自产产品的运输、展示、销售<br>・使用自产产品或其副产品作为原材料、原料进行制造、加工，以及制造、加工产品的运输、展示、销售<br>・在鱼市、码头对渔获物进行分类、整理<br>・在亲身钓鱼活动中协助乘客捕捉水生动植物<br>・公司内外的培训',
        description12b: '（养殖业分类）',
        description12ba: '<strong>〈 分野、区分的概要 〉</strong><br> 水产养殖材料的生产、维修和管理，养殖水生动植物的培育和管理，养殖水生动植物的收获和加工，确保安全和卫生等。',
        description12bb: '<strong>〈 从事的主要工作 〉</strong><br>- 养殖鱼类、贝类、藻类等<br>- 投喂养殖鱼类、清除死鱼、残饵等<br>- 清理养殖贝类上的粘附物<br>- 收获养殖水生动植物，并运送至水产市场和登陆港<br>- 剥去养殖贝类的壳<br>- 清理养殖池塘和渔网、管理水质等<br>- 制作和修理养殖筏<br>- 生产和捕捉养殖水生动植物的幼苗等',
        description12bc: '<strong>〈 预期的相关工作 〉</strong><br>・渔具及机械的检查、更换<br>・船体的修理、清洗<br>・鱼舱、渔具库、岗亭的清洗<br>・饵料、冰块、燃料、食材、生活用品等作业、生活用品的准备、装载<br>・出海捕鱼时的烹饪、用餐服务<br>・围网养殖捕获的水生动植物等辅助性水产养殖<br>・自产产品的运输、展示、销售<br>・使用自产产品或其副产品作为原材料、原料进行制造、加工，以及制造、加工产品的运输、展示、销售<br>・在鱼市、码头对渔获物进行分类、整理<br>・在亲身钓鱼活动中协助乘客捕捉水生动植物<br>・公司内外的培训',
        work13: '食品和饮料制造业',
        description13a: '<strong>〈 分野、区分的概要 〉</strong><br> 食品和饮料（酒精饮料除外）的生产和加工，确保安全和卫生',
        description13b: '<strong>〈 从事的主要工作 〉</strong><br>・原材料加工、加热、灭菌、成型、干燥等一系列生产相关作业。<br>・检查业务中使用的机器的安全性、管理工人的卫生等，确保职业安全和食品卫生的工作。',
        description13c: '<strong>〈 预期的相关工作 〉</strong><br>・原材料的采购和接收<br>・成品的交付<br>・清洁<br>・营业场所的管理',
        work14: '餐饮业',
        description14a: '<strong>〈 分野、区分的概要 〉</strong><br> 食品和饮料准备、客户服务、商店管理',
        description14b: '<strong>〈 从事的主要工作 〉</strong><br>・食品和饮料准备（烹饪、准备和制作要提供给客户的食品和饮料）<br> 例如：准备食材、熟食、未烹饪的熟食、调味、装盘、准备食品和饮料等。<br> 客户服务（执行食品和饮料准备之外的其他任务，以便向客户提供食品和饮料）<br> 例如：引导客户入座、推荐菜单、接受订单、上菜、清理桌子、摆放餐具、接受付款、摆放产品、移交产品、收集餐具和容器、接受预订、设置座位、处理投诉、在餐饮设施与客户联络和协调。等<br>・店铺管理（除上述2项以外，店铺运营所需的一切业务）<br> 示例：店铺内的整体卫生管理、员工轮班管理、招聘及雇用相关事务、员工指导及培训相关事务、预约信息及顾客信息管理、收银机及售票机管理、会计管理、与公司总部、商社、政府等的联络及协调、各种设备设施的维护、食材及消耗品及用品的补充、订货、检验及数量管理、菜单的企划及开发、菜单册及POP广告的制作等、促销及广告策划、店铺内外及整体环境的维护、店内运营的改善、工作手册的制作及修订等',
        description14c: '<strong>〈 预期的相关工作 〉</strong><br>・生产用作商店原料的农林水产品<br> ・销售除熟食等以外的产品，提供给顾客',
        work15: '林业',
        description15a: '<strong>〈 分野、区分的概要 〉</strong><br> 从事森林栽培树木、生产原木、栽植树苗等工作。',
        description15b: '<strong>〈 从事的主要工作 〉</strong><br>・栽培树苗、培育树木<br>・生产原木等',
        description15c: '<strong>〈 预期的相关工作 〉</strong><br>从事该业务的日本国民可以顺便从事通常会做的相关工作。 <br> 预计相关工作如下：<br>・使用所生产的原木进行加工和其他工作<br>・使用原木生产副产品（树皮、藤蔓等）进行制造和其他工作<br>・设备、装置、工具等的维护和管理<br>・材料的管理和运输<br>・营业场所的清洁工作等。',
        work16: '木材工业',
        description16a: '<strong>〈 分野、区分的概要 〉</strong><br> 木材及木制品制造及加工（不包括家具、固定装置及其他配件）',
        description16b: '<strong>〈 从事的主要工作 〉</strong><br> 木材 / 单板制造 / 木片制造 / 胶合板制造 / 层压木材制造 / 预切加工 / 优质木材制造 / 地板制造',
        description16c: '<strong>〈 预期的相关工作 〉</strong><br>- 原材料的采购和验收（原木和供应品）<br>- 产品检验<br>- 产品运输（运输、包装、装载）<br>- 组织和清洁工作区域。',
      },
      dispatch: {
        title: '其他行业的人才支援服务',
        description: '其他行业的人才支援服务为各种行业的企业提供具备必要技能和经验的优秀人才。我们根据客户的商业需求，快速且准确地匹配最佳人才。行业例子包括酒店、工厂、餐饮店等。',
        services: '从人才招聘、筛选到入职后的跟进，我们提供一站式服务。我们根据客户的商业需求，提供适当的人才，支持客户的商业成功。'
      }
    }
  },
  en: {
    // HomePage
    bannerTitle: '',
    bannerSubtitle: 'Building the future toward the realization of a safe and reliable digital society',
    ourServices: 'Services',
    pickUp: 'Pick Up',
    // Navigation Buttons
    greeting: 'GREETING<br>CEO Greeting',
    vision: 'VISION<br>Management Philosophy & Vision',
    companyProfile: 'COMPANY PROFILE<br>Company Overview',
    welfare: 'WELFARE<br>Welfare',
    target: 'TARGET<br>Target',
    history: 'HISTORY<br>History',
    // NavBar
    achievementsNavBar: 'Achievements',
    companyNavBar: 'All Company Information',
    visionNavBar: 'Management Philosophy & Vision',
    companyProfileNavBar: 'Company Overview',
    welfareNavBar: 'Welfare',
    targetNavBar: 'Target',
    historyNavBar: 'History',
    solution: 'All Business Contents',
    itsolution: 'IT Business Content',
    t1solution: 'Registered Support Organization',
    t2solution: 'Paid Job Introduction',
    right: '   ',
    ses: 'SES Business',
    appDev: 'App Development',
    develop: 'Development Track Record',
    skill: 'Owned Skills',
    dispatch: 'Other Industry Staffing Support',
    // Footer
    companyNameFooter: 'GrowthSoft Inc.',
    address: '1-7-10 Iidabashi, Chiyoda-ku, Tokyo 102-0072<br />Yamakyu Building Main Building 7F',
    phone: 'Phone: 03-6265-4936',
    email: 'Email: info@growthsoft.co.jp',
    links: 'Links',
    home: 'Home',
    companyInfo: 'Company Information',
    solutions: 'Business Content',
    recruitmentInfo: 'Recruitment',
    contact: 'Contact Us',
    copyright: 'Copyright © 2024. GrowthSoft Inc. All rights reserved.',
    // Greeting Section
    greetingTitle: 'Greeting',
    greetingMission: '<strong>Mission and Goals</strong><br>At GrowthSoft, our top priority is the success of our clients\' businesses, and we are dedicated to providing innovative IT solutions. Utilizing our extensive experience and expertise across various industries, we strive to offer the best solutions.',
    greetingService: '<strong>Service Flexibility and Trust</strong><br>We aim to provide flexible and effective services tailored to the needs of our clients, consistently exceeding their expectations. We value building trust through the introduction of advanced technologies and continuous improvement.',
    greetingEmployee: '<strong>Employee Growth and Contribution</strong><br>Our success is supported by the growth and contribution of each employee. We create an environment where employees can fully utilize their abilities and continue to grow together, aiming for the development of the entire organization. With a spirit of respect and cooperation, we contribute to the success of our clients.',
    greetingFuture: '<strong>Challenges and Value Creation for the Future</strong><br>In a world where technology advances daily, we constantly challenge ourselves and strive to create new value. We promise to walk alongside our clients and open up new futures together. We sincerely ask for your continued support and patronage.',
    map: 'Access',
    mapcontext: 'GrowthSoft Inc.<br />102-0072<br />7F, Sankyo Building Main Tower, 1-7-10 Iidabashi, Chiyoda-ku, Tokyo<br />Phone: 03-6265-4936<br />Email: info@growthsoft.co.jp<br /><br />Access from nearby stations:<br />[Tozai Line]<br />5-minute walk from Exit 7 of Kudanshita Station<br />[Shinjuku Line / Hanzomon Line]<br />6-minute walk from Exit 3a of Kudanshita Station<br />[Tozai Line / Namboku Line / Oedo Line / Yurakucho Line]<br />5-minute walk from Exit A4 of Iidabashi Station<br />[JR Sobu Line]<br />6-minute walk from East Exit of JR Iidabashi Station',
    maplinks: 'View on Google Maps',
    mapcompanyName: 'GrowthSoft Inc.',
    mapaddress: '102-0072 <br />7F, Sankyo Building Main Tower, 1-7-10 Iidabashi, Chiyoda-ku, Tokyo',
    mapphone: 'Phone: 03-6265-4936',
    mapemail: 'Email: info@growthsoft.co.jp',
    mapcontextTitle: '<br />Access from nearby stations',
    mapcontext1: '<br />[Tozai Line] <br />5-minute walk from Exit 7 of Kudanshita Station',
    mapcontext2: '<br />[Shinjuku Line / Hanzomon Line] <br />6-minute walk from Exit 3a of Kudanshita Station',
    mapcontext3: '<br />[Tozai Line / Namboku Line / Oedo Line / Yurakucho Line] <br />5-minute walk from Exit A4 of Iidabashi Station',
    mapcontext4: '<br />[JR Sobu Line] <br />6-minute walk from the East Exit of JR Iidabashi Station',
    ceoName: 'Wang Qiang',
    // Vision Section
    visionTitle: 'Management Philosophy & Vision',
    visionMission: '<strong>Mission and Goals</strong><br>Our management philosophy is to grow and achieve a happy life by respecting each other with our clients, employees, and society as a whole. We always adhere to high ethical standards and contribute to the development of a sustainable society by building trust.',
    visionService: '<strong>Service Flexibility and Trust</strong><br>We provide superior technology and services to our clients, proposing solutions that exceed their expectations. We offer growth opportunities and a comfortable working environment for employees, respecting each individual\'s career path. We focus on environmental protection and community contributions, conducting sustainable business.',
    visionEmployee: '<strong>Employee Growth and Contribution</strong><br>We strive for a happy life while growing together with mutual respect. To achieve this vision, we approach our daily work with sincerity and passion.',
    // Company Profile Section
    companyProfileTitle: 'Company Overview',
    companyNameLabel: 'Company Name',
    companyName: 'GrowthSoft Inc.',
    capitalLabel: 'Capital',
    capital: '15,000,000 JPY',
    ceoLabel: 'Representative',
    foundedLabel: 'Established',
    founded: 'September 4, 2023',
    employeesLabel: 'Number of Employees',
    employees: '22',
    headquartersLabel: 'Headquarters',
    headquarters: '1-7-10 Iidabashi, Chiyoda-ku, Tokyo 102-0072, Yamakyu Building Main Building 7F',
    phoneLabel: 'Phone',
    phone: '03-6265-4936',
    banks: 'Banking Partners',
    bank1: 'Sumitomo Mitsui Banking Corporation',
    bank2: 'GMO Aozora Net Bank',
    qualifications: 'Qualifications',
    qualification1: 'Qualified Invoice　T8013301051315',
    qualification2: 'Registered Support Organization　24登-010800',
    qualification3: 'Paid Employment Placement　13-ユ-317559',
    qualification4: 'Worker dispatch　（派）13-318368',
    // Welfare Section
    welfareTitle: 'Welfare',
    insurance: 'Insurance',
    insuranceDetails: 'Health Insurance, Welfare Pension, Employment Insurance, Workers\' Accident Compensation Insurance, Childcare Contribution',
    vacation: 'Vacation',
    vacationDetails: 'Maternity Leave, Childcare Leave, Care Leave System, Flextime System, Short-time Work System (Pregnancy, Childcare, Nursing Care)',
    allowances: 'Allowances',
    allowancesDetails: 'Commuting Allowance, Attendance Allowance, Overtime Allowance, Housing Allowance, Year-end Special Duty Allowance, Qualification Acquisition Support, Seminar Fee Support',
    // History Section
    HistoryTitle: 'Company History',
    Historyyear1: 'September 4, 2023',
    Historyevent1: '・Established GrowthSoft Inc.',
    Historyyear2: 'April 15, 2024',
    Historyevent2: '・Moved headquarters to Iidabashi, Chiyoda-ku due to business expansion<br>・Increased capital to 5 million yen',
    Historyyear3: 'June 1, 2024',
    Historyevent3: '・Registered as a qualified invoice issuer',
    Historyyear4: 'August 31, 2024',
    Historyevent4: '・Achieved 35 million yen in sales revenue',
    Historyyear5: 'October 10, 2024',
    Historyevent5: '・Registered as a Certified Support Organization',
    Historyyear6: 'January 1, 2025',
    Historyevent6: '・Obtained license for fee-based employment placement services',
    Historyyear7: 'July 3, 2025',
    Historyevent7: '・Capital increased to 15 million yen',
    Historyyear8: 'August 31, 2025',
    Historyevent8: '・Achieved sales of 87.5 million yen',
    Historyyear9: 'January 1, 2026',
    Historyevent9: '・Obtained a labor dispatch business license',
    // Target Section
    TargetMainTitle: 'Management Goals',
    TargetTitle: 'Mid- to Long-Term Sales Targets',
    Targetyear: 'Year 1: 30 million yen<br>Year 2: 70 million yen<br>Year 3: 110 million yen',
    Targetyear1: 'Year 1: 30 million yen',
    Targetyear2: 'Year 2: 70 million yen',
    Targetyear3: 'Year 3: 110 million yen',
    // Other
    blank: '',
    line: '-',
    joinus: 'join us',
    mapTitle: 'MAP',
    home1: 'HOME',
    companyInfo1: 'Company',
    solutions1: 'Business',
    recruitmentInfo1: 'Recruit',
    contact1: 'Contact',
    language1: 'Language',
    language: 'Language',
    languages: {
      ja: '日本語',
      zh: '中文',
      en: 'English',
      ko: '한국어',
      vi: 'Tiếng Việt',
    },
    recruitment: {
      bannerTitle: '',
      bannerSubtitle: 'Let\'s respect each other and strive towards a happy life',
      bannerButton: 'See Details',
      title: 'Recruitment Information',
      description: 'GrowthSoft is accepting entries for the following positions.<br>Click on the job title to view the details.',
      applyButton: 'Apply',
      newGraduate: 'New Graduate Recruitment',
      careerRecruitment: 'Mid-career Recruitment',
      seconedGraduate: 'Seconed Graduate Recruitment',
      job1: {
        title: 'New Graduate Recruitment',
        details: [
          {
            title: 'Application Requirements',
            content: [
              {
                label: 'Required Qualifications',
                value: `
                  <li>Bachelor’s degree or higher (IT-related major required for vocational school graduates)</li>
                  <li>Good personality and strong communication skills</li>
                  <li>Ability to work cooperatively in a team</li>
                `
              }
            ]
          },
          {
            title: 'Compensation & Benefits',
            content: [
              {
                label: 'Expected Annual Salary',
                value: '3,000,000 to 4,000,000 yen<br>*Based on skill and experience'
              },
              {
                label: '',
                value: `
                  <li>Final decision based on our internal policy considering various factors</li>
                  <li>Probation period: 3 months (no change in employment conditions)</li>
                  <li>Annual salary review</li>
                  <li>Bonus: Twice a year (including possible year-end performance bonus)</li>
                `
              },
              {
                label: 'Holidays & Leave',
                value: `
                  <li>Five-day workweek (weekends and national holidays off)</li>
                  <li>Paid leave from the start (10 days in the first year)</li>
                  <li>New Year holiday</li>
                  <li>Bereavement leave</li>
                  <li>Maternity leave</li>
                  <li>Parental leave</li>
                  <li>Marriage leave</li>
                  <li>Nursing care leave</li>
                `
              },
              {
                label: 'Certification Support Program',
                value: `
                  Exam fees will be covered, and passing bonuses will range from 5,000 to 100,000 yen depending on the difficulty of the exam.<br><br>
                  Examples:
                  <li>Project Manager Exam: 80,000 yen</li>
                  <li>Applied IT Engineer Exam: 30,000 yen</li>
                  <li>Basic IT Engineer Exam: 10,000 yen</li>
                  <li>AWS Certified FOUNDATIONAL: 15,000 yen</li>
                  <li>AWS Certified ASSOCIATE: 30,000 yen</li>
                  <li>AWS Certified PROFESSIONAL: 50,000 yen</li>
                  <li>AWS Certified SPECIALTY: 50,000 yen</li>
                  <li>IT Passport: 5,000 yen</li>
                  <li>TOEIC: 20,000–80,000 yen</li>
                  <li>Other vendor certifications also supported (Cisco, Azure, GCP, Oracle, SAP, etc.)</li>
                `
              }
            ]
          },
          {
            title: 'Working Hours',
            content: '※ May vary depending on the project'
          },
          {
            title: 'Work Location',
            content: 'Tokyo / Kanagawa / Chiba / Saitama'
          }
        ]
      },
      job2: {
        title: 'Mid-Career Recruitment',
        details: [
          {
            title: 'Job Description',
            content: 'You will work as a System Engineer at our clients’ development sites (including enterprise companies, manufacturer-affiliated SIers, user-affiliated SIers), engaging in tasks such as requirements definition, basic design, detailed design, development, testing, and maintenance.'
          },
          {
            title: 'Application Requirements',
            content: [
              {
                label: 'Required Qualifications',
                value: `
                  <li>At least 1 year of experience in system development</li>
                  <li>Experience with programming and strong skills in languages such as Java, Python, or C++</li>
                `
              },
              {
                label: 'Preferred Skills & Experience',
                value: `
                  <li>Experience in system operation and maintenance, with recent development experience</li>
                  <li>Experience as a project manager (PM) or project leader (PL), or in training junior staff</li>
                  <li>Experience in developing web or mobile applications</li>
                  <li>Experience in database design and management</li>
                `
              }
            ]
          },
          {
            title: 'Compensation & Benefits',
            content: [
              {
                label: 'Expected Annual Salary',
                value: '5,000,000 to 10,000,000 yen<br>*Based on experience'
              },
              {
                label: '',
                value: `
                  <li>Final decision based on skills, experience, age, etc., according to our policy</li>
                  <li>Probation period: 3 months (no change in employment conditions)</li>
                  <li>Annual salary review</li>
                  <li>Bonus: Twice a year (including possible year-end performance bonus)</li>
                `
              },
              {
                label: 'Holidays & Leave',
                value: `
                  <li>Five-day workweek (weekends and national holidays off)</li>
                  <li>Paid leave from the start (10 days in the first year)</li>
                  <li>New Year holiday</li>
                  <li>Bereavement leave</li>
                  <li>Maternity leave</li>
                  <li>Parental leave</li>
                  <li>Marriage leave</li>
                  <li>Nursing care leave</li>
                `
              },
              {
                label: 'Certification Support Program',
                value: `
                  Exam fees will be covered, and passing bonuses will range from 5,000 to 100,000 yen depending on the difficulty of the exam.<br><br>
                  Examples:
                  <li>Project Manager Exam: 80,000 yen</li>
                  <li>Applied IT Engineer Exam: 30,000 yen</li>
                  <li>Basic IT Engineer Exam: 10,000 yen</li>
                  <li>AWS Certified FOUNDATIONAL: 15,000 yen</li>
                  <li>AWS Certified ASSOCIATE: 30,000 yen</li>
                  <li>AWS Certified PROFESSIONAL: 50,000 yen</li>
                  <li>AWS Certified SPECIALTY: 50,000 yen</li>
                  <li>IT Passport: 5,000 yen</li>
                  <li>TOEIC: 20,000–80,000 yen</li>
                  <li>Other vendor certifications also supported (Cisco, Azure, GCP, Oracle, SAP, etc.)</li>
                `
              }
            ]
          },
          {
            title: 'Working Hours',
            content: '※ May vary depending on the project'
          },
          {
            title: 'Work Location',
            content: 'Tokyo / Kanagawa / Chiba / Saitama'
          }
        ]
      },
      job3: {
        title: 'Second-Time New Graduate Recruitment',
        details: [
          {
            title: 'Application Requirements',
            content: [
              {
                label: 'Required Qualifications',
                value: `
                  <li>Bachelor’s degree or higher (IT-related major required for vocational school graduates)</li>
                  <li>Good personality and strong communication skills</li>
                  <li>Ability to work cooperatively in a team</li>
                `
              }
            ]
          },
          {
            title: 'Compensation & Benefits',
            content: [
              {
                label: 'Expected Annual Salary',
                value: '3,000,000 to 4,000,000 yen<br>*Based on skill and experience'
              },
              {
                label: '',
                value: `
                  <li>Final decision based on our internal policy considering various factors</li>
                  <li>Probation period: 3 months (no change in employment conditions)</li>
                  <li>Annual salary review</li>
                  <li>Bonus: Twice a year (including possible year-end performance bonus)</li>
                `
              },
              {
                label: 'Holidays & Leave',
                value: `
                  <li>Five-day workweek (weekends and national holidays off)</li>
                  <li>Paid leave from the start (10 days in the first year)</li>
                  <li>New Year holiday</li>
                  <li>Bereavement leave</li>
                  <li>Maternity leave</li>
                  <li>Parental leave</li>
                  <li>Marriage leave</li>
                  <li>Nursing care leave</li>
                `
              },
              {
                label: 'Certification Support Program',
                value: `
                  Exam fees will be covered, and passing bonuses will range from 5,000 to 100,000 yen depending on the difficulty of the exam.<br><br>
                  Examples:
                  <li>Project Manager Exam: 80,000 yen</li>
                  <li>Applied IT Engineer Exam: 30,000 yen</li>
                  <li>Basic IT Engineer Exam: 10,000 yen</li>
                  <li>AWS Certified FOUNDATIONAL: 15,000 yen</li>
                  <li>AWS Certified ASSOCIATE: 30,000 yen</li>
                  <li>AWS Certified PROFESSIONAL: 50,000 yen</li>
                  <li>AWS Certified SPECIALTY: 50,000 yen</li>
                  <li>IT Passport: 5,000 yen</li>
                  <li>TOEIC: 20,000–80,000 yen</li>
                  <li>Other vendor certifications also supported (Cisco, Azure, GCP, Oracle, SAP, etc.)</li>
                `
              }
            ]
          },
          {
            title: 'Working Hours',
            content: '※ May vary depending on the project'
          },
          {
            title: 'Work Location',
            content: 'Tokyo / Kanagawa / Chiba / Saitama'
          }
        ]
      },
      job4: {
        title: 'Staffing Support for Other Industries',
        details: [
          {
            title: 'Application Conditions',
            content: [
              {
                label: 'Required Conditions',
                value: `
                  <li>Good personality and strong communication skills</li>
                  <li>Ability to work cooperatively in a team</li>
                  <li>Ability to perform tasks quickly and accurately</li>
                  <li>Flexibility to adapt to new environments</li>
                `
              }
            ]
          },
          {
            title: 'Treatment',
            content: [
              {
                label: 'Expected Annual Income',
                value: '2.8 million to 4.5 million JPY<br>※Preferential treatment according to experience'
              },
              {
                label: '',
                value: `
                  <li>Determined according to company regulations, considering ability, experience, age, etc.</li>
                  <li>Probation period: Yes (3 months, no change in working conditions)</li>
                  <li>Salary increase: Once a year</li>
                  <li>Bonus: Twice a year (may provide settlement bonus)</li>
                `
              }
            ]
          },
          {
            title: 'Work Location',
            content: 'Tokyo/Kanagawa/Chiba/Saitama'
          }
        ]
      }
    },
    contactUs: {
      title: 'Contact Us',
      inquiryType: 'Inquiry Type',
      name: 'Name',
      lastName: 'Last Name',
      firstName: 'First Name',
      companyName: 'Company Name or Organization',
      departmentName: 'Department Name',
      email: 'Email Address',
      phone: 'Phone Number',
      message: 'Message',
      submitButton: 'Submit',
      required: 'Required',
      optional: 'Optional',
      select: 'Please Select',
      newGraduate: 'New Graduate Recruitment',
      careerRecruitment: 'Mid-career Recruitment',
      seconedGraduate: 'Seconed Graduate Recruitment',
      serviceInquiry: 'Service or Company Inquiry',
      other: 'Other',
      validationMessage: 'Please fill out this field.',
      successMessage: 'Message has been sent!',
      errorMessage: 'Message sending failed. Please try again.'
    },
    solutionInfo: {
      title: 'Services',
      overview: 'Overview',
      technicalFields: 'Technical Fields',
      services: 'Services',
      ses: {
        title: 'SES Business',
        description: 'Our company specializes in SES (System Engineering Services), offering comprehensive solutions from system development to operation and maintenance. We are capable of supporting a wide range of needs—from the development phase of a project to deployment, and long-term support.',
        description1: 'We also have many talented foreign engineers on our team, allowing us to deliver high-quality, cost-effective services. Feel free to contact us for a quote.',
        frontend: 'Frontend',
        languages: 'Development Languages',
        database: 'Database',
        frontendContent: 'Vue.js, React.js, Angular.js, etc.',
        languagesContent: 'Java, C, C++, C#, JavaScript, TypeScript, VB.NET, ASP.NET, COBOL, PHP, etc.',
        databaseContent: 'Oracle, MySQL, PostgreSQL, SQLserver, MongoDB, etc.'
      },
      appDev: {
        title: 'App Development',
        description: 'In the app development business, we plan, develop, and operate smartphone and web applications. We provide user-friendly applications utilizing the latest technology.',
        services: 'We offer comprehensive support from requirements definition, design, development, testing to release. We develop applications optimized for our clients\' business models, enhancing their competitiveness.'
      },
      skill: {
        title: 'Skills',
        description: 'Our team is highly adaptable and flexible, capable of handling various technical domains, and we propose optimal solutions tailored to the needs of a wide range of industries.',
        description1: 'For complex business challenges, we approach problem-solving with innovative and practical methods. We have extensive project experience in various sectors such as securities, banking, and insurance.',
        description2: 'Leveraging our past expertise, we respond quickly and optimally to specific customer requests. We are continuously working to enhance our technical capabilities.',
        environment: 'Development Environment',
        languages: 'Programming Languages',
        database: 'Databases',
        environmentContent: 'Windows, Linux, etc.',
        languagesContent: 'Java, C, C++, C#, JavaScript, TypeScript, VB.NET, ASP.NET, COBOL, PHP, etc.',
        databaseContent: 'Oracle, MySQL, PostgreSQL, SQL Server, MongoDB, etc.'
      },
      develop: {
        title: 'Development Achievements',
        Webtitle: 'Web-based',
        WebNameLabel1: 'Inventory Management System',
        WebNameLabel2: 'Product Management System',
        WebNameLabel3: 'Customer Management System',
        WebNameLabel4: 'Production Management System',
        WebNameLabel5: 'ATM Integration System',
        WebNameLabel6: 'Logistics System',
        WebNameLabel7: 'Infrastructure System',
        apptitle: 'Applications',
        appNameLabel1: 'iOS',
        appNameLabel2: 'Android',
        packagetitle: 'Package Implementation Support',
        packageNameLabel1: 'SAP',
        packageNameLabel2: 'Salesforce'
      },
      dispatch: {
        title: 'Staffing Support for Other Industries',
        description: 'The staffing support service for other industries provides excellent personnel with the necessary skills and experience to various industry companies. We quickly and accurately match the best personnel according to the business needs of our clients. Examples of industries include hotels, factories, and restaurants.',
        services: 'We provide comprehensive services from recruitment and selection to follow-up after starting work. We support the business success of our clients by providing appropriate personnel based on their business needs.'
      },
      t2solution: {
        title: 'Paid Job Placement Services',
        work01: 'IT Job Opportunities (In-house & Partner Companies)',
        description01: 'We introduce IT-related positions such as web development, AWS, and IT infrastructure, with a focus on Japanese and Chinese companies.',
        work02: 'Various Job Opportunities in Japan',
        description02: 'Includes roles in administration, translation, international trade, sales, and retail.',
        work03: 'Study Abroad Applications & Academic Guidance',
        description03: 'support for applying to Japanese language schools and consultations for entering universities and graduate schools in Japan.',
        work04: 'Specified Skilled Worker Visa Support',
        description04: 'Covers industries like food service, food processing.',
      },
      t1solution: {
        title: 'Registered Support Organization Services',
        work0: 'Document Preparation Assistance',
        work001: 'Creating Support Plans',
        description001: 'We help partner companies develop support plans for foreign workers with Specified Skilled Worker visas, covering both work and daily life support. Feel free to contact us for more details.',
        work002: 'Visa Status Change Documentation',
        description002: 'We provide all necessary documents for visa status change, and under the guidance of certified immigration specialists, we help prepare and submit paperwork to local immigration offices.',
        work1: '介護',
        description1a: '<strong>〈 分野、区分の概要 〉</strong><br> 高齢や障害で、生活をする時に介護が必要になった人たちへの身体介護等（介護を受ける人の状況にあわせて入浴、食事、排せつを助けること等）のほか、身体介護等に関係して助けが必要なしごと（レクリエーションの実施、リハビリテーションの補助等）<br>  ※介護を受ける人たちの家でするものは対象ではありません。',
        description1b: '<strong>〈 従事する主な業務 〉</strong><br> ・身体介護等（介護を受ける人の状況にあわせて入浴、食事、排せつを助けること等）<br> ・身体介護等に関係して助けが必要なしごと（レクリエーションの実施、リハビリテーションの補助等） ',
        description1c: '<strong>〈 想定される関連業務 〉</strong><br> 例：お知らせ等の掲示物の管理、物品の補充や管理',
        work2: 'ビルクリーニング',
        description2a: '<strong>〈 分野、区分の概要 〉</strong><br> 建築物内部の清掃',
        description2b: '<strong>〈 従事する主な業務 〉</strong><br> 多数の利用者が利用する建築物（住宅を除く。）の内部を対象に、衛生的環境の保護、美観の維持、安全の確保及び保全の向上を目的として、場所、部位、建材、汚れ等の違いに対し、方法、洗剤及び用具を適切に選択して清掃作業を行い、建築物に存在する環境上の物質を排除し、清潔さを維持する業務<br> ※床、浴室、トイレ、洗面台等の清掃からアメニティ補充やベッドメイク作業など、衛生かつ美観が整えられた客室を商品として納品するために必要な一連の業務である客室清掃業務は主な業務に含まれる。',
        description2c: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・複数の作業員の指導、現場の管理、計画作成や進行管理等<br>・清掃用機械器具の維持管理等に関する業務、技能実習責任者の業務、技能実習指導員の業務や、生活指導員の業務（それぞれ主たる業務に該当するものを除く。）<br>・建築物と構造上一体と見なせる部分（犬走・アプローチ等の外周部など）の清掃作業<br>・資機材倉庫の整備作業<br>・建物外部洗浄作業(外壁、屋上等。ただし高所作業を伴う窓ガラス・外壁清掃作業は除く。）<br>・ベッドメイク作業<br>・建築物内外の植裁管理作業（灌水作業等）<br>・資機材の運搬作業（他の現場に移動する場合等）',
        description2d: '<strong>〈 その他特記事項 〉</strong><br> ・詳細は以下の「ビルクリーニング分野特定技能外国人が従事できる業務について（令和５年 10 月 17 日ビルクリーニング分野特定技能協議会決定第１号）」を参照すること。',
        work3: '工業製品製造業',
        description3a: '（機械金属加工区分）',
        description3aa: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、素形材製品や産業機械等の製造工程の作業に従事',
        description3ab: '<strong>〈 従事する主な業務 〉</strong><br> 鋳造 ／ 鍛造 ／ ダイカスト ／ 機械加工 ／ 金属プレス加工 ／ 鉄工 ／ 工場板金 ／ 仕上げ ／ プラスチック成形 ／ 機械検査 ／ 機械保全 ／ 電気機器組立て ／ 塗装 ／ 溶接 ／ 工業包装 ／強化プラスチック成形 ／ 金属熱処理業',
        description3ac: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3b: '（電気電子機器組立て区分）',
        description3ba: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、電気電子機器等の製造工程、組立工程の作業に従事',
        description3bb: '<strong>〈 従事する主な業務 〉</strong><br> 機械加工 ／ 仕上げ ／ プラスチック成形 ／ プリント配線板製造 ／ 電子機器組立て ／ 電気機器組立て ／ 機械検査 ／ 機械保全 ／ 工業包装 ／強化プラスチック成形',
        description3bc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3c: '（金属表面処理区分）',
        description3ca: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、表面処理等の作業に従事',
        description3cb: '<strong>〈 従事する主な業務 〉</strong><br> めっき ／ アルミニウム陽極酸化処理',
        description3cc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3d: '（紙器・段ボール箱製造区分）',
        description3da: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、紙器・段ボール箱の製造工程の作業に従事',
        description3db: '<strong>〈 従事する主な業務 〉</strong><br> 紙器・段ボール箱製造',
        description3dc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3e: '（コンクリート製品製造区分）',
        description3ea: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、コンクリート製品の製造工程の作業に従事',
        description3eb: '<strong>〈 従事する主な業務 〉</strong><br> コンクリート製品製造 ',
        description3ec: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3f: '（RPF製造区分）',
        description3fa: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、破砕・成形等の作業に従事　',
        description3fb: '<strong>〈 従事する主な業務 〉</strong><br> ＲＰＦ製造',
        description3fc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3g: '（陶磁器製品製造区分）',
        description3ga: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、陶磁器製品の製造工程の作業に従事',
        description3gb: '<strong>〈 従事する主な業務 〉</strong><br> 陶磁器工業製品製造',
        description3gc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3h: '（印刷・製本区分）',
        description3ha: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、オフセット印刷、グラビア印刷、製本の製造工程の作業に従事 ',
        description3hb: '<strong>〈 従事する主な業務 〉</strong><br> 印刷 ／ 製本',
        description3hc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3i: '（紡織製品製造区分）',
        description3ia: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、紡織製品の製造工程の作業に従事',
        description3ib: '<strong>〈 従事する主な業務 〉</strong><br> 紡績運転 ／ 織布運転 ／ 染色 ／ ニット製品製造 ／ たて編ニット生地製造 ／カーペット製造 ',
        description3ic: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3j: '（縫製区分）',
        description3ja: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、縫製工程の作業に従事',
        description3jb: '<strong>〈 従事する主な業務 〉</strong><br> 婦人子供服製造 ／ 紳士服製造 ／ 下着類製造 ／ 寝具製作 ／ 帆布製品製造 ／布はく縫製 ／ 座席シート縫製',
        description3jc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        work4: '建設',
        description4a: '（土木区分）',
        description4aa: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示・監督を受けながら、土木施設の新設、改築、維持、修繕に係る作業等に従事',
        description4ab: '<strong>〈 従事する主な業務 〉</strong><br> 型枠施工 ／ コンクリート圧送 ／ トンネル推進工 ／ 建設機械施工 ／ 土工 ／ 鉄筋施工 ／ とび ／ 海洋土木工<br> その他、土木施設の新設、改築、維持、修繕に係る作業',
        description4ac: '<strong>〈 想定される関連業務 〉</strong><br>・原材料・部品の調達・搬送<br>・機器・装置・工具等の保守管理<br>・足場の組立て、設備の掘り起こしその他の後工程の準備作業<br>・足場の解体、設備の埋め戻しその他の前工程の片付け作業<br>・清掃・保守管理作業<br>・その他、主たる業務に付随して行う作業',
        description4ad: '<strong>〈 その他特記事項 〉</strong><br> 業務の詳細については、以下の国土交通省のウェブサイト中「◆業務区分と試験及び技能実習等との対応関係」の「業務区分と建設業許可工事業との対応関係」をご覧ください。',
        description4b: '（建築区分）',
        description4ba: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示・監督を受けながら、建築物の新築、増築、改築若しくは移転又は修繕若しくは模様替に係る作業等に従事',
        description4bb: '<strong>〈 従事する主な業務 〉</strong><br> 型枠施工 ／ 左官 ／ コンクリート圧送 ／ 屋根ふき ／ 土工 ／ 鉄筋施工 ／ 鉄筋継手 ／ 内装仕上げ ／ 表装 ／ とび ／ 建築大工 ／ 建築板金 ／ 吹付ウレタン断熱<br>その他、建築物の新築、増築、改築若しくは移転、修繕又は模様替に係る作業',
        description4bc: '<strong>〈 想定される関連業務 〉</strong><br>・原材料・部品の調達・搬送<br>・機器・装置・工具等の保守管理<br>・足場の組立て、設備の掘り起こしその他の後工程の準備作業<br>・足場の解体、設備の埋め戻しその他の前工程の片付け作業<br>・清掃・保守管理作業<br>・その他、主たる業務に付随して行う作業',
        description4bd: '<strong>〈 その他特記事項 〉</strong><br> 業務の詳細については、以下の国土交通省のウェブサイト中「◆業務区分と試験及び技能実習等との対応関係」の「業務区分と建設業許可工事業との対応関係」をご覧ください。',
        description4c: '（ライフライン・設備区分）',
        description4ca: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示・監督を受けながら、電気通信、ガス、水道、電気その他のライフライン・設備の整備・設置、変更又は修理に係る作業等に従事',
        description4cb: '<strong>〈 従事する主な業務 〉</strong><br> 電気通信 ／ 配管 ／ 建築板金 ／ 保温保冷<br>その他、ライフライン・設備の整備・設置、変更又は修理に係る作業',
        description4cc: '<strong>〈 想定される関連業務 〉</strong>・原材料・部品の調達・搬送<br>・機器・装置・工具等の保守管理<br>・足場の組立て、設備の掘り起こしその他の後工程の準備作業<br>・足場の解体、設備の埋め戻しその他の前工程の片付け作業<br>・清掃・保守管理作業<br>・その他、主たる業務に付随して行う作業',
        description4cd: '<strong>〈 その他特記事項 〉</strong><br> 業務の詳細については、以下の国土交通省のウェブサイト中「◆業務区分と試験及び技能実習等との対応関係」の「業務区分と建設業許可工事業との対応関係」をご覧ください。',
        work5: '造船・舶用工業',
        description5a: '（造船区分）',
        description5aa: '<strong>〈 分野、区分の概要 〉</strong><br> 造船（監督者の指示を理解し又は自らの判断により船舶の製造工程の作業に従事）',
        description5ab: '<strong>〈 従事する主な業務 〉</strong><br> 溶接 ／ 塗装 ／ 鉄工 ／ とび ／ 配管 ／ 船舶加工',
        description5ac: '<strong>〈 想定される関連業務 〉</strong><br>・読図作業<br>・作業工程管理<br>・検査（外観、寸法、材質、強度、非破壊、耐圧気密等）<br>・機器・装置・工具の保守管理<br>・機器・装置・運搬機の運転<br>・資材の材料管理・配置<br>・部品・製品の養生<br>・足場の組立て・解体<br>・廃材処理<br>・梱包・出荷<br>・資材・部品・製品の運搬<br>・入出渠<br>・清掃',
        description5ad: '<strong>〈 その他特記事項 〉</strong><br> 業務の詳細については、以下の国土交通省のウェブサイトをご覧ください。',
        description5b: '（舶用機械区分）',
        description5ba: '<strong>〈 分野、区分の概要 〉</strong><br> 舶用機械（監督者の指示を理解し又は自らの判断により舶用機械の製造工程の作業に従事）',
        description5bb: '<strong>〈 従事する主な業務 〉</strong><br> 溶接 ／ 塗装 ／ 鉄工 ／ 仕上げ ／ 機械加工 ／ 配管 ／ 鋳造 ／ 金属プレス加工 ／強化プラスチック成形 ／ 機械保全 ／ 船用機械加工',
        description5bc: '<strong>〈 想定される関連業務 〉</strong><br>・読図作業<br>・作業工程管理<br>・検査（外観、寸法、材質、強度、非破壊、耐圧気密等）<br>・機器・装置・工具の保守管理<br>・機器・装置・運搬機の運転<br>・資材の材料管理・配置<br>・部品・製品の養生<br>・足場の組立て・解体<br>・廃材処理<br>・梱包・出荷<br>・資材・部品・製品の運搬<br>・入出渠<br>・清掃',
        description5bd: '<strong>〈 その他特記事項 〉</strong><br> 業務の詳細については、以下の国土交通省のウェブサイトをご覧ください。',
        description5c: '（舶用電気電子機器区分）',
        description5ca: '<strong>〈 分野、区分の概要 〉</strong><br> 舶用電気電子機器（監督者の指示を理解し又は自らの判断により舶用電気電子機器の製造工程の作業に従事）',
        description5cb: '<strong>〈 従事する主な業務 〉</strong><br> 機械加工 ／ 電気機器組立て ／ 金属プレス加工 ／ 電子機器組み立て ／プリント配線板製造 ／ 配管 ／ 機器保全 ／ 船用電気電子機器加工　',
        description5cc: '<strong>〈 想定される関連業務 〉</strong><br>・読図作業<br>・作業工程管理<br>・検査（外観、寸法、材質、強度、非破壊、耐圧気密等）<br>・機器・装置・工具の保守管理<br>・機器・装置・運搬機の運転<br>・資材の材料管理・配置<br>・部品・製品の養生<br>・足場の組立て・解体<br>・廃材処理<br>・梱包・出荷<br>・資材・部品・製品の運搬<br>・入出渠<br>・清掃',
        description5cd: '<strong>〈 その他特記事項 〉</strong><br> 業務の詳細については、以下の国土交通省のウェブサイトをご覧ください。',
        work6: '自動車整備',
        description6a: '<strong>〈 分野、区分の概要 〉</strong><br> 自動車の日常点検整備、定期点検整備、特定整備、特定整備に付随する業務',
        description6b: '<strong>〈 従事する主な業務 〉</strong><br> 自動車の日常点検整備、定期点検整備、特定整備、特定整備に付随する業務（電子制御装置の整備や鈑金塗装など）の基礎的な業務',
        description6c: '<strong>〈 想定される関連業務 〉</strong><br>・整備内容の説明及び関連部品の販売<br>・部品番号検索・部内発注作業<br>・ナビ・ＥＴＣ等の電装品の取付作業<br>・洗車作業<br>・下廻り塗装作業<br>・車内清掃作業<br>・構内清掃作業<br>・部品等運搬作業<br>・設備機器等清掃作業',
        work7: '航空',
        description7a: '（空港グランドハンドリング区分）',
        description7aa: '<strong>〈 分野、区分の概要 〉</strong><br> 航空機の地上走行支援業務、手荷物・貨物取扱業務等',
        description7ab: '<strong>〈 従事する主な業務 〉</strong><br> 指導者やチームリーダーの下に行う<br>・航空機地上走行支援業務<br>・手荷物・貨物取扱業務<br>・手荷物・貨物の航空機搭降載業務<br>・航空機内外の清掃整備業務',
        description7ac: '<strong>〈 想定される関連業務 〉</strong><br>・事務作業<br>・作業場所の整理整頓や清掃<br>・積雪時における作業場所の除雪',
        description7b: '（航空機整備区分）',
        description7ba: '<strong>〈 分野、区分の概要 〉</strong><br> 航空機の機体、装備品等の整備業務等',
        description7bb: '<strong>〈 従事する主な業務 〉</strong><br> 国家資格整備士等の指導・監督の下、機体や装備品等の整備業務のうち基礎的な作業（簡単な点検や交換作業等）<br>・運航整備（空港に到着した航空機に対して、次のフライトまでの間に行う整備）<br>・機体整備（通常1～1年半毎に実施する、約1～2週間にわたり機体の隅々まで行う整備）<br>・装備品・原動機整備（航空機から取り下ろされた脚部や動翼、 飛行・操縦に用いられる計器類等及びエンジンの整備）',
        description7bc: '<strong>〈 想定される関連業務 〉</strong><br>・事務作業<br>・作業場所の整理整頓や清掃<br>・積雪時における作業場所の除雪',
        work8: '宿泊',
        description8a: '<strong>〈 分野、区分の概要 〉</strong><br> 旅館やホテルにおけるフロント、企画・広報、接客及びレストランサービス等の宿泊サービスの提供業務',
        description8b: '<strong>〈 従事する主な業務 〉</strong><br> ・フロント業務（チェックイン/アウト、周辺の観光地情報の案内、ホテル発着ツアーの手配　等）<br>・企画・広報業務（キャンペーン・特別プランの立案、館内案内チラシの作成、HP、SNS等による情報発信　等）<br>・接客業務（旅館やホテル内での案内、宿泊客からの問い合わせ対応 等）<br>・レストランサービス業務（注文への応対やサービス（配膳・片付け）、料理の下ごしらえ・盛りつけ等の業務　等）',
        description8c: '<strong>〈 想定される関連業務 〉</strong><br> 旅館やホテル内における販売、備品の点検・交換等',
        work9: '自動車運送業',
        description9a: '（バス運転者区分）',
        description9aa: '<strong>〈 分野、区分の概要 〉</strong><br> 運行管理者等の指導・監督の下、一般乗合旅客自動車運送事業、一般貸切旅客自動車運送事業又は特定旅客自動車運送事業における運行前後の車両点検、安全な旅客の輸送、乗務記録の作成や乗客対応等に従事',
        description9ab: '<strong>〈 従事する主な業務 〉</strong><br> ・運行業務（運行前後の車両点検、安全な旅客の輸送、乗務記録の作成等）<br>・接遇業務（乗客対応等）',
        description9ac: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br>関連業務に当たり得るものとして、次が想定される。<br>・車内清掃作業<br>・営業所内清掃作業<br>・運賃精算、管理<br>・その他、主たる業務に付随して行う作業<br>※専ら関連業務に従事することは認められない。',
        description9b: '（タクシー運転者区分）',
        description9ba: '<strong>〈 分野、区分の概要 〉</strong><br> 運行管理者等の指導・監督の下、一般乗用旅客自動車運送事業における運行前後の車両点検、安全な旅客の輸送、乗務記録の作成や乗客対応等に従事',
        description9bb: '<strong>〈 従事する主な業務 〉</strong><br> ・運行業務（運行前後の車両点検、安全な旅客の輸送、乗務記録の作成等）<br>・接遇業務（乗客対応等）',
        description9bc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br>関連業務に当たり得るものとして、次が想定される。<br>・車内清掃作業<br>・営業所内清掃作業<br>・運賃精算、管理<br>・その他、主たる業務に付随して行う作業<br>※専ら関連業務に従事することは認められない。',
        description9c: '（トラック運転者区分）',
        description9ca: '<strong>〈 分野、区分の概要 〉</strong><br> 運行管理者等の指導・監督の下、貨物自動車運送事業における運行前後の車両点検、安全な貨物の輸送、乗務記録の作成や荷崩れを起こさない貨物の積付け等に従事',
        description9cb: '<strong>〈 従事する主な業務 〉</strong><br> ・運行業務（運行前後の車両点検、安全な旅客の輸送、乗務記録の作成等）<br>・接遇業務（乗客対応等）',
        description9cc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br>関連業務に当たり得るものとして、次が想定される。<br>・車内清掃作業<br>・営業所内清掃作業<br>・運賃精算、管理<br>・その他、主たる業務に付随して行う作業<br>※専ら関連業務に従事することは認められない。',
        work10: '鉄道',
        description10a: '（軌道整備区分）',
        description10aa: '<strong>〈 分野、区分の概要 〉</strong><br> 軌道整備（軌道等の新設、改良、修繕に係る作業・検査業務等）',
        description10ab: '<strong>〈 従事する主な業務 〉</strong><br> 以下を例とする軌道等の新設、改良、修繕に係る作業・検査業務が対象となる。<br>・軌道検測作業（高低、通り等軌道の変位を測定する作業）<br>・レール交換作業（新旧レール交換 ／ 付帯作業（吊り上げ作業等））<br>・まくらぎ交換作業（新旧まくらぎ交換 ／ 付帯作業（道床掘削作業等））<br>・バラストを取り扱う作業（バラスト掘削及び埋戻し ／ 道床形状の形成 ／ つき固めや通り整正に伴う作業等）<br>・保安設備を取り扱う作業等（脱線防止ガード等保安設備の取り付け（交換・撤去・復旧等） ／ 付帯作業（締結装置の緊張・緩解作業等））',
        description10ac: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・事務作業<br>・作業場所の整理整頓や清掃',
        description10b: '（電気設備整備区分）',
        description10ba: '<strong>〈 分野、区分の概要 〉</strong><br> 電気設備整備（電路設備、変電所等設備、電気機器等設備、信号保安設備、保安通信設備、踏切保安設備等の新設、改良、修繕に係る作業・検査業務等）',
        description10bb: '<strong>〈 従事する主な業務 〉</strong><br> 以下の設備の新設、改良、修繕に係る作業、検査業務等が対象となる。<br>・電路設備（電車線、送電線、配電線等）<br>・変電所等設備（遮断装置、変圧器、整流器、避雷器、保護装置、接地装置、消火設備等）<br>・電気機器等設備（配電盤、開閉器、電源装置、照明設備、電気掲示器、電気融雪器等）<br>・信号保安設備（信号装置、転てつ装置、連動装置、列車検知装置、自動列車停止装置等）<br>・保安通信設備（交換装置、搬送装置、無線装置、端末装置、通信線等）<br>・踏切保安設備（踏切遮断機、踏切警報機、踏切警報時間制御装置、踏切支障報知装置、障害物検知装置等）<br>※上記設備の支持物、ケーブル、管路、配線等を含む',
        description10bc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・事務作業<br>・作業場所の整理整頓や清掃',
        description10c: '（車両整備区分）',
        description10ca: '<strong>〈 分野、区分の概要 〉</strong><br> 車両整備（鉄道車両の整備業務等）',
        description10cb: '<strong>〈 従事する主な業務 〉</strong><br> 以下を例とする業務等が対象となる。<br>・列車検査、定期検査、臨時検査（空調装置、集電装置、走行装置、ブレーキ装置、空気装置、電気装置、動力発生装置、保安装置、車体、乗務員室・客室に関わる装置、連結装置等や車両部品の検査、修繕等（解ぎ装等作業や消耗品の補充を含む））<br>・構内入換（車両基地等での車両の入換や誘導等）<br>・駅派出対応（駅等における車両の検査・修繕等）<br>・改造工事（車両の改造や改良工事等）<br>・定期・臨時清掃業務（車両基地における車両の清掃等）<br>・在庫・予備品管理、工場設備取扱い<br>・上記に関する材料や部品、装置等の管理及び設備の操作・管理',
        description10cc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・事務作業<br>・作業場所の整理整頓や清掃',
        description10d: '（車両製造区分）',
        description10da: '<strong>〈 分野、区分の概要 〉</strong><br> 車両製造（鉄道車両、鉄道車両部品等の製造業務等）',
        description10db: '<strong>〈 従事する主な業務 〉</strong><br> 以下を例とする業務等が対象となる。<br>・素材加工（シートモケット加工 ／ 台車枠、構体部品加工等）<br>・部品組立て作業（輪軸（駆動装置）、配電盤等電気機器組立て ／ ドア、窓、ほろ、シート等内装設備品組立て等）<br>・構体組立て（台枠、屋根構体、側構体及び妻構体組立て ／ 構体（六面体）組立て等）<br>・塗装<br>・溶接<br>・ぎ装（機器取付け、配線、配管 ／ ドア、窓、天井、トイレ設備等内装部品取付け）<br>・台車枠製造<br>・台車組立て<br>・電子機器組立て（運転保安装置(ＡＴＣ装置やＡＴＳ装置)、制御装置、モニタ装置等の組立て）<br>・電気機器組立て（継電器等を使用した配電盤等の組立て）<br>・試験・検査（機能検査等）<br>・部品検収・配膳業務（倉庫管理及び部品等運搬等）',
        description10dc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・事務作業<br>・作業場所の整理整頓や清掃',
        description10e: '（運輸係員区分）',
        description10ea: '<strong>〈 分野、区分の概要 〉</strong><br> 運輸係員（駅係員、車掌、運転士等）',
        description10eb: '<strong>〈 従事する主な業務 〉</strong><br> 以下を例とする業務等が対象となる。<br>・ポイント操作（列車等の進路を決めるポイント操作、列車の進路に合わせた適正な鉄道信号の現示又は表示）<br>・入換え合図（列車等の転線、連結・分割等を行うための係員への合図）<br>・駅設備管理・取扱業務（駅の券売機・改札機等の管理、操作 ／ 設備故障時の一次修理対応）<br>・旅客案内・貨物取扱業務（通常時・異常時のホーム上安全確認や旅客案内 ／ 振替輸送時等の旅客案内 ／ 貨物の受付、一時留置場所・積載列車等の指定等）<br>・運行管理業務（列車ダイヤと列車運行の確認・管理 ／ 異常時における運休や増発の列車指定）<br>・車掌業務（列車内の旅客案内、運転士への合図 ／ 事故防止等に必要な安全確認 ／ 事故発生時の列車防護等による事故拡大防止等の対処を行う ／ 異常発生時等の避難誘導等）<br>・運転士業務（列車の運転には動力車操縦者運転免許要す）（列車等の運転（ワンマン列車運転の場合は車掌業務も兼任））',
        description10ec: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・事務作業<br>・作業場所の整理整頓や清掃',
        work11: '農業',
        description11a: '（耕種農業区分）',
        description11aa: '<strong>〈 分野、区分の概要 〉</strong><br> 栽培管理、農産物の集出荷・選別等の農作業',
        description11ab: '<strong>〈 従事する主な業務 〉</strong><br>・各作物に応じた土壌づくり<br>・施肥作業<br>・種子、苗木の取扱い<br>・資材、装置の取扱い<br>・栽培に関する作業<br>・安全衛生業務　等',
        description11ac: '<strong>〈 想定される関連業務 〉</strong><br>・特定技能所属機関（労働者派遣形態の場合は派遣先事業者）が生産した農畜産物を原料又は材料の一部として使用する製造又は加工の作業<br>・特定技能所属機関（労働者派遣形態の場合は派遣先事業者）による農畜産物の生産に伴う副産物（稲わら、家畜排泄物等）を原料又は材料の一部として使用する製造又は加工の作業<br>・農畜産物（特定技能所属機関（労働者派遣形態の場合は派遣先事業者）が生産した農畜産物が含まれる場合に限る。）の運搬、陳列又は販売の作業<br>・農畜産物を原料又は材料として製造され、又は加工された物（特定技能所属機関（労働者派遣形態の場合は派遣先事業者）が生産した農畜産物を原料又は材料の一部として使用し、製造され、又は加工された物が含まれる場合に限る。）の運搬、陳列又は販売の作業<br>・農畜産物の生産に伴う副産物を原料又は材料として製造され、又は加工された物（特定技能所属機関（労働者派遣形態の場合は派遣先事業者）による農畜産物の生産に伴う副産物を原料又は材料の一部として使用し、製造され、又は加工された物（たい肥等の肥料、飼料等）が含まれる場合に限る。）の運搬、陳列又は販売の作業<br>・その他特定技能所属機関（労働者派遣形態の場合は派遣先事業者）で耕種農業又は畜産農業の業務に従事する日本人が通常従事している作業（畜産農業と耕種農業を複合経営している特定技能所属機関（労働者派遣形態の場合は派遣先事業者）において畜産農業の技能を有する特定技能外国人が耕種農業の作業に従事する場合、冬場の除雪作業に従事する場合等）',
        description11b: '（畜産農業区分）',
        description11ba: '<strong>〈 分野、区分の概要 〉</strong><br> 飼養管理、畜産物の集出荷・選別等の農作業',
        description11bb: '<strong>〈 従事する主な業務 〉</strong><br>・各畜種に応じた器具の取扱い<br>・個体の取扱い、観察<br>・飼養管理<br>・生産物の取扱い<br>・安全衛生業務　等',
        description11bc: '<strong>〈 想定される関連業務 〉</strong><br>・特定技能所属機関（労働者派遣形態の場合は派遣先事業者）が生産した農畜産物を原料又は材料の一部として使用する製造又は加工の作業<br>・特定技能所属機関（労働者派遣形態の場合は派遣先事業者）による農畜産物の生産に伴う副産物（稲わら、家畜排泄物等）を原料又は材料の一部として使用する製造又は加工の作業<br>・農畜産物（特定技能所属機関（労働者派遣形態の場合は派遣先事業者）が生産した農畜産物が含まれる場合に限る。）の運搬、陳列又は販売の作業<br>・農畜産物を原料又は材料として製造され、又は加工された物（特定技能所属機関（労働者派遣形態の場合は派遣先事業者）が生産した農畜産物を原料又は材料の一部として使用し、製造され、又は加工された物が含まれる場合に限る。）の運搬、陳列又は販売の作業<br>・農畜産物の生産に伴う副産物を原料又は材料として製造され、又は加工された物（特定技能所属機関（労働者派遣形態の場合は派遣先事業者）による農畜産物の生産に伴う副産物を原料又は材料の一部として使用し、製造され、又は加工された物（たい肥等の肥料、飼料等）が含まれる場合に限る。）の運搬、陳列又は販売の作業<br>・その他特定技能所属機関（労働者派遣形態の場合は派遣先事業者）で耕種農業又は畜産農業の業務に従事する日本人が通常従事している作業（畜産農業と耕種農業を複合経営している特定技能所属機関（労働者派遣形態の場合は派遣先事業者）において畜産農業の技能を有する特定技能外国人が耕種農業の作業に従事する場合、冬場の除雪作業に従事する場合等）',
        work12: '漁業',
        description12a: '（漁業区分）',
        description12aa: '<strong>〈 分野、区分の概要 〉</strong><br> 漁具の製作・補修、水産動植物の探索、漁具・漁労機械の操作、水産動植物の採捕、漁獲物の処理・保蔵、安全衛生の確保等',
        description12ab: '<strong>〈 従事する主な業務 〉</strong><br>・釣りによる方法を主とした魚介類の捕獲(延縄漁、カツオ一本釣り漁、イカ釣り漁　等)<br>・網やカゴによる方法を主とした魚介類の捕獲(定置網漁、まき網漁、曳網漁　等)<br>・漁具（網、カゴ等）の修理作業<br>・ソナーや魚群探知機による魚群の探索<br>・漁に使用する網・縄を巻き上げる機械(ネット・ラインホーラー)、自動イカ釣り機等の機械操作<br>・漁獲物の選別、函詰め、冷凍作業、下処理<br>・漁港での漁獲物や漁具等の荷揚げ作業　等',
        description12ac: '<strong>〈 想定される関連業務 〉</strong><br>・漁具・漁労機械の点検・換装<br>・船体の補修・清掃<br>・魚倉、漁具保管庫、番屋の清掃<br>・漁船への餌、氷、燃油、食材、日用品その他の操業・生活資材の仕込み・積込み<br>・出漁に係る炊事・賄い<br>・採捕した水産動植物の生簀における畜養その他付随的な養殖<br>・自家生産物の運搬・陳列・販売<br>・自家生産物又は当該生産に伴う副産物を原料又は材料の一部として使用する製造・加工及び当該製造物・加工物の運搬・陳列・販売<br>・魚市場・陸揚港での漁獲物の選別・仕分け<br>・体験型漁業の際に乗客が行う水産動植物の採捕の補助<br>・社内外における研修',
        description12b: '（養殖業区分）',
        description12ba: '<strong>〈 分野、区分の概要 〉</strong><br> 養殖資材の製作・補修・管理、養殖水産動植物の育成管理、養殖水産動植物の収獲（穫）・処理、安全衛生の確保等',
        description12bb: '<strong>〈 従事する主な業務 〉</strong><br>・魚類や貝類、藻類などの育成<br>・養殖魚の給餌、死んだ魚や残餌等の除去<br>・養殖貝類の付着物の清掃<br>・養殖水産動植物の収獲（穫）、魚市場や陸揚港への運搬作業<br>・養殖貝類の殻剥き<br>・養殖池や網の清掃、水質等の管理<br>・養殖筏の製作、補修<br>・養殖水産動植物の種苗の生産、採捕　等',
        description12bc: '<strong>〈 想定される関連業務 〉</strong><br>・漁具・漁労機械の点検・換装<br>・船体の補修・清掃<br>・魚倉、漁具保管庫・番屋の清掃<br>・漁船への餌、氷、燃油、食材、日用品その他の操業・生活資材の仕込み・積込み<br>・養殖用の機械・設備・器工具等の清掃・消毒・管理・保守<br>・鳥獣に対する駆除、追払、防護ネット・テグス張り等の養殖場における食害防止<br>・養殖水産動植物の餌となる水産動植物や養殖用稚魚の採捕その他付随的な漁業<br>・自家生産物の運搬・陳列・販売<br>・自家生産物又は当該生産に伴う副産物を原料又は材料の一部として使用する製造・加工及び当該製造物・加工物の運搬・陳列・販売<br>・魚市場・陸揚港での漁獲物の選別・仕分け<br>・体験型漁業の際に乗客が行う水産動植物の採捕の補助<br>・社内外における研修',
        work13: '飲食料品製造業',
        description13a: '<strong>〈 分野、区分の概要 〉</strong><br> 飲食料品（酒類を除く。）の製造・加工、安全衛生の確保',
        description13b: '<strong>〈 従事する主な業務 〉</strong><br>・原料の処理、加熱、殺菌、成形、乾燥などの、生産に関わる一連の作業など<br>・業務で使う機械の安全確認や、作業者の衛生管理などの、業務上の安全衛生と食品衛生を守るための業務',
        description13c: '<strong>〈 想定される関連業務 〉</strong><br>・原料の調達・受入れ<br>・製品の納品<br>・清掃<br>・事業所の管理の作業',
        work14: '外食業',
        description14a: '<strong>〈 分野、区分の概要 〉</strong><br> 飲食物調理、接客、店舗管理',
        description14b: '<strong>〈 従事する主な業務 〉</strong><br>・飲食物調理（客に提供する飲食料品の調理、調製、製造を行うもの）<br> 例：食材仕込み、加熱調理、非加熱調理、調味、盛付け、飲食料品の調製等<br>・接客（客に飲食料品を提供するために必要な飲食物調理以外の業務を行うもの）<br> 例：席への案内、メニュー提案、注文伺い、配膳、下膳、カトラリーセッティング、代金受取り、商品セッティング、商品の受渡し、食器・容器等の回収、予約受付、客席のセッティング、苦情等への対応、給食事業所における提供先との連絡・調整 等<br>・店舗管理（店舗の運営に必要となる上記２業務以外のもの）<br> 例：店舗内の衛生管理全般、従業員のシフト管理、求人・雇用に関する事務、従業員の指導・研修に関する事務、予約客情報・顧客情報の管理、レジ・券売機管理、会計事務管理、社内本部・取引事業者・行政等との連絡調整、各種機器・設備のメンテナンス、食材・消耗品・備品の補充、発注、検品又は数量管理、メニューの企画・開発、メニューブック・POP 広告等の作成、宣伝・広告の企画、店舗内外・全体の環境整備、店内オペレーションの改善、作業マニュアルの作成・改訂等',
        description14c: '<strong>〈 想定される関連業務 〉</strong><br>・店舗において原材料として使用する農林水産物の生産<br>・客に提供する調理品等以外の物品の販売',
        work15: '林業',
        description15a: '<strong>〈 分野、区分の概要 〉</strong><br> 森林において樹木を育てて丸太を生産し、苗木を植える等の作業に従事',
        description15b: '<strong>〈 従事する主な業務 〉</strong><br>・苗木を植え、樹木を育てる作業<br>・丸太を生産する作業 等',
        description15c: '<strong>〈 想定される関連業務 〉</strong><br>当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次のものなどが想定される。<br>・生産した丸太を使用して行う加工等の作業<br>・丸太の生産に伴う副産物（樹皮、つる等）を使用して行う製造等の作業<br>・機器・装置・工具等の保守管理<br>・資材の管理・運搬<br>・事業所等の清掃作業',
        work16: '木材産業',
        description16a: '<strong>〈 分野、区分の概要 〉</strong><br> 木材・木製品の製造・加工<br>（家具や建具などの装備品を除く。）',
        description16b: '<strong>〈 従事する主な業務 〉</strong><br> 製材／単板（ベニヤ）製造／木材チップ製造／合板製造／集成材製造／プレカット加工／銘木製造／床板製造',
        description16c: '<strong>〈 想定される関連業務 〉</strong><br>・原材料（原木・資材）の調達・受入れ作業<br>・製品の検査<br>・製品の出荷作業（運搬・梱包・積込み）<br>・作業場所の整理整頓や清掃',
      }
    }
  },
  ko: {
    // HomePage
    bannerTitle : '안전하고 신뢰할 수있는 디지털 사회 실현을 향한 미래 구축',
    bannerSubtitle: 'Building the future toward the realization of a safe and reliable digital society',
    ourServices: '사업',
    pickUp: '추천',
    // Navigation Buttons
    greeting: '인사말<br>대표 인사',
    vision: '비전<br>경영 철학 및 비전',
    companyProfile: '회사 개요<br>회사 프로필',
    welfare: '복지<br>복리 후생',
    target: '목표<br>경영 목표', 
    history: '역사<br>연혁',
    // NavBar
    achievementsNavBar: '개발 실적',
    companyNavBar: '모든 회사 정보',
    visionNavBar: '경영 철학 및 비전',
    companyProfileNavBar: '회사 프로필',
    welfareNavBar: '복리 후생',
    targetNavBar: '경영 목표', 
    historyNavBar: '연혁',
    solution: '모든 사업 내용',
    itsolution: 'IT 사업 내용', 
    t1solution: '등록 지원 기관', 
    t2solution: '유료 직업 소개',
    right: '   ',
    ses: 'SES 사업',
    appDev: '앱 개발',
    develop: '개발 실적', 
    skill: '보유 기술',
    dispatch: '다른 산업의 인재 지원',
    // Footer
    companyNameFooter: '주식회사<br />GrowthSoft',
    address: '〒102-0072<br />도쿄도 치요다구 이이다바시 1-7-10<br />야마쿄 빌딩 본관 7F',
    phone: '전화: 03-6265-4936',
    email: '이메일: info@growthsoft.co.jp',
    links: '링크',
    home: '홈',
    companyInfo: '회사 정보',
    solutions: '사업 내용',
    recruitmentInfo: '채용 정보',
    contact: '문의하기',
    copyright: '저작권 © 2024. 주식회사 GrowthSoft. 모든 권리 보유.',
    // Greeting Section
    greetingTitle: '인사말',
    greetingMission: '<strong>사명과 목표</strong><br>저희 GrowthSoft는 고객의 비즈니스 성공을 최우선으로 생각하며, 혁신적인 IT 솔루션을 제공하는 것을 사명으로 하고 있습니다. 다양한 산업에서 쌓은 경험과 전문 지식을 활용하여 최적의 솔루션을 제공하기 위해 최선을 다하고 있습니다.',
    greetingService: '<strong>서비스의 유연성과 신뢰 관계</strong><br>고객의 요구에 맞춘 유연하고 효과적인 서비스를 제공하며, 항상 고객의 기대를 뛰어넘는 성과를 실현하는 것을 목표로 하고 있습니다. 첨단 기술 도입과 지속적인 개선을 통해 신뢰 관계를 구축하는 것을 중요하게 생각합니다.',
    greetingEmployee: '<strong>직원의 성장과 기여</strong><br>저희의 성공은 직원 한 사람 한 사람의 성장과 기여에 의해 지탱되고 있습니다. 직원이 자신의 능력을 최대한 발휘할 수 있는 환경을 조성하고, 함께 성장함으로써 조직 전체의 발전을 목표로 하고 있습니다. 존중과 협력의 정신을 가지고 팀이 하나가 되어 고객의 성공에 기여합니다.',
    greetingFuture: '<strong>미래에 대한 도전과 가치 창조</strong><br>기술의 진보가 일상적으로 진행되는 가운데, 저희는 끊임없이 도전하고 새로운 가치를 창출하기 위해 노력하고 있습니다. 고객과 함께 새로운 미래를 개척해 나갈 것을 약속드립니다. 여러분의 지원과 사랑을 부탁드립니다.',
    map: '오시는 길',
    mapcontext: '주식회사 GrowthSoft<br />〒102-0072<br />도쿄도 치요다구 이이다바시 1-7-10 산쿄빌딩 본관 7층<br />전화: 03-6265-4936<br />이메일: info@growthsoft.co.jp<br /><br />가까운 역에서의 오시는 길<br />[도자이선]<br />구단시타역 7번 출구에서 도보 5분<br />[신주쿠선・한조몬선]<br />구단시타역 3a 출구에서 도보 6분<br />[도자이선・난보쿠선・오에도선・유라쿠초선]<br />이이다바시역 A4 출구에서 도보 5분<br />[JR 소부선]<br />JR 이이다바시역 동쪽 출구에서 도보 6분',
    maplinks: 'Google Map에서 보기',
    mapcompanyName: '주식회사 GrowthSoft',
    mapaddress: '〒102-0072 <br />도쿄도 치요다구 이이다바시 1-7-10 산쿄빌딩 본관 7층',
    mapphone: '전화: 03-6265-4936',
    mapemail: '이메일: info@growthsoft.co.jp',
    mapcontextTitle: '<br />가까운 역에서의 오시는 길',
    mapcontext1: '<br />[도자이선] <br />구단시타역 7번 출구에서 도보 5분',
    mapcontext2: '<br />[신주쿠선・한조몬선] <br />구단시타역 3a 출구에서 도보 6분',
    mapcontext3: '<br />[도자이선・난보쿠선・오에도선・유라쿠초선] <br />이이다바시역 A4 출구에서 도보 5분',
    mapcontext4: '<br />[JR 소부선] <br />JR 이이다바시역 동쪽 출구에서 도보 6분',
    ceoName: '왕 강',
    // Vision Section
    visionTitle: '경영 철학 및 비전',
    visionMission: '<strong>사명과 목표</strong><br>저희의 경영 철학은 고객, 직원, 그리고 사회 전체에 대해 서로 존중하며 성장하고 행복한 삶을 실현하는 것입니다. 저희는 항상 높은 윤리 기준을 가지고 신뢰를 구축함으로써 지속 가능한 사회 발전에 기여합니다.',
    visionService: '<strong>서비스의 유연성과 신뢰 관계</strong><br>고객에게는 뛰어난 기술과 서비스를 제공하며, 그 기대를 뛰어넘는 솔루션을 제안합니다. 직원에게는 성장 기회와 일하기 좋은 환경을 제공하며, 각자의 커리어 패스를 존중합니다. 사회에 대해서는 환경 보호와 지역 사회에의 공헌을 중시하며, 지속 가능한 비즈니스를 전개합니다.',
    visionEmployee: '<strong>직원의 성장과 기여</strong><br>저희는 서로 존중하며 함께 성장하고, 행복한 삶을 향해 노력합니다. 이 비전을 실현하기 위해 저희는 일상 업무에서 성실함과 열정을 가지고 임하고 있습니다.',
    // Company Profile Section
    companyProfileTitle: '회사 개요',
    companyNameLabel: '회사명',
    companyName: '주식회사 GrowthSoft（그로스소프트）',
    capitalLabel: '자본금',
    capital: '15,000,000엔',
    ceoLabel: '대표자',
    foundedLabel: '설립일',
    founded: '2023년 9월 4일',
    employeesLabel: '직원 수',
    employees: '22명',
    headquartersLabel: '본사',
    headquarters: '〒102-0072 도쿄도 치요다구 이이다바시 1-7-10 야마쿄 빌딩 본관 7층',
    phoneLabel: '전화',
    phone: '03-6265-4936',
    banks: '거래 은행',
    bank1: '스미토모 미쓰이 은행',
    bank2: 'GMO 아오조라 인터넷 은행',
    qualifications: '자격',
    qualification1: '적격 청구서　T8013301051315',
    qualification2: '등록 지원 기관　24登-010800',
    qualification3: '유료 직업 소개소　13-ユ-317559',
    qualification4: '노동자 파견　（派）13-318368',
    // Welfare Section
    welfareTitle: '복리 후생',
    insurance: '보험',
    insuranceDetails: '건강 보험, 후생 연금, 고용 보험, 산재 보험, 아동 및 육아 기여금',
    vacation: '휴가',
    vacationDetails: '산휴, 육아 휴직, 간병 휴직 제도, 유연 근무제, 단시간 근무 제도（임신, 육아, 간병）',
    allowances: '수당',
    allowancesDetails: '교통비, 성실 수당, 초과 근무 수당, 주택 수당, 연말 특별 출근 수당, 자격 취득 지원, 세미나 비용 지원',
    // History Section
    HistoryTitle: '연혁',
    Historyyear1: '2023년 9월 4일',
    Historyevent1: '・주식회사 GrowthSoft 설립',
    Historyyear2: '2024년 4월 15일',
    Historyevent2: '・사업 확장으로 인해 지요다구 이이다바시로 본사 이전<br>・자본금을 5,000만 엔으로 증자',
    Historyyear3: '2024년 6월 1일',
    Historyevent3: '・적격 세금계산서 발행 사업자 등록',
    Historyyear4: '2024년 8월 31일',
    Historyevent4: '・매출 3,500만 엔 달성',
    Historyyear5: '2024년 10월 10일',
    Historyevent5: '・등록 지원 기관 등록',
    Historyyear6: '2025년 1월 1일',
    Historyevent6: '・유료 직업 소개 사업 허가 취득',
    Historyyear7: '2025년 7월 3일',
    Historyevent7: '・자본금을 1,500만엔으로 증자',
    Historyyear8: '2025년 8월 31일',
    Historyevent8: '・매출 8,750만 엔 달성',
    Historyyear9: '2026년 1월 1일',
    Historyevent9: '・노동자 파견 사업 허가증 취득',
    // Target Section
    TargetMainTitle: '경영 목표',
    TargetTitle: '중장기 매출 계획',
    Targetyear: '1년차: 3,000만 엔<br>2년차: 7,000만 엔<br>3년차: 1억1,000만 엔',
    Targetyear1: '1년차: 3,000만 엔',
    Targetyear2: '2년차: 7,000만 엔',
    Targetyear3: '3년차: 1억1,000만 엔',
    // Other
    blank: '',
    line: '-',
    joinus: 'join us',
    mapTitle: 'MAP',
    home1: 'HOME',
    companyInfo1: 'Company',
    solutions1: 'Business',
    recruitmentInfo1: 'Recruit',
    contact1: 'Contact',
    language1: 'Language',
    language: '언어',
    languages: {
      ja: '日本語',
      zh: '中文',
      en: 'English',
      ko: '한국어',
      vi: 'Tiếng Việt',
    },
    recruitment: {
      bannerTitle: '서로를 존중하며 행복한 삶을 향해 성장해 나가자',
      bannerSubtitle: 'Let\'s respect each other and strive towards a happy life',
      bannerButton: '자세히 보기',
      title: '채용 정보',
      description: 'GrowthSoft에서는 아래의 직종에서 지원을 받고 있습니다.<br>모집 내용의 자세한 사항은 직종명을 클릭하여 확인해 주세요.',
      applyButton: '지원하기',
      newGraduate: '신입 채용',
      careerRecruitment: '경력 채용',
      seconedGraduate: '제2신졸',
      job1: {
        title: '신입 채용',
        details: [
          {
            title: '지원 자격',
            content: [
              {
                label: '필수 조건',
                value: `
                  <li>대학교 졸업 이상 (전문대 졸업자는 IT 관련 전공 필수)</li>
                  <li>밝고 원만한 성격, 커뮤니케이션 능력</li>
                  <li>팀워크를 중요시하는 자세</li>
                `
              }
            ]
          },
          {
            title: '급여 및 복지',
            content: [
              {
                label: '예상 연봉',
                value: '연 300만~400만 엔<br>*경력과 능력에 따라 결정'
              },
              {
                label: '',
                value: `
                  <li>내규에 따라 종합적으로 판단 후 결정</li>
                  <li>수습 기간 3개월 (조건 변동 없음)</li>
                  <li>연 1회 급여 인상</li>
                  <li>상여금 연 2회 (성과에 따라 연말 특별 상여 가능)</li>
                `
              },
              {
                label: '휴무 및 휴가',
                value: `
                  <li>주 5일 근무 (토・일・공휴일 휴무)</li>
                  <li>입사 시점부터 유급휴가 발생 (첫 해 10일)</li>
                  <li>연말연시 휴가</li>
                  <li>경조사 휴가</li>
                  <li>출산휴가</li>
                  <li>육아휴직</li>
                  <li>결혼휴가</li>
                  <li>간병휴가</li>
                `
              },
              {
                label: '자격증 취득 지원 제도',
                value: `
                  수험료 지급, 합격보 장금은 난이도에 따라 5천엔~10만엔 지급<br><br>
                  【예】
                  <li>프로젝트 매니저 시험: 8만엔</li>
                  <li>응용정보처리기사: 3만엔</li>
                  <li>기초정보처리기사: 1만엔</li>
                  <li>AWS FOUNDATIONAL: 1.5만엔</li>
                  <li>AWS ASSOCIATE: 3만엔</li>
                  <li>AWS PROFESSIONAL: 5만엔</li>
                  <li>AWS SPECIALTY: 5만엔</li>
                  <li>IT 패스포트: 5천엔</li>
                  <li>TOEIC: 2만~8만엔</li>
                  <li>그 외 벤더 자격증 (Cisco, Azure, GCP, Oracle, SAP 등)도 지원</li>
                `
              }
            ]
          },
          {
            title: '근무 시간',
            content: '※ 프로젝트에 따라 변동 가능'
          },
          {
            title: '근무지',
            content: '도쿄 / 가나가와 / 지바 / 사이타마'
          }
        ]
      },
      job2: {
        title: '경력직 채용',
        details: [
          {
            title: '직무 내용',
            content: '대기업, 제조 계열 SIer, 사용자 계열 SIer 등 고객사의 개발 현장에서 시스템 엔지니어로 근무하며, 요건 정의, 기본 설계, 상세 설계, 개발, 테스트, 유지보수 등의 업무를 담당합니다.'
          },
          {
            title: '지원 자격',
            content: [
              {
                label: '필수 조건',
                value: `
                  <li>시스템 개발 경력 1년 이상</li>
                  <li>프로그래밍 경험 및 Java, Python, C++ 등 주요 언어 숙련도</li>
                `
              },
              {
                label: '우대 조건',
                value: `
                  <li>운용・유지보수 경험과 최근 개발 경험 병행자</li>
                  <li>PM・PL 경험 또는 후배 육성 경험자</li>
                  <li>웹 또는 모바일 애플리케이션 개발 경험</li>
                  <li>DB 설계 및 운영 경험</li>
                `
              }
            ]
          },
          {
            title: '급여 및 복지',
            content: [
              {
                label: '예상 연봉',
                value: '연 500만~1,000만 엔<br>*경력에 따라 결정'
              },
              {
                label: '',
                value: `
                  <li>경력, 연령, 능력을 종합적으로 고려해 내규에 따라 결정</li>
                  <li>수습 기간 3개월 (조건 변동 없음)</li>
                  <li>연 1회 급여 인상</li>
                  <li>상여금 연 2회 (성과에 따라 연말 특별 상여 가능)</li>
                `
              },
              {
                label: '휴무 및 휴가',
                value: `
                  <li>주 5일 근무 (토・일・공휴일 휴무)</li>
                  <li>입사 시점부터 유급휴가 발생 (첫 해 10일)</li>
                  <li>연말연시 휴가</li>
                  <li>경조사 휴가</li>
                  <li>출산휴가</li>
                  <li>육아휴직</li>
                  <li>결혼휴가</li>
                  <li>간병휴가</li>
                `
              },
              {
                label: '자격증 취득 지원 제도',
                value: `
                  수험료 지급, 합격보 장금은 난이도에 따라 5천엔~10만엔 지급<br><br>
                  【예】
                  <li>프로젝트 매니저 시험: 8만엔</li>
                  <li>응용정보처리기사: 3만엔</li>
                  <li>기초정보처리기사: 1만엔</li>
                  <li>AWS FOUNDATIONAL: 1.5만엔</li>
                  <li>AWS ASSOCIATE: 3만엔</li>
                  <li>AWS PROFESSIONAL: 5만엔</li>
                  <li>AWS SPECIALTY: 5만엔</li>
                  <li>IT 패스포트: 5천엔</li>
                  <li>TOEIC: 2만~8만엔</li>
                  <li>그 외 벤더 자격증 (Cisco, Azure, GCP, Oracle, SAP 등)도 지원</li>
                `
              }
            ]
          },
          {
            title: '근무 시간',
            content: '※ 프로젝트에 따라 변동 가능'
          },
          {
            title: '근무지',
            content: '도쿄 / 가나가와 / 지바 / 사이타마'
          }
        ]
      },
      job3: {
        title: '제2신졸 채용',
        details: [
          {
            title: '지원 자격',
            content: [
              {
                label: '필수 조건',
                value: `
                  <li>대학교 졸업 이상 (전문대 졸업자는 IT 관련 전공 필수)</li>
                  <li>밝고 원만한 성격, 커뮤니케이션 능력</li>
                  <li>팀워크를 중요시하는 자세</li>
                `
              }
            ]
          },
          {
            title: '급여 및 복지',
            content: [
              {
                label: '예상 연봉',
                value: '연 300만~400만 엔<br>*경력과 능력에 따라 결정'
              },
              {
                label: '',
                value: `
                  <li>내규에 따라 종합적으로 판단 후 결정</li>
                  <li>수습 기간 3개월 (조건 변동 없음)</li>
                  <li>연 1회 급여 인상</li>
                  <li>상여금 연 2회 (성과에 따라 연말 특별 상여 가능)</li>
                `
              },
              {
                label: '휴무 및 휴가',
                value: `
                  <li>주 5일 근무 (토・일・공휴일 휴무)</li>
                  <li>입사 시점부터 유급휴가 발생 (첫 해 10일)</li>
                  <li>연말연시 휴가</li>
                  <li>경조사 휴가</li>
                  <li>출산휴가</li>
                  <li>육아휴직</li>
                  <li>결혼휴가</li>
                  <li>간병휴가</li>
                `
              },
              {
                label: '자격증 취득 지원 제도',
                value: `
                  수험료 지급, 합격보 장금은 난이도에 따라 5천엔~10만엔 지급<br><br>
                  【예】
                  <li>프로젝트 매니저 시험: 8만엔</li>
                  <li>응용정보처리기사: 3만엔</li>
                  <li>기초정보처리기사: 1만엔</li>
                  <li>AWS FOUNDATIONAL: 1.5만엔</li>
                  <li>AWS ASSOCIATE: 3만엔</li>
                  <li>AWS PROFESSIONAL: 5만엔</li>
                  <li>AWS SPECIALTY: 5만엔</li>
                  <li>IT 패스포트: 5천엔</li>
                  <li>TOEIC: 2만~8만엔</li>
                  <li>그 외 벤더 자격증 (Cisco, Azure, GCP, Oracle, SAP 등)도 지원</li>
                `
              }
            ]
          },
          {
            title: '근무 시간',
            content: '※ 프로젝트에 따라 변동 가능'
          },
          {
            title: '근무지',
            content: '도쿄 / 가나가와 / 지바 / 사이타마'
          }
        ]
      },
      job4: {
        title: '다른 산업의 인재 지원',
        details: [
          {
            title: '지원 조건',
            content: [
              {
                label: '필수 조건',
                value: `
                  <li>좋은 성격과 강한 커뮤니케이션 능력</li>
                  <li>팀으로 협력하여 일할 수 있는 능력</li>
                  <li>신속하고 정확하게 업무를 수행할 수 있는 능력</li>
                  <li>새로운 환경에 적응할 수 있는 유연성</li>
                `
              }
            ]
          },
          {
            title: '대우',
            content: [
              {
                label: '예상 연봉',
                value: '280만 엔~450만 엔<br>※경험에 따라 우대'
              },
              {
                label: '',
                value: `
                  <li>능력, 경험, 연령 등을 고려하여 회사 규정에 따라 결정</li>
                  <li>수습 기간: 있음 (3개월, 노동 조건의 변경 없음)</li>
                  <li>급여 인상: 연 1회</li>
                  <li>보너스: 연 2회 (결산 보너스를 지급할 경우 있음)</li>
                `
              }
            ]
          },
          {
            title: '근무지',
            content: '도쿄/가나가와/지바/사이타마'
          }
        ]
      }
    },
    contactUs: {
      title: '문의하기',
      inquiryType: '문의 유형',
      name: '이름',
      lastName: '성',
      firstName: '이름',
      companyName: '회사명 또는 단체명',
      departmentName: '부서명',
      email: '이메일 주소',
      phone: '전화번호',
      message: '문의 내용',
      submitButton: '제출',
      required: '필수',
      optional: '선택',
      select: '선택해 주세요',
      newGraduate: '신입 채용',
      careerRecruitment: '경력 채용',
      seconedGraduate: '제2신졸',
      serviceInquiry: '서비스 또는 회사 관련 문의',
      other: '기타',
      validationMessage: '이 필드를 작성해 주세요.',
      successMessage: '메시지가 전송되었습니다!',
      errorMessage: '메시지 전송에 실패했습니다. 다시 시도해 주세요.'
    },
    solutionInfo: {
      title: '사업 내용',
      overview: '개요',
      technicalFields: '기술 분야',
      services: '서비스 내용',
      ses: {
        title: 'SES 사업',
        description: '저희 회사는 SES(시스템 엔지니어링 서비스) 사업을 중심으로 시스템 개발부터 운영 및 유지보수까지 일관된 서비스를 제공합니다. 프로젝트의 개발 단계부터 전환, 유지보수 및 운영까지 다양한 니즈에 대응이 가능합니다.',
        description1: '또한 당사에는 뛰어난 외국인 엔지니어들이 다수 소속되어 있어, 품질이 우수하고 비용 효율적인 서비스를 제공합니다. 견적 문의도 언제든지 편하게 연락 주세요.',
        frontend: '프론트엔드',
        languages: '개발 언어',
        database: '데이터베이스',
        frontendContent: 'Vue.js、React.js、Angular.js 등',
        languagesContent: 'Java、C、C++、C#、JavaScript、TypeScript、VB.NET、ASP.NET、COBOL、PHP 등',
        databaseContent: 'Oracle、MySQL、PostgreSQL、SQLserver、MongoDB 등'
      },
      appDev: {
        title: '앱 개발',
        description: '앱 개발 사업에서는 스마트폰 앱과 웹 앱의 기획, 개발 및 운영을 수행합니다. 최신 기술을 활용하여 사용자에게 친숙한 앱을 제공합니다.',
        services: '요구 사항 정의, 디자인, 개발, 테스트, 출시까지 일관된 지원을 제공합니다. 고객의 비즈니스 모델에 최적화된 애플리케이션을 개발하여 경쟁력을 높입니다.'
      },
      skill: {
        title: '보유 스킬',
        description: '당사 팀은 다양한 기술 영역에 대응할 수 있는 높은 적응력과 유연성을 갖추고 있으며, 폭넓은 산업 분야의 요구에 맞춘 최적의 솔루션을 제안합니다.',
        description1: '복잡한 비즈니스 과제에 대해서는 혁신적이고 실용적인 접근 방식으로 문제 해결을 합니다. 증권, 은행, 보험 산업 등 다양한 분야에서 풍부한 프로젝트 경험이 있습니다.',
        description2: '그동안의 지식을 활용하여 고객의 구체적인 요구사항에 신속하고 최적의 방식으로 대응합니다. 앞으로도 지속적으로 기술력 향상을 위해 노력하고 있습니다.',
        environment: '개발 환경',
        languages: '개발 언어',
        database: '데이터베이스',
        environmentContent: 'Windows, Linux 등',
        languagesContent: 'Java, C, C++, C#, JavaScript, TypeScript, VB.NET, ASP.NET, COBOL, PHP 등',
        databaseContent: 'Oracle, MySQL, PostgreSQL, SQL Server, MongoDB 등'
      },
      develop: {
        title: '개발 실적',
        Webtitle: '웹 계열',
        WebNameLabel1: '재고 관리 시스템',
        WebNameLabel2: '상품 관리 시스템',
        WebNameLabel3: '고객 관리 시스템',
        WebNameLabel4: '생산 관리 시스템',
        WebNameLabel5: 'ATM 연계 시스템',
        WebNameLabel6: '물류 시스템',
        WebNameLabel7: '기반 시스템',
        apptitle: '애플리케이션',
        appNameLabel1: 'iOS',
        appNameLabel2: 'Android',
        packagetitle: '패키지 도입 대응',
        packageNameLabel1: 'SAP',
        packageNameLabel2: 'Salesforce'
      },
      dispatch: {
        title: '다른 산업의 인재 지원 서비스',
        description: '다른 산업의 인재 지원 서비스는 다양한 산업의 기업에 필요한 기술과 경험을 갖춘 우수한 인재를 제공합니다. 고객의 비즈니스 요구에 맞춰 신속하고 정확하게 최적의 인재를 매칭합니다. 산업 예로는 호텔, 공장, 음식점 등이 있습니다.',
        services: '인재 모집 및 선발부터 근무 시작 후의 팔로우업까지 일관된 서비스를 제공합니다. 고객의 비즈니스 요구에 맞춘 적절한 인재를 제공함으로써, 고객의 비즈니스 성공을 지원합니다.'
      },
      t2solution: {
        title: '유료 직업 소개 서비스',
        work01: 'IT 채용 (자사 / 타사)',
        description01: '웹 개발, AWS, IT 인프라 등 중일 기업의 IT 직종을 소개합니다.',
        work02: '일본 내 다양한 직종 소개',
        description02: '사무, 번역, 무역, 영업, 판매 등 다양한 직종을 안내합니다.',
        work03: '유학 신청 및 진학 지원',
        description03: '일본어학교 신청, 대학·대학원 진학 상담을 제공합니다.',
        work04: '특정기능비자 지원',
        description04: '우리는 케이터링, 식품 가공 등 특정 기술 비자와 관련된 부문을 지원합니다.',
      },
      t1solution: {
        title: '등록 지원 기관 서비스',
        work0: '서류 작성 지원',
        work001: '지원 계획서 작성',
        description001: '저희 서비스는 기업이 특정기능 외국인을 채용할 때, 업무와 생활에 필요한 지원 계획서를 제안하고 작성해 드립니다. 자세한 사항은 언제든지 문의 주세요.',
        work002: '체류 자격 변경 서류 작성',
        description002: '체류 자격 변경에 필요한 서류를 제공하며, 행정서사의 지도를 받아 문서를 준비하고 지역 출입국관리사무소에 제출 및 대리 접수를 도와드립니다.',
        work1: '介護',
        description1a: '<strong>〈 分野、区分の概要 〉</strong><br> 高齢や障害で、生活をする時に介護が必要になった人たちへの身体介護等（介護を受ける人の状況にあわせて入浴、食事、排せつを助けること等）のほか、身体介護等に関係して助けが必要なしごと（レクリエーションの実施、リハビリテーションの補助等）<br>  ※介護を受ける人たちの家でするものは対象ではありません。',
        description1b: '<strong>〈 従事する主な業務 〉</strong><br> ・身体介護等（介護を受ける人の状況にあわせて入浴、食事、排せつを助けること等）<br> ・身体介護等に関係して助けが必要なしごと（レクリエーションの実施、リハビリテーションの補助等） ',
        description1c: '<strong>〈 想定される関連業務 〉</strong><br> 例：お知らせ等の掲示物の管理、物品の補充や管理',
        work2: 'ビルクリーニング',
        description2a: '<strong>〈 分野、区分の概要 〉</strong><br> 建築物内部の清掃',
        description2b: '<strong>〈 従事する主な業務 〉</strong><br> 多数の利用者が利用する建築物（住宅を除く。）の内部を対象に、衛生的環境の保護、美観の維持、安全の確保及び保全の向上を目的として、場所、部位、建材、汚れ等の違いに対し、方法、洗剤及び用具を適切に選択して清掃作業を行い、建築物に存在する環境上の物質を排除し、清潔さを維持する業務<br> ※床、浴室、トイレ、洗面台等の清掃からアメニティ補充やベッドメイク作業など、衛生かつ美観が整えられた客室を商品として納品するために必要な一連の業務である客室清掃業務は主な業務に含まれる。',
        description2c: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・複数の作業員の指導、現場の管理、計画作成や進行管理等<br>・清掃用機械器具の維持管理等に関する業務、技能実習責任者の業務、技能実習指導員の業務や、生活指導員の業務（それぞれ主たる業務に該当するものを除く。）<br>・建築物と構造上一体と見なせる部分（犬走・アプローチ等の外周部など）の清掃作業<br>・資機材倉庫の整備作業<br>・建物外部洗浄作業(外壁、屋上等。ただし高所作業を伴う窓ガラス・外壁清掃作業は除く。）<br>・ベッドメイク作業<br>・建築物内外の植裁管理作業（灌水作業等）<br>・資機材の運搬作業（他の現場に移動する場合等）',
        description2d: '<strong>〈 その他特記事項 〉</strong><br> ・詳細は以下の「ビルクリーニング分野特定技能外国人が従事できる業務について（令和５年 10 月 17 日ビルクリーニング分野特定技能協議会決定第１号）」を参照すること。',
        work3: '工業製品製造業',
        description3a: '（機械金属加工区分）',
        description3aa: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、素形材製品や産業機械等の製造工程の作業に従事',
        description3ab: '<strong>〈 従事する主な業務 〉</strong><br> 鋳造 ／ 鍛造 ／ ダイカスト ／ 機械加工 ／ 金属プレス加工 ／ 鉄工 ／ 工場板金 ／ 仕上げ ／ プラスチック成形 ／ 機械検査 ／ 機械保全 ／ 電気機器組立て ／ 塗装 ／ 溶接 ／ 工業包装 ／強化プラスチック成形 ／ 金属熱処理業',
        description3ac: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3b: '（電気電子機器組立て区分）',
        description3ba: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、電気電子機器等の製造工程、組立工程の作業に従事',
        description3bb: '<strong>〈 従事する主な業務 〉</strong><br> 機械加工 ／ 仕上げ ／ プラスチック成形 ／ プリント配線板製造 ／ 電子機器組立て ／ 電気機器組立て ／ 機械検査 ／ 機械保全 ／ 工業包装 ／強化プラスチック成形',
        description3bc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3c: '（金属表面処理区分）',
        description3ca: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、表面処理等の作業に従事',
        description3cb: '<strong>〈 従事する主な業務 〉</strong><br> めっき ／ アルミニウム陽極酸化処理',
        description3cc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3d: '（紙器・段ボール箱製造区分）',
        description3da: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、紙器・段ボール箱の製造工程の作業に従事',
        description3db: '<strong>〈 従事する主な業務 〉</strong><br> 紙器・段ボール箱製造',
        description3dc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3e: '（コンクリート製品製造区分）',
        description3ea: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、コンクリート製品の製造工程の作業に従事',
        description3eb: '<strong>〈 従事する主な業務 〉</strong><br> コンクリート製品製造 ',
        description3ec: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3f: '（RPF製造区分）',
        description3fa: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、破砕・成形等の作業に従事　',
        description3fb: '<strong>〈 従事する主な業務 〉</strong><br> ＲＰＦ製造',
        description3fc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3g: '（陶磁器製品製造区分）',
        description3ga: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、陶磁器製品の製造工程の作業に従事',
        description3gb: '<strong>〈 従事する主な業務 〉</strong><br> 陶磁器工業製品製造',
        description3gc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3h: '（印刷・製本区分）',
        description3ha: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、オフセット印刷、グラビア印刷、製本の製造工程の作業に従事 ',
        description3hb: '<strong>〈 従事する主な業務 〉</strong><br> 印刷 ／ 製本',
        description3hc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3i: '（紡織製品製造区分）',
        description3ia: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、紡織製品の製造工程の作業に従事',
        description3ib: '<strong>〈 従事する主な業務 〉</strong><br> 紡績運転 ／ 織布運転 ／ 染色 ／ ニット製品製造 ／ たて編ニット生地製造 ／カーペット製造 ',
        description3ic: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3j: '（縫製区分）',
        description3ja: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、縫製工程の作業に従事',
        description3jb: '<strong>〈 従事する主な業務 〉</strong><br> 婦人子供服製造 ／ 紳士服製造 ／ 下着類製造 ／ 寝具製作 ／ 帆布製品製造 ／布はく縫製 ／ 座席シート縫製',
        description3jc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        work4: '建設',
        description4a: '（土木区分）',
        description4aa: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示・監督を受けながら、土木施設の新設、改築、維持、修繕に係る作業等に従事',
        description4ab: '<strong>〈 従事する主な業務 〉</strong><br> 型枠施工 ／ コンクリート圧送 ／ トンネル推進工 ／ 建設機械施工 ／ 土工 ／ 鉄筋施工 ／ とび ／ 海洋土木工<br> その他、土木施設の新設、改築、維持、修繕に係る作業',
        description4ac: '<strong>〈 想定される関連業務 〉</strong><br>・原材料・部品の調達・搬送<br>・機器・装置・工具等の保守管理<br>・足場の組立て、設備の掘り起こしその他の後工程の準備作業<br>・足場の解体、設備の埋め戻しその他の前工程の片付け作業<br>・清掃・保守管理作業<br>・その他、主たる業務に付随して行う作業',
        description4ad: '<strong>〈 その他特記事項 〉</strong><br> 業務の詳細については、以下の国土交通省のウェブサイト中「◆業務区分と試験及び技能実習等との対応関係」の「業務区分と建設業許可工事業との対応関係」をご覧ください。',
        description4b: '（建築区分）',
        description4ba: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示・監督を受けながら、建築物の新築、増築、改築若しくは移転又は修繕若しくは模様替に係る作業等に従事',
        description4bb: '<strong>〈 従事する主な業務 〉</strong><br> 型枠施工 ／ 左官 ／ コンクリート圧送 ／ 屋根ふき ／ 土工 ／ 鉄筋施工 ／ 鉄筋継手 ／ 内装仕上げ ／ 表装 ／ とび ／ 建築大工 ／ 建築板金 ／ 吹付ウレタン断熱<br>その他、建築物の新築、増築、改築若しくは移転、修繕又は模様替に係る作業',
        description4bc: '<strong>〈 想定される関連業務 〉</strong><br>・原材料・部品の調達・搬送<br>・機器・装置・工具等の保守管理<br>・足場の組立て、設備の掘り起こしその他の後工程の準備作業<br>・足場の解体、設備の埋め戻しその他の前工程の片付け作業<br>・清掃・保守管理作業<br>・その他、主たる業務に付随して行う作業',
        description4bd: '<strong>〈 その他特記事項 〉</strong><br> 業務の詳細については、以下の国土交通省のウェブサイト中「◆業務区分と試験及び技能実習等との対応関係」の「業務区分と建設業許可工事業との対応関係」をご覧ください。',
        description4c: '（ライフライン・設備区分）',
        description4ca: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示・監督を受けながら、電気通信、ガス、水道、電気その他のライフライン・設備の整備・設置、変更又は修理に係る作業等に従事',
        description4cb: '<strong>〈 従事する主な業務 〉</strong><br> 電気通信 ／ 配管 ／ 建築板金 ／ 保温保冷<br>その他、ライフライン・設備の整備・設置、変更又は修理に係る作業',
        description4cc: '<strong>〈 想定される関連業務 〉</strong>・原材料・部品の調達・搬送<br>・機器・装置・工具等の保守管理<br>・足場の組立て、設備の掘り起こしその他の後工程の準備作業<br>・足場の解体、設備の埋め戻しその他の前工程の片付け作業<br>・清掃・保守管理作業<br>・その他、主たる業務に付随して行う作業',
        description4cd: '<strong>〈 その他特記事項 〉</strong><br> 業務の詳細については、以下の国土交通省のウェブサイト中「◆業務区分と試験及び技能実習等との対応関係」の「業務区分と建設業許可工事業との対応関係」をご覧ください。',
        work5: '造船・舶用工業',
        description5a: '（造船区分）',
        description5aa: '<strong>〈 分野、区分の概要 〉</strong><br> 造船（監督者の指示を理解し又は自らの判断により船舶の製造工程の作業に従事）',
        description5ab: '<strong>〈 従事する主な業務 〉</strong><br> 溶接 ／ 塗装 ／ 鉄工 ／ とび ／ 配管 ／ 船舶加工',
        description5ac: '<strong>〈 想定される関連業務 〉</strong><br>・読図作業<br>・作業工程管理<br>・検査（外観、寸法、材質、強度、非破壊、耐圧気密等）<br>・機器・装置・工具の保守管理<br>・機器・装置・運搬機の運転<br>・資材の材料管理・配置<br>・部品・製品の養生<br>・足場の組立て・解体<br>・廃材処理<br>・梱包・出荷<br>・資材・部品・製品の運搬<br>・入出渠<br>・清掃',
        description5ad: '<strong>〈 その他特記事項 〉</strong><br> 業務の詳細については、以下の国土交通省のウェブサイトをご覧ください。',
        description5b: '（舶用機械区分）',
        description5ba: '<strong>〈 分野、区分の概要 〉</strong><br> 舶用機械（監督者の指示を理解し又は自らの判断により舶用機械の製造工程の作業に従事）',
        description5bb: '<strong>〈 従事する主な業務 〉</strong><br> 溶接 ／ 塗装 ／ 鉄工 ／ 仕上げ ／ 機械加工 ／ 配管 ／ 鋳造 ／ 金属プレス加工 ／強化プラスチック成形 ／ 機械保全 ／ 船用機械加工',
        description5bc: '<strong>〈 想定される関連業務 〉</strong><br>・読図作業<br>・作業工程管理<br>・検査（外観、寸法、材質、強度、非破壊、耐圧気密等）<br>・機器・装置・工具の保守管理<br>・機器・装置・運搬機の運転<br>・資材の材料管理・配置<br>・部品・製品の養生<br>・足場の組立て・解体<br>・廃材処理<br>・梱包・出荷<br>・資材・部品・製品の運搬<br>・入出渠<br>・清掃',
        description5bd: '<strong>〈 その他特記事項 〉</strong><br> 業務の詳細については、以下の国土交通省のウェブサイトをご覧ください。',
        description5c: '（舶用電気電子機器区分）',
        description5ca: '<strong>〈 分野、区分の概要 〉</strong><br> 舶用電気電子機器（監督者の指示を理解し又は自らの判断により舶用電気電子機器の製造工程の作業に従事）',
        description5cb: '<strong>〈 従事する主な業務 〉</strong><br> 機械加工 ／ 電気機器組立て ／ 金属プレス加工 ／ 電子機器組み立て ／プリント配線板製造 ／ 配管 ／ 機器保全 ／ 船用電気電子機器加工　',
        description5cc: '<strong>〈 想定される関連業務 〉</strong><br>・読図作業<br>・作業工程管理<br>・検査（外観、寸法、材質、強度、非破壊、耐圧気密等）<br>・機器・装置・工具の保守管理<br>・機器・装置・運搬機の運転<br>・資材の材料管理・配置<br>・部品・製品の養生<br>・足場の組立て・解体<br>・廃材処理<br>・梱包・出荷<br>・資材・部品・製品の運搬<br>・入出渠<br>・清掃',
        description5cd: '<strong>〈 その他特記事項 〉</strong><br> 業務の詳細については、以下の国土交通省のウェブサイトをご覧ください。',
        work6: '自動車整備',
        description6a: '<strong>〈 分野、区分の概要 〉</strong><br> 自動車の日常点検整備、定期点検整備、特定整備、特定整備に付随する業務',
        description6b: '<strong>〈 従事する主な業務 〉</strong><br> 自動車の日常点検整備、定期点検整備、特定整備、特定整備に付随する業務（電子制御装置の整備や鈑金塗装など）の基礎的な業務',
        description6c: '<strong>〈 想定される関連業務 〉</strong><br>・整備内容の説明及び関連部品の販売<br>・部品番号検索・部内発注作業<br>・ナビ・ＥＴＣ等の電装品の取付作業<br>・洗車作業<br>・下廻り塗装作業<br>・車内清掃作業<br>・構内清掃作業<br>・部品等運搬作業<br>・設備機器等清掃作業',
        work7: '航空',
        description7a: '（空港グランドハンドリング区分）',
        description7aa: '<strong>〈 分野、区分の概要 〉</strong><br> 航空機の地上走行支援業務、手荷物・貨物取扱業務等',
        description7ab: '<strong>〈 従事する主な業務 〉</strong><br> 指導者やチームリーダーの下に行う<br>・航空機地上走行支援業務<br>・手荷物・貨物取扱業務<br>・手荷物・貨物の航空機搭降載業務<br>・航空機内外の清掃整備業務',
        description7ac: '<strong>〈 想定される関連業務 〉</strong><br>・事務作業<br>・作業場所の整理整頓や清掃<br>・積雪時における作業場所の除雪',
        description7b: '（航空機整備区分）',
        description7ba: '<strong>〈 分野、区分の概要 〉</strong><br> 航空機の機体、装備品等の整備業務等',
        description7bb: '<strong>〈 従事する主な業務 〉</strong><br> 国家資格整備士等の指導・監督の下、機体や装備品等の整備業務のうち基礎的な作業（簡単な点検や交換作業等）<br>・運航整備（空港に到着した航空機に対して、次のフライトまでの間に行う整備）<br>・機体整備（通常1～1年半毎に実施する、約1～2週間にわたり機体の隅々まで行う整備）<br>・装備品・原動機整備（航空機から取り下ろされた脚部や動翼、 飛行・操縦に用いられる計器類等及びエンジンの整備）',
        description7bc: '<strong>〈 想定される関連業務 〉</strong><br>・事務作業<br>・作業場所の整理整頓や清掃<br>・積雪時における作業場所の除雪',
        work8: '宿泊',
        description8a: '<strong>〈 分野、区分の概要 〉</strong><br> 旅館やホテルにおけるフロント、企画・広報、接客及びレストランサービス等の宿泊サービスの提供業務',
        description8b: '<strong>〈 従事する主な業務 〉</strong><br> ・フロント業務（チェックイン/アウト、周辺の観光地情報の案内、ホテル発着ツアーの手配　等）<br>・企画・広報業務（キャンペーン・特別プランの立案、館内案内チラシの作成、HP、SNS等による情報発信　等）<br>・接客業務（旅館やホテル内での案内、宿泊客からの問い合わせ対応 等）<br>・レストランサービス業務（注文への応対やサービス（配膳・片付け）、料理の下ごしらえ・盛りつけ等の業務　等）',
        description8c: '<strong>〈 想定される関連業務 〉</strong><br> 旅館やホテル内における販売、備品の点検・交換等',
        work9: '自動車運送業',
        description9a: '（バス運転者区分）',
        description9aa: '<strong>〈 分野、区分の概要 〉</strong><br> 運行管理者等の指導・監督の下、一般乗合旅客自動車運送事業、一般貸切旅客自動車運送事業又は特定旅客自動車運送事業における運行前後の車両点検、安全な旅客の輸送、乗務記録の作成や乗客対応等に従事',
        description9ab: '<strong>〈 従事する主な業務 〉</strong><br> ・運行業務（運行前後の車両点検、安全な旅客の輸送、乗務記録の作成等）<br>・接遇業務（乗客対応等）',
        description9ac: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br>関連業務に当たり得るものとして、次が想定される。<br>・車内清掃作業<br>・営業所内清掃作業<br>・運賃精算、管理<br>・その他、主たる業務に付随して行う作業<br>※専ら関連業務に従事することは認められない。',
        description9b: '（タクシー運転者区分）',
        description9ba: '<strong>〈 分野、区分の概要 〉</strong><br> 運行管理者等の指導・監督の下、一般乗用旅客自動車運送事業における運行前後の車両点検、安全な旅客の輸送、乗務記録の作成や乗客対応等に従事',
        description9bb: '<strong>〈 従事する主な業務 〉</strong><br> ・運行業務（運行前後の車両点検、安全な旅客の輸送、乗務記録の作成等）<br>・接遇業務（乗客対応等）',
        description9bc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br>関連業務に当たり得るものとして、次が想定される。<br>・車内清掃作業<br>・営業所内清掃作業<br>・運賃精算、管理<br>・その他、主たる業務に付随して行う作業<br>※専ら関連業務に従事することは認められない。',
        description9c: '（トラック運転者区分）',
        description9ca: '<strong>〈 分野、区分の概要 〉</strong><br> 運行管理者等の指導・監督の下、貨物自動車運送事業における運行前後の車両点検、安全な貨物の輸送、乗務記録の作成や荷崩れを起こさない貨物の積付け等に従事',
        description9cb: '<strong>〈 従事する主な業務 〉</strong><br> ・運行業務（運行前後の車両点検、安全な旅客の輸送、乗務記録の作成等）<br>・接遇業務（乗客対応等）',
        description9cc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br>関連業務に当たり得るものとして、次が想定される。<br>・車内清掃作業<br>・営業所内清掃作業<br>・運賃精算、管理<br>・その他、主たる業務に付随して行う作業<br>※専ら関連業務に従事することは認められない。',
        work10: '鉄道',
        description10a: '（軌道整備区分）',
        description10aa: '<strong>〈 分野、区分の概要 〉</strong><br> 軌道整備（軌道等の新設、改良、修繕に係る作業・検査業務等）',
        description10ab: '<strong>〈 従事する主な業務 〉</strong><br> 以下を例とする軌道等の新設、改良、修繕に係る作業・検査業務が対象となる。<br>・軌道検測作業（高低、通り等軌道の変位を測定する作業）<br>・レール交換作業（新旧レール交換 ／ 付帯作業（吊り上げ作業等））<br>・まくらぎ交換作業（新旧まくらぎ交換 ／ 付帯作業（道床掘削作業等））<br>・バラストを取り扱う作業（バラスト掘削及び埋戻し ／ 道床形状の形成 ／ つき固めや通り整正に伴う作業等）<br>・保安設備を取り扱う作業等（脱線防止ガード等保安設備の取り付け（交換・撤去・復旧等） ／ 付帯作業（締結装置の緊張・緩解作業等））',
        description10ac: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・事務作業<br>・作業場所の整理整頓や清掃',
        description10b: '（電気設備整備区分）',
        description10ba: '<strong>〈 分野、区分の概要 〉</strong><br> 電気設備整備（電路設備、変電所等設備、電気機器等設備、信号保安設備、保安通信設備、踏切保安設備等の新設、改良、修繕に係る作業・検査業務等）',
        description10bb: '<strong>〈 従事する主な業務 〉</strong><br> 以下の設備の新設、改良、修繕に係る作業、検査業務等が対象となる。<br>・電路設備（電車線、送電線、配電線等）<br>・変電所等設備（遮断装置、変圧器、整流器、避雷器、保護装置、接地装置、消火設備等）<br>・電気機器等設備（配電盤、開閉器、電源装置、照明設備、電気掲示器、電気融雪器等）<br>・信号保安設備（信号装置、転てつ装置、連動装置、列車検知装置、自動列車停止装置等）<br>・保安通信設備（交換装置、搬送装置、無線装置、端末装置、通信線等）<br>・踏切保安設備（踏切遮断機、踏切警報機、踏切警報時間制御装置、踏切支障報知装置、障害物検知装置等）<br>※上記設備の支持物、ケーブル、管路、配線等を含む',
        description10bc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・事務作業<br>・作業場所の整理整頓や清掃',
        description10c: '（車両整備区分）',
        description10ca: '<strong>〈 分野、区分の概要 〉</strong><br> 車両整備（鉄道車両の整備業務等）',
        description10cb: '<strong>〈 従事する主な業務 〉</strong><br> 以下を例とする業務等が対象となる。<br>・列車検査、定期検査、臨時検査（空調装置、集電装置、走行装置、ブレーキ装置、空気装置、電気装置、動力発生装置、保安装置、車体、乗務員室・客室に関わる装置、連結装置等や車両部品の検査、修繕等（解ぎ装等作業や消耗品の補充を含む））<br>・構内入換（車両基地等での車両の入換や誘導等）<br>・駅派出対応（駅等における車両の検査・修繕等）<br>・改造工事（車両の改造や改良工事等）<br>・定期・臨時清掃業務（車両基地における車両の清掃等）<br>・在庫・予備品管理、工場設備取扱い<br>・上記に関する材料や部品、装置等の管理及び設備の操作・管理',
        description10cc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・事務作業<br>・作業場所の整理整頓や清掃',
        description10d: '（車両製造区分）',
        description10da: '<strong>〈 分野、区分の概要 〉</strong><br> 車両製造（鉄道車両、鉄道車両部品等の製造業務等）',
        description10db: '<strong>〈 従事する主な業務 〉</strong><br> 以下を例とする業務等が対象となる。<br>・素材加工（シートモケット加工 ／ 台車枠、構体部品加工等）<br>・部品組立て作業（輪軸（駆動装置）、配電盤等電気機器組立て ／ ドア、窓、ほろ、シート等内装設備品組立て等）<br>・構体組立て（台枠、屋根構体、側構体及び妻構体組立て ／ 構体（六面体）組立て等）<br>・塗装<br>・溶接<br>・ぎ装（機器取付け、配線、配管 ／ ドア、窓、天井、トイレ設備等内装部品取付け）<br>・台車枠製造<br>・台車組立て<br>・電子機器組立て（運転保安装置(ＡＴＣ装置やＡＴＳ装置)、制御装置、モニタ装置等の組立て）<br>・電気機器組立て（継電器等を使用した配電盤等の組立て）<br>・試験・検査（機能検査等）<br>・部品検収・配膳業務（倉庫管理及び部品等運搬等）',
        description10dc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・事務作業<br>・作業場所の整理整頓や清掃',
        description10e: '（運輸係員区分）',
        description10ea: '<strong>〈 分野、区分の概要 〉</strong><br> 運輸係員（駅係員、車掌、運転士等）',
        description10eb: '<strong>〈 従事する主な業務 〉</strong><br> 以下を例とする業務等が対象となる。<br>・ポイント操作（列車等の進路を決めるポイント操作、列車の進路に合わせた適正な鉄道信号の現示又は表示）<br>・入換え合図（列車等の転線、連結・分割等を行うための係員への合図）<br>・駅設備管理・取扱業務（駅の券売機・改札機等の管理、操作 ／ 設備故障時の一次修理対応）<br>・旅客案内・貨物取扱業務（通常時・異常時のホーム上安全確認や旅客案内 ／ 振替輸送時等の旅客案内 ／ 貨物の受付、一時留置場所・積載列車等の指定等）<br>・運行管理業務（列車ダイヤと列車運行の確認・管理 ／ 異常時における運休や増発の列車指定）<br>・車掌業務（列車内の旅客案内、運転士への合図 ／ 事故防止等に必要な安全確認 ／ 事故発生時の列車防護等による事故拡大防止等の対処を行う ／ 異常発生時等の避難誘導等）<br>・運転士業務（列車の運転には動力車操縦者運転免許要す）（列車等の運転（ワンマン列車運転の場合は車掌業務も兼任））',
        description10ec: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・事務作業<br>・作業場所の整理整頓や清掃',
        work11: '農業',
        description11a: '（耕種農業区分）',
        description11aa: '<strong>〈 分野、区分の概要 〉</strong><br> 栽培管理、農産物の集出荷・選別等の農作業',
        description11ab: '<strong>〈 従事する主な業務 〉</strong><br>・各作物に応じた土壌づくり<br>・施肥作業<br>・種子、苗木の取扱い<br>・資材、装置の取扱い<br>・栽培に関する作業<br>・安全衛生業務　等',
        description11ac: '<strong>〈 想定される関連業務 〉</strong><br>・特定技能所属機関（労働者派遣形態の場合は派遣先事業者）が生産した農畜産物を原料又は材料の一部として使用する製造又は加工の作業<br>・特定技能所属機関（労働者派遣形態の場合は派遣先事業者）による農畜産物の生産に伴う副産物（稲わら、家畜排泄物等）を原料又は材料の一部として使用する製造又は加工の作業<br>・農畜産物（特定技能所属機関（労働者派遣形態の場合は派遣先事業者）が生産した農畜産物が含まれる場合に限る。）の運搬、陳列又は販売の作業<br>・農畜産物を原料又は材料として製造され、又は加工された物（特定技能所属機関（労働者派遣形態の場合は派遣先事業者）が生産した農畜産物を原料又は材料の一部として使用し、製造され、又は加工された物が含まれる場合に限る。）の運搬、陳列又は販売の作業<br>・農畜産物の生産に伴う副産物を原料又は材料として製造され、又は加工された物（特定技能所属機関（労働者派遣形態の場合は派遣先事業者）による農畜産物の生産に伴う副産物を原料又は材料の一部として使用し、製造され、又は加工された物（たい肥等の肥料、飼料等）が含まれる場合に限る。）の運搬、陳列又は販売の作業<br>・その他特定技能所属機関（労働者派遣形態の場合は派遣先事業者）で耕種農業又は畜産農業の業務に従事する日本人が通常従事している作業（畜産農業と耕種農業を複合経営している特定技能所属機関（労働者派遣形態の場合は派遣先事業者）において畜産農業の技能を有する特定技能外国人が耕種農業の作業に従事する場合、冬場の除雪作業に従事する場合等）',
        description11b: '（畜産農業区分）',
        description11ba: '<strong>〈 分野、区分の概要 〉</strong><br> 飼養管理、畜産物の集出荷・選別等の農作業',
        description11bb: '<strong>〈 従事する主な業務 〉</strong><br>・各畜種に応じた器具の取扱い<br>・個体の取扱い、観察<br>・飼養管理<br>・生産物の取扱い<br>・安全衛生業務　等',
        description11bc: '<strong>〈 想定される関連業務 〉</strong><br>・特定技能所属機関（労働者派遣形態の場合は派遣先事業者）が生産した農畜産物を原料又は材料の一部として使用する製造又は加工の作業<br>・特定技能所属機関（労働者派遣形態の場合は派遣先事業者）による農畜産物の生産に伴う副産物（稲わら、家畜排泄物等）を原料又は材料の一部として使用する製造又は加工の作業<br>・農畜産物（特定技能所属機関（労働者派遣形態の場合は派遣先事業者）が生産した農畜産物が含まれる場合に限る。）の運搬、陳列又は販売の作業<br>・農畜産物を原料又は材料として製造され、又は加工された物（特定技能所属機関（労働者派遣形態の場合は派遣先事業者）が生産した農畜産物を原料又は材料の一部として使用し、製造され、又は加工された物が含まれる場合に限る。）の運搬、陳列又は販売の作業<br>・農畜産物の生産に伴う副産物を原料又は材料として製造され、又は加工された物（特定技能所属機関（労働者派遣形態の場合は派遣先事業者）による農畜産物の生産に伴う副産物を原料又は材料の一部として使用し、製造され、又は加工された物（たい肥等の肥料、飼料等）が含まれる場合に限る。）の運搬、陳列又は販売の作業<br>・その他特定技能所属機関（労働者派遣形態の場合は派遣先事業者）で耕種農業又は畜産農業の業務に従事する日本人が通常従事している作業（畜産農業と耕種農業を複合経営している特定技能所属機関（労働者派遣形態の場合は派遣先事業者）において畜産農業の技能を有する特定技能外国人が耕種農業の作業に従事する場合、冬場の除雪作業に従事する場合等）',
        work12: '漁業',
        description12a: '（漁業区分）',
        description12aa: '<strong>〈 分野、区分の概要 〉</strong><br> 漁具の製作・補修、水産動植物の探索、漁具・漁労機械の操作、水産動植物の採捕、漁獲物の処理・保蔵、安全衛生の確保等',
        description12ab: '<strong>〈 従事する主な業務 〉</strong><br>・釣りによる方法を主とした魚介類の捕獲(延縄漁、カツオ一本釣り漁、イカ釣り漁　等)<br>・網やカゴによる方法を主とした魚介類の捕獲(定置網漁、まき網漁、曳網漁　等)<br>・漁具（網、カゴ等）の修理作業<br>・ソナーや魚群探知機による魚群の探索<br>・漁に使用する網・縄を巻き上げる機械(ネット・ラインホーラー)、自動イカ釣り機等の機械操作<br>・漁獲物の選別、函詰め、冷凍作業、下処理<br>・漁港での漁獲物や漁具等の荷揚げ作業　等',
        description12ac: '<strong>〈 想定される関連業務 〉</strong><br>・漁具・漁労機械の点検・換装<br>・船体の補修・清掃<br>・魚倉、漁具保管庫、番屋の清掃<br>・漁船への餌、氷、燃油、食材、日用品その他の操業・生活資材の仕込み・積込み<br>・出漁に係る炊事・賄い<br>・採捕した水産動植物の生簀における畜養その他付随的な養殖<br>・自家生産物の運搬・陳列・販売<br>・自家生産物又は当該生産に伴う副産物を原料又は材料の一部として使用する製造・加工及び当該製造物・加工物の運搬・陳列・販売<br>・魚市場・陸揚港での漁獲物の選別・仕分け<br>・体験型漁業の際に乗客が行う水産動植物の採捕の補助<br>・社内外における研修',
        description12b: '（養殖業区分）',
        description12ba: '<strong>〈 分野、区分の概要 〉</strong><br> 養殖資材の製作・補修・管理、養殖水産動植物の育成管理、養殖水産動植物の収獲（穫）・処理、安全衛生の確保等',
        description12bb: '<strong>〈 従事する主な業務 〉</strong><br>・魚類や貝類、藻類などの育成<br>・養殖魚の給餌、死んだ魚や残餌等の除去<br>・養殖貝類の付着物の清掃<br>・養殖水産動植物の収獲（穫）、魚市場や陸揚港への運搬作業<br>・養殖貝類の殻剥き<br>・養殖池や網の清掃、水質等の管理<br>・養殖筏の製作、補修<br>・養殖水産動植物の種苗の生産、採捕　等',
        description12bc: '<strong>〈 想定される関連業務 〉</strong><br>・漁具・漁労機械の点検・換装<br>・船体の補修・清掃<br>・魚倉、漁具保管庫・番屋の清掃<br>・漁船への餌、氷、燃油、食材、日用品その他の操業・生活資材の仕込み・積込み<br>・養殖用の機械・設備・器工具等の清掃・消毒・管理・保守<br>・鳥獣に対する駆除、追払、防護ネット・テグス張り等の養殖場における食害防止<br>・養殖水産動植物の餌となる水産動植物や養殖用稚魚の採捕その他付随的な漁業<br>・自家生産物の運搬・陳列・販売<br>・自家生産物又は当該生産に伴う副産物を原料又は材料の一部として使用する製造・加工及び当該製造物・加工物の運搬・陳列・販売<br>・魚市場・陸揚港での漁獲物の選別・仕分け<br>・体験型漁業の際に乗客が行う水産動植物の採捕の補助<br>・社内外における研修',
        work13: '飲食料品製造業',
        description13a: '<strong>〈 分野、区分の概要 〉</strong><br> 飲食料品（酒類を除く。）の製造・加工、安全衛生の確保',
        description13b: '<strong>〈 従事する主な業務 〉</strong><br>・原料の処理、加熱、殺菌、成形、乾燥などの、生産に関わる一連の作業など<br>・業務で使う機械の安全確認や、作業者の衛生管理などの、業務上の安全衛生と食品衛生を守るための業務',
        description13c: '<strong>〈 想定される関連業務 〉</strong><br>・原料の調達・受入れ<br>・製品の納品<br>・清掃<br>・事業所の管理の作業',
        work14: '外食業',
        description14a: '<strong>〈 分野、区分の概要 〉</strong><br> 飲食物調理、接客、店舗管理',
        description14b: '<strong>〈 従事する主な業務 〉</strong><br>・飲食物調理（客に提供する飲食料品の調理、調製、製造を行うもの）<br> 例：食材仕込み、加熱調理、非加熱調理、調味、盛付け、飲食料品の調製等<br>・接客（客に飲食料品を提供するために必要な飲食物調理以外の業務を行うもの）<br> 例：席への案内、メニュー提案、注文伺い、配膳、下膳、カトラリーセッティング、代金受取り、商品セッティング、商品の受渡し、食器・容器等の回収、予約受付、客席のセッティング、苦情等への対応、給食事業所における提供先との連絡・調整 等<br>・店舗管理（店舗の運営に必要となる上記２業務以外のもの）<br> 例：店舗内の衛生管理全般、従業員のシフト管理、求人・雇用に関する事務、従業員の指導・研修に関する事務、予約客情報・顧客情報の管理、レジ・券売機管理、会計事務管理、社内本部・取引事業者・行政等との連絡調整、各種機器・設備のメンテナンス、食材・消耗品・備品の補充、発注、検品又は数量管理、メニューの企画・開発、メニューブック・POP 広告等の作成、宣伝・広告の企画、店舗内外・全体の環境整備、店内オペレーションの改善、作業マニュアルの作成・改訂等',
        description14c: '<strong>〈 想定される関連業務 〉</strong><br>・店舗において原材料として使用する農林水産物の生産<br>・客に提供する調理品等以外の物品の販売',
        work15: '林業',
        description15a: '<strong>〈 分野、区分の概要 〉</strong><br> 森林において樹木を育てて丸太を生産し、苗木を植える等の作業に従事',
        description15b: '<strong>〈 従事する主な業務 〉</strong><br>・苗木を植え、樹木を育てる作業<br>・丸太を生産する作業 等',
        description15c: '<strong>〈 想定される関連業務 〉</strong><br>当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次のものなどが想定される。<br>・生産した丸太を使用して行う加工等の作業<br>・丸太の生産に伴う副産物（樹皮、つる等）を使用して行う製造等の作業<br>・機器・装置・工具等の保守管理<br>・資材の管理・運搬<br>・事業所等の清掃作業',
        work16: '木材産業',
        description16a: '<strong>〈 分野、区分の概要 〉</strong><br> 木材・木製品の製造・加工<br>（家具や建具などの装備品を除く。）',
        description16b: '<strong>〈 従事する主な業務 〉</strong><br> 製材／単板（ベニヤ）製造／木材チップ製造／合板製造／集成材製造／プレカット加工／銘木製造／床板製造',
        description16c: '<strong>〈 想定される関連業務 〉</strong><br>・原材料（原木・資材）の調達・受入れ作業<br>・製品の検査<br>・製品の出荷作業（運搬・梱包・積込み）<br>・作業場所の整理整頓や清掃',
      }
    }
  },
  vi: {
    // HomePage
    bannerTitle: 'Hãy cùng nhau trưởng thành hướng tới cuộc sống hạnh phúc trong sự tôn trọng lẫn nhau',
    bannerSubtitle: 'Building the future toward the realization of a safe and reliable digital society',
    ourServices: 'Dịch vụ',
    pickUp: 'Đề xuất',
    // Navigation Buttons
    greeting: 'LỜI CHÀO<br>Lời chào của CEO',
    vision: 'TẦM NHÌN<br>Triết lý và Tầm nhìn Quản lý',
    companyProfile: 'HỒ SƠ CÔNG TY<br>Tổng quan Công ty',
    welfare: 'PHÚC LỢI<br>Phúc lợi',
    target: 'MỤC TIÊU<br>Mục tiêu quản lý',
    history: 'LỊCH SỬ<br>Lịch sử',
    // NavBar
    achievementsNavBar: 'Thành tựu',
    companyNavBar: 'Tất cả thông tin công ty',
    visionNavBar: 'Triết lý và Tầm nhìn Quản lý',
    companyProfileNavBar: 'Tổng quan Công ty',
    welfareNavBar: 'Phúc lợi',
    targetNavBar: 'Mục tiêu quản lý',
    historyNavBar: 'Lịch sử',
    solution: 'Tất cả nội dung kinh doanh',
    itsolution: 'Nội dung kinh doanh CNTT',
    t1solution: 'Cơ quan hỗ trợ đăng ký',
    t2solution: 'Giới thiệu việc làm có trả tiền',
    right: '   ',
    ses: 'Kinh doanh SES',
    appDev: 'Phát triển Ứng dụng',
    develop: 'thành tích phát triển',
    skill: 'kỹ năng',
    dispatch: 'Hỗ trợ nhân sự ngành khác',
    // Footer
    companyNameFooter: 'Công ty TNHH<br />GrowthSoft',
    address: 'Số 1-7-10 Iidabashi, Chiyoda-ku, Tokyo 102-0072<br />Tầng 7, Tòa nhà Yamakyu Main Building',
    phone: 'Điện thoại: 03-6265-4936',
    email: 'Email: info@growthsoft.co.jp',
    links: 'Liên kết',
    home: 'Trang chủ',
    companyInfo: 'Thông tin công ty',
    solutions: 'Nội dung kinh doanh',
    recruitmentInfo: 'Thông tin tuyển dụng',
    contact: 'Liên hệ',
    copyright: 'Bản quyền © 2024. Công ty TNHH GrowthSoft. Bảo lưu mọi quyền.',
    // Greeting Section
    greetingTitle: 'Lời chào',
    greetingMission: '<strong>Sứ mệnh và Mục tiêu</strong><br>Tại GrowthSoft, ưu tiên hàng đầu của chúng tôi là sự thành công của doanh nghiệp khách hàng, và chúng tôi cam kết cung cấp các giải pháp CNTT sáng tạo. Sử dụng kinh nghiệm và chuyên môn phong phú của chúng tôi trong các ngành công nghiệp khác nhau, chúng tôi nỗ lực cung cấp các giải pháp tốt nhất.',
    greetingService: '<strong>Tính linh hoạt và Quan hệ tin cậy của Dịch vụ</strong><br>Chúng tôi cung cấp các dịch vụ linh hoạt và hiệu quả phù hợp với nhu cầu của khách hàng, luôn vượt qua sự mong đợi của họ. Chúng tôi coi trọng việc xây dựng quan hệ tin cậy thông qua việc giới thiệu các công nghệ tiên tiến và cải tiến liên tục.',
    greetingEmployee: '<strong>Sự phát triển và Đóng góp của Nhân viên</strong><br>Thành công của chúng tôi được hỗ trợ bởi sự phát triển và đóng góp của từng nhân viên. Chúng tôi tạo ra một môi trường mà nhân viên có thể phát huy tối đa khả năng của mình và tiếp tục phát triển cùng nhau, hướng tới sự phát triển của toàn bộ tổ chức. Với tinh thần tôn trọng và hợp tác, chúng tôi đóng góp vào sự thành công của khách hàng.',
    greetingFuture: '<strong>Thách thức và Tạo ra Giá trị cho Tương lai</strong><br>Trong một thế giới công nghệ tiến bộ từng ngày, chúng tôi luôn thách thức bản thân và nỗ lực tạo ra giá trị mới. Chúng tôi hứa sẽ cùng khách hàng mở ra những tương lai mới. Chúng tôi chân thành mong nhận được sự ủng hộ và yêu thương từ các bạn.',
    map: 'Chỉ đường',
    mapcontext: 'Công ty cổ phần GrowthSoft<br />〒102-0072<br />Tầng 7, Tòa nhà Sankyo (khu chính), 1-7-10 Iidabashi, Quận Chiyoda, Tokyo<br />Điện thoại: 03-6265-4936<br />Email: info@growthsoft.co.jp<br /><br />Chỉ đường từ các ga lân cận:<br />[Tuyến Tozai]<br />Đi bộ 5 phút từ cửa ra số 7 Ga Kudanshita<br />[Tuyến Shinjuku / Tuyến Hanzomon]<br />Đi bộ 6 phút từ cửa ra số 3a Ga Kudanshita<br />[Tuyến Tozai / Tuyến Namboku / Tuyến Oedo / Tuyến Yurakucho]<br />Đi bộ 5 phút từ cửa ra A4 Ga Iidabashi<br />[Tuyến JR Sobu]<br />Đi bộ 6 phút từ cửa Đông Ga JR Iidabashi',
    maplinks: 'Xem trên Google Maps',
    mapcompanyName: 'Công ty cổ phần GrowthSoft',
    mapaddress: '〒102-0072 <br />Tầng 7, Tòa nhà Sankyo (khu chính), 1-7-10 Iidabashi, Quận Chiyoda, Tokyo',
    mapphone: 'Điện thoại: 03-6265-4936',
    mapemail: 'Email: info@growthsoft.co.jp',
    mapcontextTitle: '<br />Chỉ đường từ các ga lân cận',
    mapcontext1: '<br />[Tuyến Tozai] <br />Đi bộ 5 phút từ cửa ra số 7 Ga Kudanshita',
    mapcontext2: '<br />[Tuyến Shinjuku / Tuyến Hanzomon] <br />Đi bộ 6 phút từ cửa ra số 3a Ga Kudanshita',
    mapcontext3: '<br />[Tuyến Tozai / Tuyến Namboku / Tuyến Oedo / Tuyến Yurakucho] <br />Đi bộ 5 phút từ cửa ra A4 Ga Iidabashi',
    mapcontext4: '<br />[Tuyến JR Sobu] <br />Đi bộ 6 phút từ cửa Đông Ga JR Iidabashi',
    ceoName: 'Vương Cường',
    // Vision Section
    visionTitle: 'Triết lý và Tầm nhìn Quản lý',
    visionMission: '<strong>Sứ mệnh và Mục tiêu</strong><br>Triết lý quản lý của chúng tôi là phát triển và đạt được cuộc sống hạnh phúc bằng cách tôn trọng lẫn nhau với khách hàng, nhân viên và xã hội nói chung. Chúng tôi luôn tuân thủ các tiêu chuẩn đạo đức cao và đóng góp vào sự phát triển bền vững của xã hội bằng cách xây dựng lòng tin.',
    visionService: '<strong>Tính linh hoạt và Quan hệ tin cậy của Dịch vụ</strong><br>Chúng tôi cung cấp công nghệ và dịch vụ vượt trội cho khách hàng, đề xuất các giải pháp vượt qua sự mong đợi của họ. Chúng tôi cung cấp cơ hội phát triển và môi trường làm việc thoải mái cho nhân viên, tôn trọng con đường sự nghiệp của từng người. Chúng tôi chú trọng bảo vệ môi trường và đóng góp cho cộng đồng, thực hiện kinh doanh bền vững.',
    visionEmployee: '<strong>Sự phát triển và Đóng góp của Nhân viên</strong><br>Chúng tôi nỗ lực đạt được cuộc sống hạnh phúc trong sự tôn trọng lẫn nhau và phát triển cùng nhau. Để thực hiện tầm nhìn này, chúng tôi tiếp cận công việc hàng ngày với sự chân thành và đam mê.',
    // Company Profile Section
    companyProfileTitle: 'Tổng quan Công ty',
    companyNameLabel: 'Tên công ty',
    companyName: 'Công ty TNHH GrowthSoft',
    capitalLabel: 'Vốn',
    capital: '15,000,000 JPY',
    ceoLabel: 'Đại diện',
    foundedLabel: 'Thành lập',
    founded: 'Ngày 4 tháng 9 năm 2023',
    employeesLabel: 'Số lượng nhân viên',
    employees: '22',
    headquartersLabel: 'Trụ sở chính',
    headquarters: 'Số 1-7-10 Iidabashi, Chiyoda-ku, Tokyo 102-0072, Tòa nhà Yamakyu Main Building, Tầng 7',
    phoneLabel: 'Điện thoại',
    phone: '03-6265-4936',
    banks: 'Ngân hàng giao dịch',
    bank1: 'Ngân hàng Sumitomo Mitsui',
    bank2: 'Ngân hàng trực tuyến GMO Aozora',
    qualifications: 'Tư cách',
    qualification1: 'Hóa đơn đủ điều kiện　T8013301051315',
    qualification2: 'Tổ chức hỗ trợ đăng ký　24登-010800',
    qualification3: 'Giới thiệu việc làm có thu phí　13-ユ-317559',
    qualification4: 'Điều phối công nhân　（派）13-318368',
    // Welfare Section
    welfareTitle: 'Phúc lợi',
    insurance: 'Bảo hiểm',
    insuranceDetails: 'Bảo hiểm y tế, Lương hưu phúc lợi, Bảo hiểm thất nghiệp, Bảo hiểm tai nạn lao động, Đóng góp nuôi dưỡng trẻ em',
    vacation: 'Kỳ nghỉ',
    vacationDetails: 'Nghỉ thai sản, Nghỉ chăm sóc con, Hệ thống nghỉ phép chăm sóc, Hệ thống thời gian làm việc linh hoạt, Hệ thống làm việc ngắn hạn (Mang thai, Chăm sóc con, Chăm sóc)',
    allowances: 'Phụ cấp',
    allowancesDetails: 'Phụ cấp đi lại, Phụ cấp chuyên cần, Phụ cấp làm thêm giờ, Phụ cấp nhà ở, Phụ cấp đặc biệt cuối năm, Hỗ trợ đạt chứng chỉ, Hỗ trợ chi phí hội thảo',
    // History Section
    HistoryTitle: 'Lịch sử phát triển',
    Historyyear1: 'Ngày 4 tháng 9 năm 2023',
    Historyevent1: '・Thành lập Công ty Cổ phần GrowthSoft',
    Historyyear2: 'Ngày 15 tháng 4 năm 2024',
    Historyevent2: '・Chuyển trụ sở chính đến Iidabashi, quận Chiyoda do mở rộng kinh doanh<br>・Tăng vốn điều lệ lên 50 triệu yên',
    Historyyear3: 'Ngày 1 tháng 6 năm 2024',
    Historyevent3: '・Đăng ký là doanh nghiệp phát hành hóa đơn đủ điều kiện',
    Historyyear4: 'Ngày 31 tháng 8 năm 2024',
    Historyevent4: '・Đạt doanh thu 35 triệu yên',
    Historyyear5: 'Ngày 10 tháng 10 năm 2024',
    Historyevent5: '・Đăng ký là tổ chức hỗ trợ được chứng nhận',
    Historyyear6: 'Ngày 1 tháng 1 năm 2025',
    Historyevent6: '・Được cấp giấy phép dịch vụ giới thiệu việc làm có thu phí',
    Historyyear7: 'Ngày 3 tháng 7 năm 2025',
    Historyevent7: '・Tăng vốn lên 15 triệu yên',
    Historyyear8: 'Ngày 31 tháng 8 năm 2025',
    Historyevent8: '・Đạt doanh thu 875 triệu yên',
    Historyyear9: 'Ngày 1 tháng 1 năm 2026',
    Historyevent9: '・Đã nhận được giấy phép kinh doanh dịch vụ cung ứng lao động',
    // Target Section
    TargetMainTitle: 'Mục tiêu quản lý',
    TargetTitle: 'Kế hoạch doanh thu trung và dài hạn',
    Targetyear: 'Năm 1: 30 triệu yên<br>Năm 2: 70 triệu yên<br>Năm 3: 110 triệu yên',
    Targetyear1: 'Năm 1: 30 triệu yên',
    Targetyear2: 'Năm 2: 70 triệu yên',
    Targetyear3: 'Năm 3: 110 triệu yên',
    // Other
    blank: '',
    line: '-',
    joinus: 'join us',
    mapTitle: 'MAP',
    home1: 'HOME',
    companyInfo1: 'Company',
    solutions1: 'Business',
    recruitmentInfo1: 'Recruit',
    contact1: 'Contact',
    language1: 'Language',
    language: 'Ngôn ngữ',
    languages: {
      ja: '日本語',
      zh: '中文',
      en: 'English',
      ko: '한국어',
      vi: 'Tiếng Việt',
    },
    recruitment: {
      bannerTitle: 'Hãy cùng nhau trưởng thành hướng tới cuộc sống hạnh phúc trong sự tôn trọng lẫn nhau',
      bannerSubtitle: 'Let\'s respect each other and strive towards a happy life',
      bannerButton: 'Xem chi tiết',
      title: 'Thông tin tuyển dụng',
      description: 'GrowthSoft đang nhận đơn đăng ký cho các vị trí sau.<br>Nhấp vào tên công việc để xem chi tiết.',
      applyButton: 'Ứng tuyển',
      newGraduate: 'Tuyển dụng sinh viên mới tốt nghiệp',
      careerRecruitment: 'Tuyển dụng giữa kỳ',
      seconedGraduate: 'Tốt nghiệp lần thứ hai',
      job1: {
        title: 'Tuyển dụng nhân viên mới',
        details: [
          {
            title: 'Điều kiện ứng tuyển',
            content: [
              {
                label: 'Yêu cầu bắt buộc',
                value: `
                  <li>Tốt nghiệp đại học (Trường cao đẳng bắt buộc là chuyên ngành liên quan đến CNTT)</li>
                  <li>Vui vẻ, hòa đồng, có kỹ năng giao tiếp tốt</li>
                  <li>Chú trọng làm việc nhóm</li>
                `
              }
            ]
          },
          {
            title: 'Lương và phúc lợi',
            content: [
              {
                label: 'Thu nhập dự kiến',
                value: 'Từ 3,000,000 ~ 4,000,000 yên/năm<br>*Tùy thuộc vào kinh nghiệm và năng lực'
              },
              {
                label: '',
                value: `
                  <li>Quyết định dựa trên quy định công ty và đánh giá toàn diện</li>
                  <li>Thời gian thử việc 3 tháng (không thay đổi điều kiện)</li>
                  <li>Tăng lương 1 lần/năm</li>
                  <li>Thưởng 2 lần/năm (Có thể có thưởng đặc biệt cuối năm tùy theo kết quả làm việc)</li>
                `
              },
              {
                label: 'Ngày nghỉ và chế độ nghỉ phép',
                value: `
                  <li>Làm việc 5 ngày/tuần (Nghỉ thứ 7, CN và ngày lễ)</li>
                  <li>Có ngày nghỉ phép có lương từ ngày vào công ty (10 ngày trong năm đầu tiên)</li>
                  <li>Nghỉ cuối năm và đầu năm mới</li>
                  <li>Nghỉ hiếu hỷ</li>
                  <li>Nghỉ sinh con</li>
                  <li>Chế độ nghỉ nuôi con</li>
                  <li>Nghỉ cưới</li>
                  <li>Nghỉ chăm sóc người thân</li>
                `
              },
              {
                label: 'Hỗ trợ thi lấy chứng chỉ',
                value: `
                  Lệ phí thi sẽ được chi trả và tiền thưởng khi vượt qua kỳ thi sẽ dao động từ 5.000 yên đến 100.000 yên tùy theo mức độ khó.<br><br>
                  【ví dụ】
                  <li>Chứng chỉ Project Manager: 80,000 yên</li>
                  <li>Applied Information Engineer: 30,000 yên</li>
                  <li>Fundamental Information Engineer: 10,000 yên</li>
                  <li>AWS FOUNDATIONAL: 15,000 yên</li>
                  <li>AWS ASSOCIATE: 30,000 yên</li>
                  <li>AWS PROFESSIONAL: 50,000 yên</li>
                  <li>AWS SPECIALTY: 50,000 yên</li>
                  <li>IT Passport: 5,000 yên</li>
                  <li>TOEIC: 20,000 ~ 80,000 yên</li>
                  <li>Hỗ trợ các chứng chỉ khác như Cisco, Azure, GCP, Oracle, SAP,...</li>
                `
              }
            ]
          },
          {
            title: 'Giờ làm việc',
            content: '※ Có thể thay đổi tùy theo dự án'
          },
          {
            title: 'Địa điểm làm việc',
            content: 'Tokyo / Kanagawa / Chiba / Saitama'
          }
        ]
      },
      job2: {
        title: 'Tuyển dụng kỹ sư có kinh nghiệm',
        details: [
          {
            title: 'Nội dung công việc',
            content: 'Làm kỹ sư phát triển hệ thống tại các công ty khách hàng như SIer thuộc tập đoàn lớn, công ty sản xuất, công ty sử dụng hệ thống. Tham gia từ khâu định nghĩa yêu cầu, thiết kế cơ bản, thiết kế chi tiết, phát triển, test đến bảo trì.'
          },
          {
            title: 'Điều kiện ứng tuyển',
            content: [
              {
                label: 'Yêu cầu bắt buộc',
                value: `
                  <li>Có ít nhất 1 năm kinh nghiệm phát triển hệ thống</li>
                  <li>Có kinh nghiệm lập trình, sử dụng thành thạo các ngôn ngữ như Java, Python, C++</li>
                `
              },
              {
                label: 'Ưu tiên',
                value: `
                  <li>Có kinh nghiệm vận hành, bảo trì đồng thời với phát triển gần đây</li>
                  <li>Có kinh nghiệm làm PM, PL hoặc đào tạo nhân viên</li>
                  <li>Có kinh nghiệm phát triển ứng dụng Web hoặc Mobile</li>
                  <li>Có kinh nghiệm thiết kế và vận hành cơ sở dữ liệu (DB)</li>
                `
              }
            ]
          },
          {
            title: 'Lương và phúc lợi',
            content: [
              {
                label: 'Thu nhập dự kiến',
                value: 'Từ 5,000,000 ~ 10,000,000 yên/năm<br>*Tùy thuộc vào kinh nghiệm'
              },
              {
                label: '',
                value: `
                  <li>Quyết định theo quy định công ty dựa trên độ tuổi, kinh nghiệm và năng lực</li>
                  <li>Thử việc 3 tháng (Không thay đổi điều kiện)</li>
                  <li>Tăng lương 1 lần/năm</li>
                  <li>Thưởng 2 lần/năm (Có thể có thưởng đặc biệt cuối năm)</li>
                `
              },
              {
                label: 'Ngày nghỉ và chế độ nghỉ phép',
                value: `
                  <li>Làm việc 5 ngày/tuần (Nghỉ thứ 7, CN và ngày lễ)</li>
                  <li>Có ngày nghỉ phép có lương từ ngày vào công ty (10 ngày trong năm đầu tiên)</li>
                  <li>Nghỉ cuối năm và đầu năm mới</li>
                  <li>Nghỉ hiếu hỷ</li>
                  <li>Nghỉ sinh con</li>
                  <li>Chế độ nghỉ nuôi con</li>
                  <li>Nghỉ cưới</li>
                  <li>Nghỉ chăm sóc người thân</li>
                `
              },
              {
                label: 'Hỗ trợ thi lấy chứng chỉ',
                value: `
                  Lệ phí thi sẽ được chi trả và tiền thưởng khi vượt qua kỳ thi sẽ dao động từ 5.000 yên đến 100.000 yên tùy theo mức độ khó.<br><br>
                  【ví dụ】
                  <li>Chứng chỉ Project Manager: 80,000 yên</li>
                  <li>Applied Information Engineer: 30,000 yên</li>
                  <li>Fundamental Information Engineer: 10,000 yên</li>
                  <li>AWS FOUNDATIONAL: 15,000 yên</li>
                  <li>AWS ASSOCIATE: 30,000 yên</li>
                  <li>AWS PROFESSIONAL: 50,000 yên</li>
                  <li>AWS SPECIALTY: 50,000 yên</li>
                  <li>IT Passport: 5,000 yên</li>
                  <li>TOEIC: 20,000 ~ 80,000 yên</li>
                  <li>Hỗ trợ các chứng chỉ khác như Cisco, Azure, GCP, Oracle, SAP,...</li>
                `
              }
            ]
          },
          {
            title: 'Giờ làm việc',
            content: '※ Có thể thay đổi tùy theo dự án'
          },
          {
            title: 'Địa điểm làm việc',
            content: 'Tokyo / Kanagawa / Chiba / Saitama'
          }
        ]
      },
      job3: {
        title: 'Tuyển dụng sinh viên tốt nghiệp lần 2',
        details: [
          {
            title: 'Điều kiện ứng tuyển',
            content: [
              {
                label: 'Yêu cầu bắt buộc',
                value: `
                  <li>Tốt nghiệp đại học (Trường cao đẳng bắt buộc là chuyên ngành liên quan đến CNTT)</li>
                  <li>Vui vẻ, hòa đồng, có kỹ năng giao tiếp tốt</li>
                  <li>Chú trọng làm việc nhóm</li>
                `
              }
            ]
          },
          {
            title: 'Lương và phúc lợi',
            content: [
              {
                label: 'Thu nhập dự kiến',
                value: 'Từ 3,000,000 ~ 4,000,000 yên/năm<br>*Tùy thuộc vào kinh nghiệm và năng lực'
              },
              {
                label: '',
                value: `
                  <li>Quyết định dựa trên quy định công ty và đánh giá toàn diện</li>
                  <li>Thử việc 3 tháng (Không thay đổi điều kiện)</li>
                  <li>Tăng lương 1 lần/năm</li>
                  <li>Thưởng 2 lần/năm (Có thể có thưởng đặc biệt cuối năm)</li>
                `
              },
              {
                label: 'Ngày nghỉ và chế độ nghỉ phép',
                value: `
                  <li>Làm việc 5 ngày/tuần (Nghỉ thứ 7, CN và ngày lễ)</li>
                  <li>Có ngày nghỉ phép có lương từ ngày vào công ty (10 ngày trong năm đầu tiên)</li>
                  <li>Nghỉ cuối năm và đầu năm mới</li>
                  <li>Nghỉ hiếu hỷ</li>
                  <li>Nghỉ sinh con</li>
                  <li>Chế độ nghỉ nuôi con</li>
                  <li>Nghỉ cưới</li>
                  <li>Nghỉ chăm sóc người thân</li>
                `
              },
              {
                label: 'Hỗ trợ thi lấy chứng chỉ',
                value: `
                  Lệ phí thi sẽ được chi trả và tiền thưởng khi vượt qua kỳ thi sẽ dao động từ 5.000 yên đến 100.000 yên tùy theo mức độ khó.<br><br>
                  【ví dụ】
                  <li>Chứng chỉ Project Manager: 80,000 yên</li>
                  <li>Applied Information Engineer: 30,000 yên</li>
                  <li>Fundamental Information Engineer: 10,000 yên</li>
                  <li>AWS FOUNDATIONAL: 15,000 yên</li>
                  <li>AWS ASSOCIATE: 30,000 yên</li>
                  <li>AWS PROFESSIONAL: 50,000 yên</li>
                  <li>AWS SPECIALTY: 50,000 yên</li>
                  <li>IT Passport: 5,000 yên</li>
                  <li>TOEIC: 20,000 ~ 80,000 yên</li>
                  <li>Hỗ trợ các chứng chỉ khác như Cisco, Azure, GCP, Oracle, SAP,...</li>
                `
              }
            ]
          },
          {
            title: 'Giờ làm việc',
            content: '※ Có thể thay đổi tùy theo dự án'
          },
          {
            title: 'Địa điểm làm việc',
            content: 'Tokyo / Kanagawa / Chiba / Saitama'
          }
        ]
      },
      job4: {
        title: 'Hỗ trợ nhân sự ngành khác',
        details: [
          {
            title: 'Điều kiện ứng tuyển',
            content: [
              {
                label: 'Điều kiện bắt buộc',
                value: `
                  <li>Tính cách tốt và kỹ năng giao tiếp mạnh</li>
                  <li>Khả năng làm việc hợp tác trong nhóm</li>
                  <li>Khả năng thực hiện công việc nhanh chóng và chính xác</li>
                  <li>Khả năng thích ứng với môi trường mới</li>
                `
              }
            ]
          },
          {
            title: 'Đãi ngộ',
            content: [
              {
                label: 'Thu nhập hàng năm dự kiến',
                value: '2.8 triệu đến 4.5 triệu JPY<br>※Ưu đãi theo kinh nghiệm'
              },
              {
                label: '',
                value: `
                  <li>Quyết định theo quy định công ty, xem xét khả năng, kinh nghiệm, tuổi tác, v.v.</li>
                  <li>Thời gian thử việc: Có (3 tháng, không thay đổi điều kiện làm việc)</li>
                  <li>Tăng lương: Một lần mỗi năm</li>
                  <li>Thưởng: Hai lần mỗi năm (có thể có thưởng quyết toán)</li>
                `
              }
            ]
          },
          {
            title: 'Địa điểm làm việc',
            content: 'Tokyo/Kanagawa/Chiba/Saitama'
          }
        ]
      }
    },
    contactUs: {
      title: 'Liên hệ',
      inquiryType: 'Loại hình liên hệ',
      name: 'Tên',
      lastName: 'Họ',
      firstName: 'Tên',
      companyName: 'Tên công ty hoặc tổ chức',
      departmentName: 'Tên bộ phận',
      email: 'Địa chỉ email',
      phone: 'Số điện thoại',
      message: 'Nội dung liên hệ',
      submitButton: 'Gửi',
      required: 'Bắt buộc',
      optional: 'Tùy chọn',
      select: 'Vui lòng chọn',
      newGraduate: 'Tuyển dụng sinh viên mới tốt nghiệp',
      careerRecruitment: 'Tuyển dụng giữa kỳ',
      seconedGraduate: 'Tốt nghiệp lần thứ hai',
      serviceInquiry: 'Liên hệ về dịch vụ hoặc công ty',
      other: 'Khác',
      validationMessage: 'Vui lòng điền vào trường này.',
      successMessage: 'Tin nhắn đã được gửi!',
      errorMessage: 'Gửi tin nhắn thất bại. Vui lòng thử lại.'
    },
    solutionInfo: {
      title: 'Nội dung dịch vụ',
      overview: 'Tổng quan',
      technicalFields: 'Lĩnh vực kỹ thuật',
      services: 'Nội dung dịch vụ',
      ses: {
        title: 'Kinh doanh SES',
        description: 'Công ty chúng tôi cung cấp đầy đủ các dịch vụ từ phát triển hệ thống đến vận hành và bảo trì, với hoạt động kinh doanh SES (Dịch vụ kỹ thuật hệ thống) là cốt lõi. Chúng tôi có thể đáp ứng nhiều nhu cầu khác nhau, từ giai đoạn phát triển dự án cho đến di chuyển, bảo trì và vận hành. ',
        description1: 'Chúng tôi cũng có nhiều kỹ sư nước ngoài xuất sắc trong biên chế, cung cấp dịch vụ chất lượng cao và tiết kiệm chi phí. Vui lòng liên hệ với chúng tôi để được báo giá. ',
        frontend: 'Frontend',
        languages: 'Ngôn ngữ phát triển',
        database: 'Cơ sở dữ liệu',
        frontendContent: 'Vue.js, React.js, Angular.js, v.v.',
        languagesContent: 'Java, C, C++, C#, JavaScript, TypeScript, VB.NET, ASP.NET, COBOL, PHP, v.v.',
        databaseContent: 'Oracle, MySQL, PostgreSQL, SQLserver, MongoDB, v.v.'
      },
      appDev: {
        title: 'Phát triển Ứng dụng',
        description: 'Trong lĩnh vực phát triển ứng dụng, chúng tôi lập kế hoạch, phát triển và vận hành các ứng dụng điện thoại thông minh và ứng dụng web. Chúng tôi sử dụng công nghệ mới nhất để cung cấp cho người dùng những ứng dụng dễ sử dụng. ',
        services: 'Chúng tôi cung cấp hỗ trợ toàn diện từ định nghĩa yêu cầu, thiết kế, phát triển, thử nghiệm đến phát hành. Chúng tôi phát triển các ứng dụng tối ưu hóa cho mô hình kinh doanh của khách hàng, nâng cao tính cạnh tranh của họ.'
      },
      skill: {
        title: 'Kỹ năng sở hữu',
        description: 'Đội ngũ của chúng tôi có khả năng thích ứng và linh hoạt cao trong việc đáp ứng các lĩnh vực kỹ thuật đa dạng, đồng thời đề xuất các giải pháp tối ưu phù hợp với yêu cầu của nhiều ngành nghề khác nhau.',
        description1: 'Đối với các vấn đề kinh doanh phức tạp, chúng tôi sẽ giải quyết bằng cách tiếp cận sáng tạo và thực tế. Chúng tôi có nhiều kinh nghiệm dự án trong các ngành như chứng khoán, ngân hàng, bảo hiểm và các lĩnh vực khác.',
        description2: 'Chúng tôi sẽ tận dụng kiến thức đã có để đáp ứng nhanh chóng và tối ưu với yêu cầu cụ thể của khách hàng. Chúng tôi cũng liên tục nâng cao năng lực kỹ thuật trong tương lai.',
        environment: 'Môi trường phát triển',
        languages: 'Ngôn ngữ phát triển',
        database: 'Cơ sở dữ liệu',
        environmentContent: 'Windows, Linux, v.v.',
        languagesContent: 'Java, C, C++, C#, JavaScript, TypeScript, VB.NET, ASP.NET, COBOL, PHP, v.v.',
        databaseContent: 'Oracle, MySQL, PostgreSQL, SQL Server, MongoDB, v.v.'
      },
      develop: {
        title: 'Thực hiện phát triển',
        Webtitle: 'Hệ thống Web',
        WebNameLabel1: 'Hệ thống quản lý tồn kho',
        WebNameLabel2: 'Hệ thống quản lý sản phẩm',
        WebNameLabel3: 'Hệ thống quản lý khách hàng',
        WebNameLabel4: 'Hệ thống quản lý sản xuất',
        WebNameLabel5: 'Hệ thống kết nối ATM',
        WebNameLabel6: 'Hệ thống logistics',
        WebNameLabel7: 'Hệ thống cơ sở hạ tầng',
        apptitle: 'Ứng dụng',
        appNameLabel1: 'iOS',
        appNameLabel2: 'Android',
        packagetitle: 'Ứng dụng cài đặt gói',
        packageNameLabel1: 'SAP',
        packageNameLabel2: 'Salesforce'
      },
      dispatch: {
        title: 'Hỗ trợ nhân sự ngành khác',
        description: 'Dịch vụ hỗ trợ nhân sự ngành khác cung cấp nhân viên xuất sắc với kỹ năng và kinh nghiệm cần thiết cho các công ty trong các ngành công nghiệp khác nhau. Chúng tôi nhanh chóng và chính xác kết nối nhân sự tốt nhất theo nhu cầu kinh doanh của khách hàng. Các ví dụ về ngành bao gồm khách sạn, nhà máy và nhà hàng.',
        services: 'Chúng tôi cung cấp dịch vụ toàn diện từ tuyển dụng, lựa chọn nhân sự đến theo dõi sau khi bắt đầu làm việc. Chúng tôi hỗ trợ sự thành công của khách hàng bằng cách cung cấp nhân sự phù hợp dựa trên nhu cầu kinh doanh của họ.'
      },
      t2solution: {
        title: 'Dịch vụ giới thiệu việc làm có tính phí',
        work01: 'Tuyển dụng IT (nội bộ / đối tác)',
        description01: 'Giới thiệu các công việc IT tại các công ty Nhật - Trung: phát triển web, AWS, hạ tầng IT,...',
        work02: 'Giới thiệu nhiều ngành nghề tại Nhật Bản',
        description02: 'Công việc văn phòng, biên phiên dịch, thương mại, kinh doanh, bán hàng,...',
        work03: 'Hỗ trợ du học và tiến cử học lên',
        description03: '(Miễn phí) Hỗ trợ đăng ký vào trường tiếng Nhật, tư vấn học lên đại học và cao học tại Nhật.',
        work04: 'Visa kỹ năng đặc định',
        description04: 'Chúng tôi hỗ trợ các ngành có liên quan đến thị thực kỹ năng cụ thể, chẳng hạn như dịch vụ ăn uống và chế biến thực phẩm.',
      },
      t1solution: {
        title: 'Dịch vụ của tổ chức hỗ trợ đăng ký',
        work0: 'Hỗ trợ chuẩn bị hồ sơ',
        work001: 'Soạn thảo kế hoạch hỗ trợ',
        description001: 'Khi doanh nghiệp muốn tuyển dụng lao động nước ngoài theo diện kỹ năng đặc định, chúng tôi hỗ trợ lên kế hoạch công việc và sinh hoạt cụ thể. Mọi chi tiết xin liên hệ để được tư vấn thêm.',
        work002: 'Soạn hồ sơ thay đổi tư cách lưu trú',
        description002: 'Cung cấp mẫu hồ sơ thay đổi tư cách lưu trú, hỗ trợ soạn thảo theo hướng dẫn của hành chính viên và nộp hồ sơ đến Cục xuất nhập cảnh tại các địa phương.',
        work1: '介護',
        description1a: '<strong>〈 分野、区分の概要 〉</strong><br> 高齢や障害で、生活をする時に介護が必要になった人たちへの身体介護等（介護を受ける人の状況にあわせて入浴、食事、排せつを助けること等）のほか、身体介護等に関係して助けが必要なしごと（レクリエーションの実施、リハビリテーションの補助等）<br>  ※介護を受ける人たちの家でするものは対象ではありません。',
        description1b: '<strong>〈 従事する主な業務 〉</strong><br> ・身体介護等（介護を受ける人の状況にあわせて入浴、食事、排せつを助けること等）<br> ・身体介護等に関係して助けが必要なしごと（レクリエーションの実施、リハビリテーションの補助等） ',
        description1c: '<strong>〈 想定される関連業務 〉</strong><br> 例：お知らせ等の掲示物の管理、物品の補充や管理',
        work2: 'ビルクリーニング',
        description2a: '<strong>〈 分野、区分の概要 〉</strong><br> 建築物内部の清掃',
        description2b: '<strong>〈 従事する主な業務 〉</strong><br> 多数の利用者が利用する建築物（住宅を除く。）の内部を対象に、衛生的環境の保護、美観の維持、安全の確保及び保全の向上を目的として、場所、部位、建材、汚れ等の違いに対し、方法、洗剤及び用具を適切に選択して清掃作業を行い、建築物に存在する環境上の物質を排除し、清潔さを維持する業務<br> ※床、浴室、トイレ、洗面台等の清掃からアメニティ補充やベッドメイク作業など、衛生かつ美観が整えられた客室を商品として納品するために必要な一連の業務である客室清掃業務は主な業務に含まれる。',
        description2c: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・複数の作業員の指導、現場の管理、計画作成や進行管理等<br>・清掃用機械器具の維持管理等に関する業務、技能実習責任者の業務、技能実習指導員の業務や、生活指導員の業務（それぞれ主たる業務に該当するものを除く。）<br>・建築物と構造上一体と見なせる部分（犬走・アプローチ等の外周部など）の清掃作業<br>・資機材倉庫の整備作業<br>・建物外部洗浄作業(外壁、屋上等。ただし高所作業を伴う窓ガラス・外壁清掃作業は除く。）<br>・ベッドメイク作業<br>・建築物内外の植裁管理作業（灌水作業等）<br>・資機材の運搬作業（他の現場に移動する場合等）',
        description2d: '<strong>〈 その他特記事項 〉</strong><br> ・詳細は以下の「ビルクリーニング分野特定技能外国人が従事できる業務について（令和５年 10 月 17 日ビルクリーニング分野特定技能協議会決定第１号）」を参照すること。',
        work3: '工業製品製造業',
        description3a: '（機械金属加工区分）',
        description3aa: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、素形材製品や産業機械等の製造工程の作業に従事',
        description3ab: '<strong>〈 従事する主な業務 〉</strong><br> 鋳造 ／ 鍛造 ／ ダイカスト ／ 機械加工 ／ 金属プレス加工 ／ 鉄工 ／ 工場板金 ／ 仕上げ ／ プラスチック成形 ／ 機械検査 ／ 機械保全 ／ 電気機器組立て ／ 塗装 ／ 溶接 ／ 工業包装 ／強化プラスチック成形 ／ 金属熱処理業',
        description3ac: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3b: '（電気電子機器組立て区分）',
        description3ba: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、電気電子機器等の製造工程、組立工程の作業に従事',
        description3bb: '<strong>〈 従事する主な業務 〉</strong><br> 機械加工 ／ 仕上げ ／ プラスチック成形 ／ プリント配線板製造 ／ 電子機器組立て ／ 電気機器組立て ／ 機械検査 ／ 機械保全 ／ 工業包装 ／強化プラスチック成形',
        description3bc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3c: '（金属表面処理区分）',
        description3ca: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、表面処理等の作業に従事',
        description3cb: '<strong>〈 従事する主な業務 〉</strong><br> めっき ／ アルミニウム陽極酸化処理',
        description3cc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3d: '（紙器・段ボール箱製造区分）',
        description3da: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、紙器・段ボール箱の製造工程の作業に従事',
        description3db: '<strong>〈 従事する主な業務 〉</strong><br> 紙器・段ボール箱製造',
        description3dc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3e: '（コンクリート製品製造区分）',
        description3ea: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、コンクリート製品の製造工程の作業に従事',
        description3eb: '<strong>〈 従事する主な業務 〉</strong><br> コンクリート製品製造 ',
        description3ec: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3f: '（RPF製造区分）',
        description3fa: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、破砕・成形等の作業に従事　',
        description3fb: '<strong>〈 従事する主な業務 〉</strong><br> ＲＰＦ製造',
        description3fc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3g: '（陶磁器製品製造区分）',
        description3ga: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、陶磁器製品の製造工程の作業に従事',
        description3gb: '<strong>〈 従事する主な業務 〉</strong><br> 陶磁器工業製品製造',
        description3gc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3h: '（印刷・製本区分）',
        description3ha: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、オフセット印刷、グラビア印刷、製本の製造工程の作業に従事 ',
        description3hb: '<strong>〈 従事する主な業務 〉</strong><br> 印刷 ／ 製本',
        description3hc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3i: '（紡織製品製造区分）',
        description3ia: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、紡織製品の製造工程の作業に従事',
        description3ib: '<strong>〈 従事する主な業務 〉</strong><br> 紡績運転 ／ 織布運転 ／ 染色 ／ ニット製品製造 ／ たて編ニット生地製造 ／カーペット製造 ',
        description3ic: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        description3j: '（縫製区分）',
        description3ja: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示を理解し、又は自らの判断により、縫製工程の作業に従事',
        description3jb: '<strong>〈 従事する主な業務 〉</strong><br> 婦人子供服製造 ／ 紳士服製造 ／ 下着類製造 ／ 寝具製作 ／ 帆布製品製造 ／布はく縫製 ／ 座席シート縫製',
        description3jc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・原材料・部品の調達・搬送作業<br>・各職種の前後工程作業<br>・クレーン・フォークリフト等運転作業<br>・清掃・保守管理作業<br>※専ら関連業務に従事することは認められない。',
        work4: '建設',
        description4a: '（土木区分）',
        description4aa: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示・監督を受けながら、土木施設の新設、改築、維持、修繕に係る作業等に従事',
        description4ab: '<strong>〈 従事する主な業務 〉</strong><br> 型枠施工 ／ コンクリート圧送 ／ トンネル推進工 ／ 建設機械施工 ／ 土工 ／ 鉄筋施工 ／ とび ／ 海洋土木工<br> その他、土木施設の新設、改築、維持、修繕に係る作業',
        description4ac: '<strong>〈 想定される関連業務 〉</strong><br>・原材料・部品の調達・搬送<br>・機器・装置・工具等の保守管理<br>・足場の組立て、設備の掘り起こしその他の後工程の準備作業<br>・足場の解体、設備の埋め戻しその他の前工程の片付け作業<br>・清掃・保守管理作業<br>・その他、主たる業務に付随して行う作業',
        description4ad: '<strong>〈 その他特記事項 〉</strong><br> 業務の詳細については、以下の国土交通省のウェブサイト中「◆業務区分と試験及び技能実習等との対応関係」の「業務区分と建設業許可工事業との対応関係」をご覧ください。',
        description4b: '（建築区分）',
        description4ba: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示・監督を受けながら、建築物の新築、増築、改築若しくは移転又は修繕若しくは模様替に係る作業等に従事',
        description4bb: '<strong>〈 従事する主な業務 〉</strong><br> 型枠施工 ／ 左官 ／ コンクリート圧送 ／ 屋根ふき ／ 土工 ／ 鉄筋施工 ／ 鉄筋継手 ／ 内装仕上げ ／ 表装 ／ とび ／ 建築大工 ／ 建築板金 ／ 吹付ウレタン断熱<br>その他、建築物の新築、増築、改築若しくは移転、修繕又は模様替に係る作業',
        description4bc: '<strong>〈 想定される関連業務 〉</strong><br>・原材料・部品の調達・搬送<br>・機器・装置・工具等の保守管理<br>・足場の組立て、設備の掘り起こしその他の後工程の準備作業<br>・足場の解体、設備の埋め戻しその他の前工程の片付け作業<br>・清掃・保守管理作業<br>・その他、主たる業務に付随して行う作業',
        description4bd: '<strong>〈 その他特記事項 〉</strong><br> 業務の詳細については、以下の国土交通省のウェブサイト中「◆業務区分と試験及び技能実習等との対応関係」の「業務区分と建設業許可工事業との対応関係」をご覧ください。',
        description4c: '（ライフライン・設備区分）',
        description4ca: '<strong>〈 分野、区分の概要 〉</strong><br> 指導者の指示・監督を受けながら、電気通信、ガス、水道、電気その他のライフライン・設備の整備・設置、変更又は修理に係る作業等に従事',
        description4cb: '<strong>〈 従事する主な業務 〉</strong><br> 電気通信 ／ 配管 ／ 建築板金 ／ 保温保冷<br>その他、ライフライン・設備の整備・設置、変更又は修理に係る作業',
        description4cc: '<strong>〈 想定される関連業務 〉</strong>・原材料・部品の調達・搬送<br>・機器・装置・工具等の保守管理<br>・足場の組立て、設備の掘り起こしその他の後工程の準備作業<br>・足場の解体、設備の埋め戻しその他の前工程の片付け作業<br>・清掃・保守管理作業<br>・その他、主たる業務に付随して行う作業',
        description4cd: '<strong>〈 その他特記事項 〉</strong><br> 業務の詳細については、以下の国土交通省のウェブサイト中「◆業務区分と試験及び技能実習等との対応関係」の「業務区分と建設業許可工事業との対応関係」をご覧ください。',
        work5: '造船・舶用工業',
        description5a: '（造船区分）',
        description5aa: '<strong>〈 分野、区分の概要 〉</strong><br> 造船（監督者の指示を理解し又は自らの判断により船舶の製造工程の作業に従事）',
        description5ab: '<strong>〈 従事する主な業務 〉</strong><br> 溶接 ／ 塗装 ／ 鉄工 ／ とび ／ 配管 ／ 船舶加工',
        description5ac: '<strong>〈 想定される関連業務 〉</strong><br>・読図作業<br>・作業工程管理<br>・検査（外観、寸法、材質、強度、非破壊、耐圧気密等）<br>・機器・装置・工具の保守管理<br>・機器・装置・運搬機の運転<br>・資材の材料管理・配置<br>・部品・製品の養生<br>・足場の組立て・解体<br>・廃材処理<br>・梱包・出荷<br>・資材・部品・製品の運搬<br>・入出渠<br>・清掃',
        description5ad: '<strong>〈 その他特記事項 〉</strong><br> 業務の詳細については、以下の国土交通省のウェブサイトをご覧ください。',
        description5b: '（舶用機械区分）',
        description5ba: '<strong>〈 分野、区分の概要 〉</strong><br> 舶用機械（監督者の指示を理解し又は自らの判断により舶用機械の製造工程の作業に従事）',
        description5bb: '<strong>〈 従事する主な業務 〉</strong><br> 溶接 ／ 塗装 ／ 鉄工 ／ 仕上げ ／ 機械加工 ／ 配管 ／ 鋳造 ／ 金属プレス加工 ／強化プラスチック成形 ／ 機械保全 ／ 船用機械加工',
        description5bc: '<strong>〈 想定される関連業務 〉</strong><br>・読図作業<br>・作業工程管理<br>・検査（外観、寸法、材質、強度、非破壊、耐圧気密等）<br>・機器・装置・工具の保守管理<br>・機器・装置・運搬機の運転<br>・資材の材料管理・配置<br>・部品・製品の養生<br>・足場の組立て・解体<br>・廃材処理<br>・梱包・出荷<br>・資材・部品・製品の運搬<br>・入出渠<br>・清掃',
        description5bd: '<strong>〈 その他特記事項 〉</strong><br> 業務の詳細については、以下の国土交通省のウェブサイトをご覧ください。',
        description5c: '（舶用電気電子機器区分）',
        description5ca: '<strong>〈 分野、区分の概要 〉</strong><br> 舶用電気電子機器（監督者の指示を理解し又は自らの判断により舶用電気電子機器の製造工程の作業に従事）',
        description5cb: '<strong>〈 従事する主な業務 〉</strong><br> 機械加工 ／ 電気機器組立て ／ 金属プレス加工 ／ 電子機器組み立て ／プリント配線板製造 ／ 配管 ／ 機器保全 ／ 船用電気電子機器加工　',
        description5cc: '<strong>〈 想定される関連業務 〉</strong><br>・読図作業<br>・作業工程管理<br>・検査（外観、寸法、材質、強度、非破壊、耐圧気密等）<br>・機器・装置・工具の保守管理<br>・機器・装置・運搬機の運転<br>・資材の材料管理・配置<br>・部品・製品の養生<br>・足場の組立て・解体<br>・廃材処理<br>・梱包・出荷<br>・資材・部品・製品の運搬<br>・入出渠<br>・清掃',
        description5cd: '<strong>〈 その他特記事項 〉</strong><br> 業務の詳細については、以下の国土交通省のウェブサイトをご覧ください。',
        work6: '自動車整備',
        description6a: '<strong>〈 分野、区分の概要 〉</strong><br> 自動車の日常点検整備、定期点検整備、特定整備、特定整備に付随する業務',
        description6b: '<strong>〈 従事する主な業務 〉</strong><br> 自動車の日常点検整備、定期点検整備、特定整備、特定整備に付随する業務（電子制御装置の整備や鈑金塗装など）の基礎的な業務',
        description6c: '<strong>〈 想定される関連業務 〉</strong><br>・整備内容の説明及び関連部品の販売<br>・部品番号検索・部内発注作業<br>・ナビ・ＥＴＣ等の電装品の取付作業<br>・洗車作業<br>・下廻り塗装作業<br>・車内清掃作業<br>・構内清掃作業<br>・部品等運搬作業<br>・設備機器等清掃作業',
        work7: '航空',
        description7a: '（空港グランドハンドリング区分）',
        description7aa: '<strong>〈 分野、区分の概要 〉</strong><br> 航空機の地上走行支援業務、手荷物・貨物取扱業務等',
        description7ab: '<strong>〈 従事する主な業務 〉</strong><br> 指導者やチームリーダーの下に行う<br>・航空機地上走行支援業務<br>・手荷物・貨物取扱業務<br>・手荷物・貨物の航空機搭降載業務<br>・航空機内外の清掃整備業務',
        description7ac: '<strong>〈 想定される関連業務 〉</strong><br>・事務作業<br>・作業場所の整理整頓や清掃<br>・積雪時における作業場所の除雪',
        description7b: '（航空機整備区分）',
        description7ba: '<strong>〈 分野、区分の概要 〉</strong><br> 航空機の機体、装備品等の整備業務等',
        description7bb: '<strong>〈 従事する主な業務 〉</strong><br> 国家資格整備士等の指導・監督の下、機体や装備品等の整備業務のうち基礎的な作業（簡単な点検や交換作業等）<br>・運航整備（空港に到着した航空機に対して、次のフライトまでの間に行う整備）<br>・機体整備（通常1～1年半毎に実施する、約1～2週間にわたり機体の隅々まで行う整備）<br>・装備品・原動機整備（航空機から取り下ろされた脚部や動翼、 飛行・操縦に用いられる計器類等及びエンジンの整備）',
        description7bc: '<strong>〈 想定される関連業務 〉</strong><br>・事務作業<br>・作業場所の整理整頓や清掃<br>・積雪時における作業場所の除雪',
        work8: '宿泊',
        description8a: '<strong>〈 分野、区分の概要 〉</strong><br> 旅館やホテルにおけるフロント、企画・広報、接客及びレストランサービス等の宿泊サービスの提供業務',
        description8b: '<strong>〈 従事する主な業務 〉</strong><br> ・フロント業務（チェックイン/アウト、周辺の観光地情報の案内、ホテル発着ツアーの手配　等）<br>・企画・広報業務（キャンペーン・特別プランの立案、館内案内チラシの作成、HP、SNS等による情報発信　等）<br>・接客業務（旅館やホテル内での案内、宿泊客からの問い合わせ対応 等）<br>・レストランサービス業務（注文への応対やサービス（配膳・片付け）、料理の下ごしらえ・盛りつけ等の業務　等）',
        description8c: '<strong>〈 想定される関連業務 〉</strong><br> 旅館やホテル内における販売、備品の点検・交換等',
        work9: '自動車運送業',
        description9a: '（バス運転者区分）',
        description9aa: '<strong>〈 分野、区分の概要 〉</strong><br> 運行管理者等の指導・監督の下、一般乗合旅客自動車運送事業、一般貸切旅客自動車運送事業又は特定旅客自動車運送事業における運行前後の車両点検、安全な旅客の輸送、乗務記録の作成や乗客対応等に従事',
        description9ab: '<strong>〈 従事する主な業務 〉</strong><br> ・運行業務（運行前後の車両点検、安全な旅客の輸送、乗務記録の作成等）<br>・接遇業務（乗客対応等）',
        description9ac: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br>関連業務に当たり得るものとして、次が想定される。<br>・車内清掃作業<br>・営業所内清掃作業<br>・運賃精算、管理<br>・その他、主たる業務に付随して行う作業<br>※専ら関連業務に従事することは認められない。',
        description9b: '（タクシー運転者区分）',
        description9ba: '<strong>〈 分野、区分の概要 〉</strong><br> 運行管理者等の指導・監督の下、一般乗用旅客自動車運送事業における運行前後の車両点検、安全な旅客の輸送、乗務記録の作成や乗客対応等に従事',
        description9bb: '<strong>〈 従事する主な業務 〉</strong><br> ・運行業務（運行前後の車両点検、安全な旅客の輸送、乗務記録の作成等）<br>・接遇業務（乗客対応等）',
        description9bc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br>関連業務に当たり得るものとして、次が想定される。<br>・車内清掃作業<br>・営業所内清掃作業<br>・運賃精算、管理<br>・その他、主たる業務に付随して行う作業<br>※専ら関連業務に従事することは認められない。',
        description9c: '（トラック運転者区分）',
        description9ca: '<strong>〈 分野、区分の概要 〉</strong><br> 運行管理者等の指導・監督の下、貨物自動車運送事業における運行前後の車両点検、安全な貨物の輸送、乗務記録の作成や荷崩れを起こさない貨物の積付け等に従事',
        description9cb: '<strong>〈 従事する主な業務 〉</strong><br> ・運行業務（運行前後の車両点検、安全な旅客の輸送、乗務記録の作成等）<br>・接遇業務（乗客対応等）',
        description9cc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br>関連業務に当たり得るものとして、次が想定される。<br>・車内清掃作業<br>・営業所内清掃作業<br>・運賃精算、管理<br>・その他、主たる業務に付随して行う作業<br>※専ら関連業務に従事することは認められない。',
        work10: '鉄道',
        description10a: '（軌道整備区分）',
        description10aa: '<strong>〈 分野、区分の概要 〉</strong><br> 軌道整備（軌道等の新設、改良、修繕に係る作業・検査業務等）',
        description10ab: '<strong>〈 従事する主な業務 〉</strong><br> 以下を例とする軌道等の新設、改良、修繕に係る作業・検査業務が対象となる。<br>・軌道検測作業（高低、通り等軌道の変位を測定する作業）<br>・レール交換作業（新旧レール交換 ／ 付帯作業（吊り上げ作業等））<br>・まくらぎ交換作業（新旧まくらぎ交換 ／ 付帯作業（道床掘削作業等））<br>・バラストを取り扱う作業（バラスト掘削及び埋戻し ／ 道床形状の形成 ／ つき固めや通り整正に伴う作業等）<br>・保安設備を取り扱う作業等（脱線防止ガード等保安設備の取り付け（交換・撤去・復旧等） ／ 付帯作業（締結装置の緊張・緩解作業等））',
        description10ac: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・事務作業<br>・作業場所の整理整頓や清掃',
        description10b: '（電気設備整備区分）',
        description10ba: '<strong>〈 分野、区分の概要 〉</strong><br> 電気設備整備（電路設備、変電所等設備、電気機器等設備、信号保安設備、保安通信設備、踏切保安設備等の新設、改良、修繕に係る作業・検査業務等）',
        description10bb: '<strong>〈 従事する主な業務 〉</strong><br> 以下の設備の新設、改良、修繕に係る作業、検査業務等が対象となる。<br>・電路設備（電車線、送電線、配電線等）<br>・変電所等設備（遮断装置、変圧器、整流器、避雷器、保護装置、接地装置、消火設備等）<br>・電気機器等設備（配電盤、開閉器、電源装置、照明設備、電気掲示器、電気融雪器等）<br>・信号保安設備（信号装置、転てつ装置、連動装置、列車検知装置、自動列車停止装置等）<br>・保安通信設備（交換装置、搬送装置、無線装置、端末装置、通信線等）<br>・踏切保安設備（踏切遮断機、踏切警報機、踏切警報時間制御装置、踏切支障報知装置、障害物検知装置等）<br>※上記設備の支持物、ケーブル、管路、配線等を含む',
        description10bc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・事務作業<br>・作業場所の整理整頓や清掃',
        description10c: '（車両整備区分）',
        description10ca: '<strong>〈 分野、区分の概要 〉</strong><br> 車両整備（鉄道車両の整備業務等）',
        description10cb: '<strong>〈 従事する主な業務 〉</strong><br> 以下を例とする業務等が対象となる。<br>・列車検査、定期検査、臨時検査（空調装置、集電装置、走行装置、ブレーキ装置、空気装置、電気装置、動力発生装置、保安装置、車体、乗務員室・客室に関わる装置、連結装置等や車両部品の検査、修繕等（解ぎ装等作業や消耗品の補充を含む））<br>・構内入換（車両基地等での車両の入換や誘導等）<br>・駅派出対応（駅等における車両の検査・修繕等）<br>・改造工事（車両の改造や改良工事等）<br>・定期・臨時清掃業務（車両基地における車両の清掃等）<br>・在庫・予備品管理、工場設備取扱い<br>・上記に関する材料や部品、装置等の管理及び設備の操作・管理',
        description10cc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・事務作業<br>・作業場所の整理整頓や清掃',
        description10d: '（車両製造区分）',
        description10da: '<strong>〈 分野、区分の概要 〉</strong><br> 車両製造（鉄道車両、鉄道車両部品等の製造業務等）',
        description10db: '<strong>〈 従事する主な業務 〉</strong><br> 以下を例とする業務等が対象となる。<br>・素材加工（シートモケット加工 ／ 台車枠、構体部品加工等）<br>・部品組立て作業（輪軸（駆動装置）、配電盤等電気機器組立て ／ ドア、窓、ほろ、シート等内装設備品組立て等）<br>・構体組立て（台枠、屋根構体、側構体及び妻構体組立て ／ 構体（六面体）組立て等）<br>・塗装<br>・溶接<br>・ぎ装（機器取付け、配線、配管 ／ ドア、窓、天井、トイレ設備等内装部品取付け）<br>・台車枠製造<br>・台車組立て<br>・電子機器組立て（運転保安装置(ＡＴＣ装置やＡＴＳ装置)、制御装置、モニタ装置等の組立て）<br>・電気機器組立て（継電器等を使用した配電盤等の組立て）<br>・試験・検査（機能検査等）<br>・部品検収・配膳業務（倉庫管理及び部品等運搬等）',
        description10dc: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・事務作業<br>・作業場所の整理整頓や清掃',
        description10e: '（運輸係員区分）',
        description10ea: '<strong>〈 分野、区分の概要 〉</strong><br> 運輸係員（駅係員、車掌、運転士等）',
        description10eb: '<strong>〈 従事する主な業務 〉</strong><br> 以下を例とする業務等が対象となる。<br>・ポイント操作（列車等の進路を決めるポイント操作、列車の進路に合わせた適正な鉄道信号の現示又は表示）<br>・入換え合図（列車等の転線、連結・分割等を行うための係員への合図）<br>・駅設備管理・取扱業務（駅の券売機・改札機等の管理、操作 ／ 設備故障時の一次修理対応）<br>・旅客案内・貨物取扱業務（通常時・異常時のホーム上安全確認や旅客案内 ／ 振替輸送時等の旅客案内 ／ 貨物の受付、一時留置場所・積載列車等の指定等）<br>・運行管理業務（列車ダイヤと列車運行の確認・管理 ／ 異常時における運休や増発の列車指定）<br>・車掌業務（列車内の旅客案内、運転士への合図 ／ 事故防止等に必要な安全確認 ／ 事故発生時の列車防護等による事故拡大防止等の対処を行う ／ 異常発生時等の避難誘導等）<br>・運転士業務（列車の運転には動力車操縦者運転免許要す）（列車等の運転（ワンマン列車運転の場合は車掌業務も兼任））',
        description10ec: '<strong>〈 想定される関連業務 〉</strong><br> 当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次が想定される。<br>・事務作業<br>・作業場所の整理整頓や清掃',
        work11: '農業',
        description11a: '（耕種農業区分）',
        description11aa: '<strong>〈 分野、区分の概要 〉</strong><br> 栽培管理、農産物の集出荷・選別等の農作業',
        description11ab: '<strong>〈 従事する主な業務 〉</strong><br>・各作物に応じた土壌づくり<br>・施肥作業<br>・種子、苗木の取扱い<br>・資材、装置の取扱い<br>・栽培に関する作業<br>・安全衛生業務　等',
        description11ac: '<strong>〈 想定される関連業務 〉</strong><br>・特定技能所属機関（労働者派遣形態の場合は派遣先事業者）が生産した農畜産物を原料又は材料の一部として使用する製造又は加工の作業<br>・特定技能所属機関（労働者派遣形態の場合は派遣先事業者）による農畜産物の生産に伴う副産物（稲わら、家畜排泄物等）を原料又は材料の一部として使用する製造又は加工の作業<br>・農畜産物（特定技能所属機関（労働者派遣形態の場合は派遣先事業者）が生産した農畜産物が含まれる場合に限る。）の運搬、陳列又は販売の作業<br>・農畜産物を原料又は材料として製造され、又は加工された物（特定技能所属機関（労働者派遣形態の場合は派遣先事業者）が生産した農畜産物を原料又は材料の一部として使用し、製造され、又は加工された物が含まれる場合に限る。）の運搬、陳列又は販売の作業<br>・農畜産物の生産に伴う副産物を原料又は材料として製造され、又は加工された物（特定技能所属機関（労働者派遣形態の場合は派遣先事業者）による農畜産物の生産に伴う副産物を原料又は材料の一部として使用し、製造され、又は加工された物（たい肥等の肥料、飼料等）が含まれる場合に限る。）の運搬、陳列又は販売の作業<br>・その他特定技能所属機関（労働者派遣形態の場合は派遣先事業者）で耕種農業又は畜産農業の業務に従事する日本人が通常従事している作業（畜産農業と耕種農業を複合経営している特定技能所属機関（労働者派遣形態の場合は派遣先事業者）において畜産農業の技能を有する特定技能外国人が耕種農業の作業に従事する場合、冬場の除雪作業に従事する場合等）',
        description11b: '（畜産農業区分）',
        description11ba: '<strong>〈 分野、区分の概要 〉</strong><br> 飼養管理、畜産物の集出荷・選別等の農作業',
        description11bb: '<strong>〈 従事する主な業務 〉</strong><br>・各畜種に応じた器具の取扱い<br>・個体の取扱い、観察<br>・飼養管理<br>・生産物の取扱い<br>・安全衛生業務　等',
        description11bc: '<strong>〈 想定される関連業務 〉</strong><br>・特定技能所属機関（労働者派遣形態の場合は派遣先事業者）が生産した農畜産物を原料又は材料の一部として使用する製造又は加工の作業<br>・特定技能所属機関（労働者派遣形態の場合は派遣先事業者）による農畜産物の生産に伴う副産物（稲わら、家畜排泄物等）を原料又は材料の一部として使用する製造又は加工の作業<br>・農畜産物（特定技能所属機関（労働者派遣形態の場合は派遣先事業者）が生産した農畜産物が含まれる場合に限る。）の運搬、陳列又は販売の作業<br>・農畜産物を原料又は材料として製造され、又は加工された物（特定技能所属機関（労働者派遣形態の場合は派遣先事業者）が生産した農畜産物を原料又は材料の一部として使用し、製造され、又は加工された物が含まれる場合に限る。）の運搬、陳列又は販売の作業<br>・農畜産物の生産に伴う副産物を原料又は材料として製造され、又は加工された物（特定技能所属機関（労働者派遣形態の場合は派遣先事業者）による農畜産物の生産に伴う副産物を原料又は材料の一部として使用し、製造され、又は加工された物（たい肥等の肥料、飼料等）が含まれる場合に限る。）の運搬、陳列又は販売の作業<br>・その他特定技能所属機関（労働者派遣形態の場合は派遣先事業者）で耕種農業又は畜産農業の業務に従事する日本人が通常従事している作業（畜産農業と耕種農業を複合経営している特定技能所属機関（労働者派遣形態の場合は派遣先事業者）において畜産農業の技能を有する特定技能外国人が耕種農業の作業に従事する場合、冬場の除雪作業に従事する場合等）',
        work12: '漁業',
        description12a: '（漁業区分）',
        description12aa: '<strong>〈 分野、区分の概要 〉</strong><br> 漁具の製作・補修、水産動植物の探索、漁具・漁労機械の操作、水産動植物の採捕、漁獲物の処理・保蔵、安全衛生の確保等',
        description12ab: '<strong>〈 従事する主な業務 〉</strong><br>・釣りによる方法を主とした魚介類の捕獲(延縄漁、カツオ一本釣り漁、イカ釣り漁　等)<br>・網やカゴによる方法を主とした魚介類の捕獲(定置網漁、まき網漁、曳網漁　等)<br>・漁具（網、カゴ等）の修理作業<br>・ソナーや魚群探知機による魚群の探索<br>・漁に使用する網・縄を巻き上げる機械(ネット・ラインホーラー)、自動イカ釣り機等の機械操作<br>・漁獲物の選別、函詰め、冷凍作業、下処理<br>・漁港での漁獲物や漁具等の荷揚げ作業　等',
        description12ac: '<strong>〈 想定される関連業務 〉</strong><br>・漁具・漁労機械の点検・換装<br>・船体の補修・清掃<br>・魚倉、漁具保管庫、番屋の清掃<br>・漁船への餌、氷、燃油、食材、日用品その他の操業・生活資材の仕込み・積込み<br>・出漁に係る炊事・賄い<br>・採捕した水産動植物の生簀における畜養その他付随的な養殖<br>・自家生産物の運搬・陳列・販売<br>・自家生産物又は当該生産に伴う副産物を原料又は材料の一部として使用する製造・加工及び当該製造物・加工物の運搬・陳列・販売<br>・魚市場・陸揚港での漁獲物の選別・仕分け<br>・体験型漁業の際に乗客が行う水産動植物の採捕の補助<br>・社内外における研修',
        description12b: '（養殖業区分）',
        description12ba: '<strong>〈 分野、区分の概要 〉</strong><br> 養殖資材の製作・補修・管理、養殖水産動植物の育成管理、養殖水産動植物の収獲（穫）・処理、安全衛生の確保等',
        description12bb: '<strong>〈 従事する主な業務 〉</strong><br>・魚類や貝類、藻類などの育成<br>・養殖魚の給餌、死んだ魚や残餌等の除去<br>・養殖貝類の付着物の清掃<br>・養殖水産動植物の収獲（穫）、魚市場や陸揚港への運搬作業<br>・養殖貝類の殻剥き<br>・養殖池や網の清掃、水質等の管理<br>・養殖筏の製作、補修<br>・養殖水産動植物の種苗の生産、採捕　等',
        description12bc: '<strong>〈 想定される関連業務 〉</strong><br>・漁具・漁労機械の点検・換装<br>・船体の補修・清掃<br>・魚倉、漁具保管庫・番屋の清掃<br>・漁船への餌、氷、燃油、食材、日用品その他の操業・生活資材の仕込み・積込み<br>・養殖用の機械・設備・器工具等の清掃・消毒・管理・保守<br>・鳥獣に対する駆除、追払、防護ネット・テグス張り等の養殖場における食害防止<br>・養殖水産動植物の餌となる水産動植物や養殖用稚魚の採捕その他付随的な漁業<br>・自家生産物の運搬・陳列・販売<br>・自家生産物又は当該生産に伴う副産物を原料又は材料の一部として使用する製造・加工及び当該製造物・加工物の運搬・陳列・販売<br>・魚市場・陸揚港での漁獲物の選別・仕分け<br>・体験型漁業の際に乗客が行う水産動植物の採捕の補助<br>・社内外における研修',
        work13: '飲食料品製造業',
        description13a: '<strong>〈 分野、区分の概要 〉</strong><br> 飲食料品（酒類を除く。）の製造・加工、安全衛生の確保',
        description13b: '<strong>〈 従事する主な業務 〉</strong><br>・原料の処理、加熱、殺菌、成形、乾燥などの、生産に関わる一連の作業など<br>・業務で使う機械の安全確認や、作業者の衛生管理などの、業務上の安全衛生と食品衛生を守るための業務',
        description13c: '<strong>〈 想定される関連業務 〉</strong><br>・原料の調達・受入れ<br>・製品の納品<br>・清掃<br>・事業所の管理の作業',
        work14: '外食業',
        description14a: '<strong>〈 分野、区分の概要 〉</strong><br> 飲食物調理、接客、店舗管理',
        description14b: '<strong>〈 従事する主な業務 〉</strong><br>・飲食物調理（客に提供する飲食料品の調理、調製、製造を行うもの）<br> 例：食材仕込み、加熱調理、非加熱調理、調味、盛付け、飲食料品の調製等<br>・接客（客に飲食料品を提供するために必要な飲食物調理以外の業務を行うもの）<br> 例：席への案内、メニュー提案、注文伺い、配膳、下膳、カトラリーセッティング、代金受取り、商品セッティング、商品の受渡し、食器・容器等の回収、予約受付、客席のセッティング、苦情等への対応、給食事業所における提供先との連絡・調整 等<br>・店舗管理（店舗の運営に必要となる上記２業務以外のもの）<br> 例：店舗内の衛生管理全般、従業員のシフト管理、求人・雇用に関する事務、従業員の指導・研修に関する事務、予約客情報・顧客情報の管理、レジ・券売機管理、会計事務管理、社内本部・取引事業者・行政等との連絡調整、各種機器・設備のメンテナンス、食材・消耗品・備品の補充、発注、検品又は数量管理、メニューの企画・開発、メニューブック・POP 広告等の作成、宣伝・広告の企画、店舗内外・全体の環境整備、店内オペレーションの改善、作業マニュアルの作成・改訂等',
        description14c: '<strong>〈 想定される関連業務 〉</strong><br>・店舗において原材料として使用する農林水産物の生産<br>・客に提供する調理品等以外の物品の販売',
        work15: '林業',
        description15a: '<strong>〈 分野、区分の概要 〉</strong><br> 森林において樹木を育てて丸太を生産し、苗木を植える等の作業に従事',
        description15b: '<strong>〈 従事する主な業務 〉</strong><br>・苗木を植え、樹木を育てる作業<br>・丸太を生産する作業 等',
        description15c: '<strong>〈 想定される関連業務 〉</strong><br>当該業務に従事する日本人が通常従事することとなる関連業務に付随的に従事することは差し支えない。<br> 関連業務に当たり得るものとして、次のものなどが想定される。<br>・生産した丸太を使用して行う加工等の作業<br>・丸太の生産に伴う副産物（樹皮、つる等）を使用して行う製造等の作業<br>・機器・装置・工具等の保守管理<br>・資材の管理・運搬<br>・事業所等の清掃作業',
        work16: '木材産業',
        description16a: '<strong>〈 分野、区分の概要 〉</strong><br> 木材・木製品の製造・加工<br>（家具や建具などの装備品を除く。）',
        description16b: '<strong>〈 従事する主な業務 〉</strong><br> 製材／単板（ベニヤ）製造／木材チップ製造／合板製造／集成材製造／プレカット加工／銘木製造／床板製造',
        description16c: '<strong>〈 想定される関連業務 〉</strong><br>・原材料（原木・資材）の調達・受入れ作業<br>・製品の検査<br>・製品の出荷作業（運搬・梱包・積込み）<br>・作業場所の整理整頓や清掃',
      }
    }
  },
};

const i18n = new VueI18n({
  locale: 'ja', // 设置默认语言
  messages,
});

export default i18n;
